// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/tokens.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Company Dashboard design tokens (CSS custom properties + .glass / .fab utilities).
 * Mirrors the \`dashboard.*\` Tailwind tokens added in \`tailwind.config.js\`.
 * Source: .kiro/specs/company-dashboard-internal-pages/design.md
 */

*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
 ! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
 */

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, Fira Code, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/

dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/

:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */

[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}

* {
    box-sizing: border-box;
  }

html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-rendering: optimizeLegibility;
    overflow-x: hidden;
    background-color: #f8fafc;
  }

body{
  font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
  font-size: 0.875rem;
  line-height: 1.375rem;
  letter-spacing: 0;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

html.dark [data-testid="create-job-flow"] h2body {
  color: #f5f5fa;
}

html.dark body {
  color: #f5f5fa;
}

body {
  color: #FFFFFF;
    font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11';
    line-height: 1.5;
    min-height: 100%;
    background-color: #f8fafc;
}

#root {
    min-height: 100%;
    background-color: inherit;
  }

/* ─── Dark mode base ────────────────────────────────────────────────
     A single body-level override gives every screen — even ones we
     haven't explicitly dark-styled yet — a readable dark background.
     Per-component \`dark:\` variants then layer on top. */

html.dark {
    color-scheme: dark;
  }

html.dark body{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
    background-color: #0b0b15;
}

html.dark #root {
    background-color: #0b0b15;
  }

/* Subtle dark scrollbars (WebKit). */

html.dark *::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.12);
  }

html.dark *::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }

/* Native form controls. */

html.dark input,
  html.dark textarea,
  html.dark select {
    color-scheme: dark;
  }

/* Typography hierarchy */

h1{
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

html.dark h1 {
  color: #f5f5fa;
}

h1 {
  color: #FFFFFF;
}

h2{
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

html.dark h2 {
  color: #f5f5fa;
}

h2 {
  color: #FFFFFF;
}

h3{
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: -0.02em;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

html.dark h3 {
  color: #f5f5fa;
}

h3 {
  color: #FFFFFF;
}

h4{
  font-size: 1.125rem;
  line-height: 1.75rem;
  letter-spacing: -0.015em;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

html.dark h4 {
  color: #ececf3;
}

html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) h4,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero])h4 {
  color: #1f2937;
}

h4 {
  color: #FFFFFF;
}

h5{
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: -0.01em;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

html.dark h5 {
  color: #ececf3;
}

html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) h5,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero])h5 {
  color: #1f2937;
}

h5 {
  color: #FFFFFF;
}

h6{
  font-size: 0.875rem;
  line-height: 1.375rem;
  letter-spacing: 0;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

html.dark [data-testid="create-job-flow"] h2h6 {
  color: #f5f5fa;
}

html.dark h6 {
  color: #d6d6e0;
}


html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) h6,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero])h6 {
  color: #1f2937;
}

h6 {
  color: #A1A8B8;
}

p{
  font-size: 0.875rem;
  line-height: 1.375rem;
  letter-spacing: 0;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

html.dark [data-testid="create-job-flow"] h2p {
  color: #f5f5fa;
}

html.dark p {
  color: #c2c2cf;
}


html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) p,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero])p {
  color: #1f2937;
}

html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) p,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero])p {
  color: #4b5563;
}

p {
  color: #A1A8B8;
}

/* Focus styles */

:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(59 130 246 / 0.4);
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
}

/* Selection */

::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 640px){

  .\\!container{
    max-width: 640px !important;
  }

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .\\!container{
    max-width: 768px !important;
  }

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .\\!container{
    max-width: 1024px !important;
  }

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .\\!container{
    max-width: 1280px !important;
  }

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1536px){

  .\\!container{
    max-width: 1536px !important;
  }

  .container{
    max-width: 1536px;
  }
}
/* ── Cards ── */
.\\!card{
  border-radius: 12px;
  border-width: 1px;
  border-color: rgb(229 231 235 / 0.6);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.02);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
html.dark .\\!card {
  background-color: #161628;
}

html.dark .\\!card {
  border-color: rgba(255, 255, 255, 0.08);
}
.\\!card {
  background-color: #171A23;
  border-color: #2A3042;
}
.card{
  border-radius: 12px;
  border-width: 1px;
  border-color: rgb(229 231 235 / 0.6);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.02);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
html.dark .card {
  background-color: #161628;
}

html.dark .card {
  border-color: rgba(255, 255, 255, 0.08);
}
.card {
  background-color: #171A23;
  border-color: #2A3042;
}
.\\!card:hover{
  --tw-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 12px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.card:hover{
  --tw-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 12px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.card-body{
  padding: 20px;
}
/* ── Brand wordmark (SNAP + SULE) ── */
.lp-brand-text {
    display: inline-flex;
    align-items: baseline;
    font-weight: 700;
    letter-spacing: -0.02em;
    line-height: 1;
    color: #fff;
  }
.lp-brand-text-snap {
    color: inherit;
  }
.lp-brand-text-sule {
    color: #2563eb;
  }
/* ── Buttons ── */
.btn{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  font-weight: 500;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.btn:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.btn:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-offset-width: 2px;
}
.btn:active{
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.btn:disabled{
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.btn-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  color: #FFFFFF;
}
.btn-primary:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.35);
  --tw-ring-color: rgba(37, 99, 235, 0.45);
  --tw-ring-offset-color: #0F1117;
}
.btn-primary:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 8px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-primary:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}
.btn-secondary{
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
  --tw-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
html.dark .btn-secondary {
  background-color: #161628;
  color: #d6d6e0;
}

html.dark .btn-secondary:hover {
  background-color: rgba(255, 255, 255, 0.06);
}

html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) .btn-secondary,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]).btn-secondary {
  color: #1f2937;
}
.btn-secondary {
  background-color: #171A23;
  border-color: #2A3042;
}
.btn-secondary:hover {
  background-color: #1E2230;
}
.btn-secondary {
  border-color: #2A3042;
  color: #A1A8B8;
}
.btn-secondary:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.btn-secondary:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(156 163 175 / var(--tw-ring-opacity, 1));
}
/* ── Inputs ── */
.input{
  width: 100%;
  border-radius: 10px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0;
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.input::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.input{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
html.dark .input {
  background-color: #161628;
  color: #f5f5fa;
}

html.dark .input::placeholder {
  color: rgba(255, 255, 255, 0.45);
}
.input {
  background-color: #171A23;
  border-color: #2A3042;
  color: #FFFFFF;
}
.input:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}
.input:focus{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
/* ── Route transitions — disabled opacity fade (caused white flash) ── */
/* Thin progress bar shown on slow chunk loads (>150ms) */
@keyframes routeProgressSlide {
    0%   { background-position: -40% 0; }
    100% { background-position: 140% 0; }
  }
/* ── Inline add / remove buttons (used in array editors) ── */
.btn-add{
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 8px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
  padding-left: 12px;
  padding-right: 12px;
  padding-top: 6px;
  padding-bottom: 6px;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.01em;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  border-color: #2A3042;
}
.btn-add:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.btn-remove{
  grid-column: span 1 / span 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 8px;
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
html.dark .btn-remove {
  color: #7a7a8a;
}
.btn-remove {
  color: #6B7280;
}
.btn-remove:hover{
  background-color: rgba(37, 99, 235, 0.10);
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
/* ── Badges ── */
.badge{
  display: inline-flex;
  align-items: center;
  border-radius: 8px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 2px;
  padding-bottom: 2px;
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.01em;
  font-weight: 500;
}
/* ── Avatar ── */
.avatar{
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
  color: #FFFFFF;
}
/* ── Layout ── */
/* ── Divider ── */
.divider{
  margin-top: 16px;
  margin-bottom: 16px;
  border-top-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
html.dark .divider {
  border-color: rgba(255, 255, 255, 0.06);
}
/* ── Link ── */
.\\!link{
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.\\!link:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.link{
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.link:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
/* ── Skeleton ── */
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.skeleton{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  border-radius: 8px;
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
/* ── Scrollbar ── */
/* ── Glass ── */
.glass{
  border-width: 1px;
  border-color: rgb(255 255 255 / 0.2);
  background-color: rgb(255 255 255 / 0.8);
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  background-color: #171A23;
  border-color: #2A3042;
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.visible{
  visibility: visible;
}
.collapse{
  visibility: collapse;
}
.static{
  position: static;
}
.\\!fixed{
  position: fixed !important;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.-inset-2{
  inset: -8px;
}
.-inset-4{
  inset: -16px;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-x-6{
  left: 24px;
  right: 24px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5{
  bottom: -2px;
}
.-bottom-1{
  bottom: -4px;
}
.-bottom-10{
  bottom: -40px;
}
.-bottom-12{
  bottom: -48px;
}
.-bottom-16{
  bottom: -64px;
}
.-bottom-2{
  bottom: -8px;
}
.-bottom-20{
  bottom: -80px;
}
.-bottom-4{
  bottom: -16px;
}
.-bottom-6{
  bottom: -24px;
}
.-bottom-8{
  bottom: -32px;
}
.-bottom-px{
  bottom: -1px;
}
.-left-1{
  left: -4px;
}
.-left-16{
  left: -64px;
}
.-left-2{
  left: -8px;
}
.-left-20{
  left: -80px;
}
.-left-40{
  left: -160px;
}
.-left-6{
  left: -24px;
}
.-left-\\[22px\\]{
  left: -22px;
}
.-right-0\\.5{
  right: -2px;
}
.-right-1{
  right: -4px;
}
.-right-10{
  right: -40px;
}
.-right-12{
  right: -48px;
}
.-right-2{
  right: -8px;
}
.-right-6{
  right: -24px;
}
.-right-8{
  right: -32px;
}
.-top-0\\.5{
  top: -2px;
}
.-top-1{
  top: -4px;
}
.-top-10{
  top: -40px;
}
.-top-12{
  top: -48px;
}
.-top-16{
  top: -64px;
}
.-top-2{
  top: -8px;
}
.-top-20{
  top: -80px;
}
.-top-3{
  top: -12px;
}
.-top-5{
  top: -20px;
}
.-top-6{
  top: -24px;
}
.-top-8{
  top: -32px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-1{
  bottom: 4px;
}
.bottom-1\\.5{
  bottom: 6px;
}
.bottom-12{
  bottom: 48px;
}
.bottom-16{
  bottom: 64px;
}
.bottom-2{
  bottom: 8px;
}
.bottom-20{
  bottom: 80px;
}
.bottom-3{
  bottom: 12px;
}
.bottom-32{
  bottom: 128px;
}
.bottom-4{
  bottom: 16px;
}
.bottom-40{
  bottom: 160px;
}
.bottom-5{
  bottom: 20px;
}
.bottom-6{
  bottom: 24px;
}
.bottom-8{
  bottom: 32px;
}
.bottom-\\[18\\%\\]{
  bottom: 18%;
}
.bottom-\\[28\\%\\]{
  bottom: 28%;
}
.bottom-\\[36\\%\\]{
  bottom: 36%;
}
.bottom-full{
  bottom: 100%;
}
.left-0{
  left: 0px;
}
.left-0\\.5{
  left: 2px;
}
.left-1{
  left: 4px;
}
.left-1\\.5{
  left: 6px;
}
.left-1\\/2{
  left: 50%;
}
.left-12{
  left: 48px;
}
.left-2{
  left: 8px;
}
.left-2\\.5{
  left: 10px;
}
.left-20{
  left: 80px;
}
.left-24{
  left: 96px;
}
.left-3{
  left: 12px;
}
.left-3\\.5{
  left: 14px;
}
.left-32{
  left: 128px;
}
.left-4{
  left: 16px;
}
.left-44{
  left: 176px;
}
.left-5{
  left: 20px;
}
.left-6{
  left: 24px;
}
.left-8{
  left: 32px;
}
.left-\\[11px\\]{
  left: 11px;
}
.left-\\[18px\\]{
  left: 18px;
}
.left-\\[22\\%\\]{
  left: 22%;
}
.left-\\[30\\%\\]{
  left: 30%;
}
.left-\\[40\\%\\]{
  left: 40%;
}
.left-\\[42\\%\\]{
  left: 42%;
}
.left-\\[55\\%\\]{
  left: 55%;
}
.left-\\[60\\%\\]{
  left: 60%;
}
.left-\\[8\\%\\]{
  left: 8%;
}
.left-\\[calc\\(50\\%\\+18px\\)\\]{
  left: calc(50% + 18px);
}
.right-0{
  right: 0px;
}
.right-1{
  right: 4px;
}
.right-1\\.5{
  right: 6px;
}
.right-1\\/3{
  right: 33.333333%;
}
.right-12{
  right: 48px;
}
.right-16{
  right: 64px;
}
.right-2{
  right: 8px;
}
.right-2\\.5{
  right: 10px;
}
.right-20{
  right: 80px;
}
.right-24{
  right: 96px;
}
.right-3{
  right: 12px;
}
.right-3\\.5{
  right: 14px;
}
.right-32{
  right: 128px;
}
.right-4{
  right: 16px;
}
.right-40{
  right: 160px;
}
.right-48{
  right: 192px;
}
.right-5{
  right: 20px;
}
.right-6{
  right: 24px;
}
.right-8{
  right: 32px;
}
.right-\\[12\\%\\]{
  right: 12%;
}
.right-\\[22\\%\\]{
  right: 22%;
}
.right-\\[24\\%\\]{
  right: 24%;
}
.right-\\[28\\%\\]{
  right: 28%;
}
.right-\\[30\\%\\]{
  right: 30%;
}
.right-\\[35\\%\\]{
  right: 35%;
}
.right-\\[38\\%\\]{
  right: 38%;
}
.right-\\[calc\\(-50\\%\\+18px\\)\\]{
  right: calc(-50% + 18px);
}
.top-0{
  top: 0px;
}
.top-0\\.5{
  top: 2px;
}
.top-1{
  top: 4px;
}
.top-1\\.5{
  top: 6px;
}
.top-1\\/2{
  top: 50%;
}
.top-1\\/4{
  top: 25%;
}
.top-10{
  top: 40px;
}
.top-12{
  top: 48px;
}
.top-16{
  top: 64px;
}
.top-2{
  top: 8px;
}
.top-2\\.5{
  top: 10px;
}
.top-20{
  top: 80px;
}
.top-24{
  top: 96px;
}
.top-28{
  top: 112px;
}
.top-3{
  top: 12px;
}
.top-32{
  top: 128px;
}
.top-36{
  top: 144px;
}
.top-4{
  top: 16px;
}
.top-5{
  top: 20px;
}
.top-6{
  top: 24px;
}
.top-8{
  top: 32px;
}
.top-\\[12\\%\\]{
  top: 12%;
}
.top-\\[14px\\]{
  top: 14px;
}
.top-\\[18\\%\\]{
  top: 18%;
}
.top-\\[20px\\]{
  top: 20px;
}
.top-\\[30\\%\\]{
  top: 30%;
}
.top-\\[38\\%\\]{
  top: 38%;
}
.top-\\[42\\%\\]{
  top: 42%;
}
.top-\\[60px\\]{
  top: 60px;
}
.top-\\[76px\\]{
  top: 76px;
}
.top-\\[calc\\(100\\%\\+0\\.375rem\\)\\]{
  top: calc(100% + 0.375rem);
}
.top-full{
  top: 100%;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[100\\]{
  z-index: 100;
}
.z-\\[101\\]{
  z-index: 101;
}
.z-\\[1\\]{
  z-index: 1;
}
.z-\\[5\\]{
  z-index: 5;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[70\\]{
  z-index: 70;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.order-1{
  order: 1;
}
.order-2{
  order: 2;
}
.order-3{
  order: 3;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-6{
  grid-column: span 6 / span 6;
}
.col-span-7{
  grid-column: span 7 / span 7;
}
.col-span-full{
  grid-column: 1 / -1;
}
.-m-1{
  margin: -4px;
}
.m-0{
  margin: 0px;
}
.-mx-1{
  margin-left: -4px;
  margin-right: -4px;
}
.-mx-1\\.5{
  margin-left: -6px;
  margin-right: -6px;
}
.-mx-2{
  margin-left: -8px;
  margin-right: -8px;
}
.-my-1\\.5{
  margin-top: -6px;
  margin-bottom: -6px;
}
.mx-0{
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1{
  margin-left: 4px;
  margin-right: 4px;
}
.mx-1\\.5{
  margin-left: 6px;
  margin-right: 6px;
}
.mx-2{
  margin-left: 8px;
  margin-right: 8px;
}
.mx-3{
  margin-left: 12px;
  margin-right: 12px;
}
.mx-4{
  margin-left: 16px;
  margin-right: 16px;
}
.mx-6{
  margin-left: 24px;
  margin-right: 24px;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-1{
  margin-top: 4px;
  margin-bottom: 4px;
}
.my-2{
  margin-top: 8px;
  margin-bottom: 8px;
}
.my-3{
  margin-top: 12px;
  margin-bottom: 12px;
}
.my-4{
  margin-top: 16px;
  margin-bottom: 16px;
}
.my-8{
  margin-top: 32px;
  margin-bottom: 32px;
}
.-mb-px{
  margin-bottom: -1px;
}
.-ml-1{
  margin-left: -4px;
}
.-ml-1\\.5{
  margin-left: -6px;
}
.-ml-2{
  margin-left: -8px;
}
.-mr-1{
  margin-right: -4px;
}
.-mt-0\\.5{
  margin-top: -2px;
}
.-mt-1{
  margin-top: -4px;
}
.-mt-12{
  margin-top: -48px;
}
.-mt-14{
  margin-top: -56px;
}
.-mt-16{
  margin-top: -64px;
}
.-mt-2{
  margin-top: -8px;
}
.-mt-20{
  margin-top: -80px;
}
.-mt-4{
  margin-top: -16px;
}
.-mt-5{
  margin-top: -20px;
}
.-mt-8{
  margin-top: -32px;
}
.-mt-\\[54px\\]{
  margin-top: -54px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-0\\.5{
  margin-bottom: 2px;
}
.mb-1{
  margin-bottom: 4px;
}
.mb-1\\.5{
  margin-bottom: 6px;
}
.mb-12{
  margin-bottom: 48px;
}
.mb-2{
  margin-bottom: 8px;
}
.mb-2\\.5{
  margin-bottom: 10px;
}
.mb-3{
  margin-bottom: 12px;
}
.mb-4{
  margin-bottom: 16px;
}
.mb-5{
  margin-bottom: 20px;
}
.mb-6{
  margin-bottom: 24px;
}
.mb-8{
  margin-bottom: 32px;
}
.mb-lp-lg{
  margin-bottom: 40px;
}
.mb-lp-md{
  margin-bottom: 24px;
}
.mb-lp-sm{
  margin-bottom: 16px;
}
.mb-lp-xl{
  margin-bottom: 80px;
}
.ml-0\\.5{
  margin-left: 2px;
}
.ml-1{
  margin-left: 4px;
}
.ml-1\\.5{
  margin-left: 6px;
}
.ml-16{
  margin-left: 64px;
}
.ml-2{
  margin-left: 8px;
}
.ml-2\\.5{
  margin-left: 10px;
}
.ml-3{
  margin-left: 12px;
}
.ml-4{
  margin-left: 16px;
}
.ml-5{
  margin-left: 20px;
}
.ml-6{
  margin-left: 24px;
}
.ml-8{
  margin-left: 32px;
}
.ml-\\[50px\\]{
  margin-left: 50px;
}
.ml-auto{
  margin-left: auto;
}
.ml-sidebar-left{
  margin-left: 260px;
}
.mr-0\\.5{
  margin-right: 2px;
}
.mr-1{
  margin-right: 4px;
}
.mr-1\\.5{
  margin-right: 6px;
}
.mr-2{
  margin-right: 8px;
}
.mr-3{
  margin-right: 12px;
}
.mr-4{
  margin-right: 16px;
}
.mt-0{
  margin-top: 0px;
}
.mt-0\\.5{
  margin-top: 2px;
}
.mt-1{
  margin-top: 4px;
}
.mt-1\\.5{
  margin-top: 6px;
}
.mt-12{
  margin-top: 48px;
}
.mt-14{
  margin-top: 56px;
}
.mt-2{
  margin-top: 8px;
}
.mt-2\\.5{
  margin-top: 10px;
}
.mt-3{
  margin-top: 12px;
}
.mt-3\\.5{
  margin-top: 14px;
}
.mt-4{
  margin-top: 16px;
}
.mt-5{
  margin-top: 20px;
}
.mt-6{
  margin-top: 24px;
}
.mt-7{
  margin-top: 28px;
}
.mt-8{
  margin-top: 32px;
}
.mt-\\[-12px\\]{
  margin-top: -12px;
}
.mt-auto{
  margin-top: auto;
}
.mt-lp-base{
  margin-top: 4px;
}
.mt-lp-lg{
  margin-top: 40px;
}
.mt-lp-md{
  margin-top: 24px;
}
.mt-lp-xl{
  margin-top: 80px;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.line-clamp-4{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
}
.line-clamp-\\[7\\]{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
}
.\\!block{
  display: block !important;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.\\!hidden{
  display: none !important;
}
.hidden{
  display: none;
}
.aspect-\\[16\\/10\\]{
  aspect-ratio: 16/10;
}
.aspect-\\[16\\/7\\]{
  aspect-ratio: 16/7;
}
.aspect-\\[16\\/9\\]{
  aspect-ratio: 16/9;
}
.aspect-\\[21\\/9\\]{
  aspect-ratio: 21/9;
}
.aspect-\\[4\\/3\\]{
  aspect-ratio: 4/3;
}
.aspect-\\[5\\/3\\]{
  aspect-ratio: 5/3;
}
.aspect-\\[5\\/4\\]{
  aspect-ratio: 5/4;
}
.aspect-square{
  aspect-ratio: 1 / 1;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-0\\.5{
  height: 2px;
}
.h-1{
  height: 4px;
}
.h-1\\.5{
  height: 6px;
}
.h-1\\/2{
  height: 50%;
}
.h-10{
  height: 40px;
}
.h-11{
  height: 44px;
}
.h-12{
  height: 48px;
}
.h-14{
  height: 56px;
}
.h-16{
  height: 64px;
}
.h-2{
  height: 8px;
}
.h-2\\.5{
  height: 10px;
}
.h-20{
  height: 80px;
}
.h-24{
  height: 96px;
}
.h-28{
  height: 112px;
}
.h-3{
  height: 12px;
}
.h-3\\.5{
  height: 14px;
}
.h-32{
  height: 128px;
}
.h-36{
  height: 144px;
}
.h-4{
  height: 16px;
}
.h-40{
  height: 160px;
}
.h-44{
  height: 176px;
}
.h-48{
  height: 192px;
}
.h-5{
  height: 20px;
}
.h-52{
  height: 208px;
}
.h-56{
  height: 224px;
}
.h-6{
  height: 24px;
}
.h-64{
  height: 256px;
}
.h-7{
  height: 28px;
}
.h-72{
  height: 288px;
}
.h-8{
  height: 32px;
}
.h-9{
  height: 36px;
}
.h-\\[100dvh\\]{
  height: 100dvh;
}
.h-\\[108px\\]{
  height: 108px;
}
.h-\\[120px\\]{
  height: 120px;
}
.h-\\[160px\\]{
  height: 160px;
}
.h-\\[176px\\]{
  height: 176px;
}
.h-\\[18px\\]{
  height: 18px;
}
.h-\\[1px\\]{
  height: 1px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[20px\\]{
  height: 20px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[260px\\]{
  height: 260px;
}
.h-\\[280px\\]{
  height: 280px;
}
.h-\\[30\\%\\]{
  height: 30%;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[35\\%\\]{
  height: 35%;
}
.h-\\[36\\%\\]{
  height: 36%;
}
.h-\\[38\\%\\]{
  height: 38%;
}
.h-\\[3px\\]{
  height: 3px;
}
.h-\\[400px\\]{
  height: 400px;
}
.h-\\[45\\%\\]{
  height: 45%;
}
.h-\\[460px\\]{
  height: 460px;
}
.h-\\[480px\\]{
  height: 480px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[50px\\]{
  height: 50px;
}
.h-\\[580px\\]{
  height: 580px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[62\\%\\]{
  height: 62%;
}
.h-\\[640px\\]{
  height: 640px;
}
.h-\\[68px\\]{
  height: 68px;
}
.h-\\[72px\\]{
  height: 72px;
}
.h-\\[88\\%\\]{
  height: 88%;
}
.h-\\[88px\\]{
  height: 88px;
}
.h-\\[calc\\(100dvh-60px-4rem-1\\.25rem-env\\(safe-area-inset-bottom\\)\\)\\]{
  height: calc(100dvh - 60px - 4rem - 1.25rem - env(safe-area-inset-bottom));
}
.h-\\[calc\\(100vh-140px\\)\\]{
  height: calc(100vh - 140px);
}
.h-\\[calc\\(100vh-7rem\\)\\]{
  height: calc(100vh - 7rem);
}
.h-auto{
  height: auto;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.max-h-0{
  max-height: 0px;
}
.max-h-32{
  max-height: 128px;
}
.max-h-48{
  max-height: 192px;
}
.max-h-52{
  max-height: 208px;
}
.max-h-56{
  max-height: 224px;
}
.max-h-60{
  max-height: 240px;
}
.max-h-64{
  max-height: 256px;
}
.max-h-72{
  max-height: 288px;
}
.max-h-80{
  max-height: 320px;
}
.max-h-\\[100px\\]{
  max-height: 100px;
}
.max-h-\\[200px\\]{
  max-height: 200px;
}
.max-h-\\[280px\\]{
  max-height: 280px;
}
.max-h-\\[28rem\\]{
  max-height: 28rem;
}
.max-h-\\[300px\\]{
  max-height: 300px;
}
.max-h-\\[400px\\]{
  max-height: 400px;
}
.max-h-\\[420px\\]{
  max-height: 420px;
}
.max-h-\\[60vh\\]{
  max-height: 60vh;
}
.max-h-\\[75vh\\]{
  max-height: 75vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[calc\\(100vh-10\\.5rem\\)\\]{
  max-height: calc(100vh - 10.5rem);
}
.max-h-\\[calc\\(100vh-60px\\)\\]{
  max-height: calc(100vh - 60px);
}
.max-h-\\[calc\\(100vh-6rem\\)\\]{
  max-height: calc(100vh - 6rem);
}
.max-h-\\[calc\\(100vh-92px\\)\\]{
  max-height: calc(100vh - 92px);
}
.max-h-full{
  max-height: 100%;
}
.max-h-screen{
  max-height: 100vh;
}
.min-h-0{
  min-height: 0px;
}
.min-h-\\[100px\\]{
  min-height: 100px;
}
.min-h-\\[11rem\\]{
  min-height: 11rem;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[140px\\]{
  min-height: 140px;
}
.min-h-\\[160px\\]{
  min-height: 160px;
}
.min-h-\\[180px\\]{
  min-height: 180px;
}
.min-h-\\[2\\.25rem\\]{
  min-height: 2.25rem;
}
.min-h-\\[2\\.5rem\\]{
  min-height: 2.5rem;
}
.min-h-\\[200px\\]{
  min-height: 200px;
}
.min-h-\\[220px\\]{
  min-height: 220px;
}
.min-h-\\[260px\\]{
  min-height: 260px;
}
.min-h-\\[26px\\]{
  min-height: 26px;
}
.min-h-\\[280px\\]{
  min-height: 280px;
}
.min-h-\\[2rem\\]{
  min-height: 2rem;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[320px\\]{
  min-height: 320px;
}
.min-h-\\[400px\\]{
  min-height: 400px;
}
.min-h-\\[40px\\]{
  min-height: 40px;
}
.min-h-\\[42px\\]{
  min-height: 42px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[4px\\]{
  min-height: 4px;
}
.min-h-\\[520px\\]{
  min-height: 520px;
}
.min-h-\\[74px\\]{
  min-height: 74px;
}
.min-h-\\[88px\\]{
  min-height: 88px;
}
.min-h-\\[inherit\\]{
  min-height: inherit;
}
.min-h-screen{
  min-height: 100vh;
}
.w-0\\.5{
  width: 2px;
}
.w-1{
  width: 4px;
}
.w-1\\.5{
  width: 6px;
}
.w-1\\/2{
  width: 50%;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-1\\/4{
  width: 25%;
}
.w-1\\/6{
  width: 16.666667%;
}
.w-10{
  width: 40px;
}
.w-11{
  width: 44px;
}
.w-12{
  width: 48px;
}
.w-14{
  width: 56px;
}
.w-16{
  width: 64px;
}
.w-2{
  width: 8px;
}
.w-2\\.5{
  width: 10px;
}
.w-2\\/3{
  width: 66.666667%;
}
.w-20{
  width: 80px;
}
.w-24{
  width: 96px;
}
.w-28{
  width: 112px;
}
.w-3{
  width: 12px;
}
.w-3\\.5{
  width: 14px;
}
.w-3\\/4{
  width: 75%;
}
.w-3\\/5{
  width: 60%;
}
.w-32{
  width: 128px;
}
.w-36{
  width: 144px;
}
.w-4{
  width: 16px;
}
.w-4\\/5{
  width: 80%;
}
.w-4\\/6{
  width: 66.666667%;
}
.w-40{
  width: 160px;
}
.w-44{
  width: 176px;
}
.w-48{
  width: 192px;
}
.w-5{
  width: 20px;
}
.w-5\\/6{
  width: 83.333333%;
}
.w-56{
  width: 224px;
}
.w-6{
  width: 24px;
}
.w-60{
  width: 240px;
}
.w-64{
  width: 256px;
}
.w-7{
  width: 28px;
}
.w-72{
  width: 288px;
}
.w-8{
  width: 32px;
}
.w-80{
  width: 320px;
}
.w-9{
  width: 36px;
}
.w-96{
  width: 384px;
}
.w-\\[108px\\]{
  width: 108px;
}
.w-\\[132px\\]{
  width: 132px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[152px\\]{
  width: 152px;
}
.w-\\[156px\\]{
  width: 156px;
}
.w-\\[18px\\]{
  width: 18px;
}
.w-\\[190px\\]{
  width: 190px;
}
.w-\\[200px\\]{
  width: 200px;
}
.w-\\[220px\\]{
  width: 220px;
}
.w-\\[225px\\]{
  width: 225px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[240px\\]{
  width: 240px;
}
.w-\\[260px\\]{
  width: 260px;
}
.w-\\[268px\\]{
  width: 268px;
}
.w-\\[280px\\]{
  width: 280px;
}
.w-\\[2px\\]{
  width: 2px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[315px\\]{
  width: 315px;
}
.w-\\[320px\\]{
  width: 320px;
}
.w-\\[36\\%\\]{
  width: 36%;
}
.w-\\[38\\%\\]{
  width: 38%;
}
.w-\\[3px\\]{
  width: 3px;
}
.w-\\[400px\\]{
  width: 400px;
}
.w-\\[45\\%\\]{
  width: 45%;
}
.w-\\[500px\\]{
  width: 500px;
}
.w-\\[55\\%\\]{
  width: 55%;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[60px\\]{
  width: 60px;
}
.w-\\[62\\%\\]{
  width: 62%;
}
.w-\\[68px\\]{
  width: 68px;
}
.w-\\[72px\\]{
  width: 72px;
}
.w-\\[88\\%\\]{
  width: 88%;
}
.w-\\[88px\\]{
  width: 88px;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-px{
  width: 1px;
}
.w-sidebar-left{
  width: 260px;
}
.min-w-0{
  min-width: 0px;
}
.min-w-\\[100px\\]{
  min-width: 100px;
}
.min-w-\\[120px\\]{
  min-width: 120px;
}
.min-w-\\[12px\\]{
  min-width: 12px;
}
.min-w-\\[140px\\]{
  min-width: 140px;
}
.min-w-\\[150px\\]{
  min-width: 150px;
}
.min-w-\\[16px\\]{
  min-width: 16px;
}
.min-w-\\[18px\\]{
  min-width: 18px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[20px\\]{
  min-width: 20px;
}
.min-w-\\[250px\\]{
  min-width: 250px;
}
.min-w-\\[44px\\]{
  min-width: 44px;
}
.min-w-\\[48px\\]{
  min-width: 48px;
}
.min-w-\\[52px\\]{
  min-width: 52px;
}
.min-w-\\[58px\\]{
  min-width: 58px;
}
.min-w-\\[60px\\]{
  min-width: 60px;
}
.min-w-\\[80px\\]{
  min-width: 80px;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1000px\\]{
  max-width: 1000px;
}
.max-w-\\[1020px\\]{
  max-width: 1020px;
}
.max-w-\\[1060px\\]{
  max-width: 1060px;
}
.max-w-\\[1100px\\]{
  max-width: 1100px;
}
.max-w-\\[1128px\\]{
  max-width: 1128px;
}
.max-w-\\[1200px\\]{
  max-width: 1200px;
}
.max-w-\\[12rem\\]{
  max-width: 12rem;
}
.max-w-\\[1320px\\]{
  max-width: 1320px;
}
.max-w-\\[132px\\]{
  max-width: 132px;
}
.max-w-\\[140px\\]{
  max-width: 140px;
}
.max-w-\\[1440px\\]{
  max-width: 1440px;
}
.max-w-\\[152px\\]{
  max-width: 152px;
}
.max-w-\\[156px\\]{
  max-width: 156px;
}
.max-w-\\[16rem\\]{
  max-width: 16rem;
}
.max-w-\\[180px\\]{
  max-width: 180px;
}
.max-w-\\[18rem\\]{
  max-width: 18rem;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[268px\\]{
  max-width: 268px;
}
.max-w-\\[280px\\]{
  max-width: 280px;
}
.max-w-\\[360px\\]{
  max-width: 360px;
}
.max-w-\\[480px\\]{
  max-width: 480px;
}
.max-w-\\[55\\%\\]{
  max-width: 55%;
}
.max-w-\\[58\\%\\]{
  max-width: 58%;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[680px\\]{
  max-width: 680px;
}
.max-w-\\[70\\%\\]{
  max-width: 70%;
}
.max-w-\\[72\\%\\]{
  max-width: 72%;
}
.max-w-\\[760px\\]{
  max-width: 760px;
}
.max-w-\\[800px\\]{
  max-width: 800px;
}
.max-w-\\[80px\\]{
  max-width: 80px;
}
.max-w-\\[8rem\\]{
  max-width: 8rem;
}
.max-w-\\[920px\\]{
  max-width: 920px;
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-lp-container{
  max-width: 1200px;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-none{
  flex: none;
}
.flex-shrink{
  flex-shrink: 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink{
  flex-shrink: 1;
}
.shrink-0{
  flex-shrink: 0;
}
.grow{
  flex-grow: 1;
}
.basis-full{
  flex-basis: 100%;
}
.border-collapse{
  border-collapse: collapse;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/3{
  --tw-translate-y: -33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0\\.5{
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1\\/3{
  --tw-translate-x: 33.333333%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4{
  --tw-translate-x: 16px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-6{
  --tw-translate-x: 24px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-12{
  --tw-rotate: -12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-45{
  --tw-rotate: -45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-6{
  --tw-rotate: -6deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90{
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-0{
  --tw-rotate: 0deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-12{
  --tw-rotate: 12deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[30deg\\]{
  --tw-rotate: 30deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[60deg\\]{
  --tw-rotate: 60deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-100{
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-75{
  --tw-scale-x: .75;
  --tw-scale-y: .75;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.animate-\\[shrink_5s_linear_forwards\\]{
  animation: shrink 5s linear forwards;
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes fadeIn{

  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
}
.animate-fade-in{
  animation: fadeIn 0.2s ease-out;
}
@keyframes ping{

  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes scaleIn{

  0%{
    transform: scale(0.96);
    opacity: 0;
  }

  100%{
    transform: scale(1);
    opacity: 1;
  }
}
.animate-scale-in{
  animation: scaleIn 0.15s ease-out;
}
@keyframes slideDown{

  0%{
    transform: translateY(-8px);
    opacity: 0;
  }

  100%{
    transform: translateY(0);
    opacity: 1;
  }
}
.animate-slide-down{
  animation: slideDown 0.25s ease-out;
}
@keyframes slideUp{

  0%{
    transform: translateY(8px);
    opacity: 0;
  }

  100%{
    transform: translateY(0);
    opacity: 1;
  }
}
.animate-slide-up{
  animation: slideUp 0.25s ease-out;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-default{
  cursor: default;
}
.cursor-grab{
  cursor: grab;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-wait{
  cursor: wait;
}
.cursor-zoom-in{
  cursor: zoom-in;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize-y{
  resize: vertical;
}
.resize{
  resize: both;
}
.snap-x{
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory{
  --tw-scroll-snap-strictness: mandatory;
}
.snap-start{
  scroll-snap-align: start;
}
.scroll-mt-24{
  scroll-margin-top: 96px;
}
.list-inside{
  list-style-position: inside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.appearance-none{
  appearance: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}
.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}
.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}
.grid-cols-\\[2\\.5fr_1fr_1fr_1\\.2fr_1\\.2fr_1fr_0\\.8fr\\]{
  grid-template-columns: 2.5fr 1fr 1fr 1.2fr 1.2fr 1fr 0.8fr;
}
.grid-cols-\\[2\\.5fr_1fr_1fr_1\\.5fr_1\\.2fr_1\\.2fr_0\\.5fr\\]{
  grid-template-columns: 2.5fr 1fr 1fr 1.5fr 1.2fr 1.2fr 0.5fr;
}
.grid-cols-\\[auto_2\\.5fr_1\\.5fr_1fr_1\\.2fr_1\\.2fr_0\\.8fr\\]{
  grid-template-columns: auto 2.5fr 1.5fr 1fr 1.2fr 1.2fr 0.8fr;
}
.grid-cols-\\[minmax\\(0\\2c 1fr\\)_2\\.5rem\\]{
  grid-template-columns: minmax(0,1fr) 2.5rem;
}
.flex-row{
  flex-direction: row;
}
.flex-row-reverse{
  flex-direction: row-reverse;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.flex-nowrap{
  flex-wrap: nowrap;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-baseline{
  align-items: baseline;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-around{
  justify-content: space-around;
}
.gap-0{
  gap: 0px;
}
.gap-0\\.5{
  gap: 2px;
}
.gap-1{
  gap: 4px;
}
.gap-1\\.5{
  gap: 6px;
}
.gap-2{
  gap: 8px;
}
.gap-2\\.5{
  gap: 10px;
}
.gap-3{
  gap: 12px;
}
.gap-3\\.5{
  gap: 14px;
}
.gap-4{
  gap: 16px;
}
.gap-5{
  gap: 20px;
}
.gap-6{
  gap: 24px;
}
.gap-8{
  gap: 32px;
}
.gap-lp-md{
  gap: 24px;
}
.gap-lp-sm{
  gap: 16px;
}
.gap-lp-xl{
  gap: 80px;
}
.gap-lp-xs{
  gap: 8px;
}
.gap-x-3{
  column-gap: 12px;
}
.gap-x-4{
  column-gap: 16px;
}
.gap-x-6{
  column-gap: 24px;
}
.gap-x-lp-md{
  column-gap: 24px;
}
.gap-y-1{
  row-gap: 4px;
}
.gap-y-1\\.5{
  row-gap: 6px;
}
.gap-y-3\\.5{
  row-gap: 14px;
}
.gap-y-lp-sm{
  row-gap: 16px;
}
.-space-x-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-6px * var(--tw-space-x-reverse));
  margin-left: calc(-6px * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-8px * var(--tw-space-x-reverse));
  margin-left: calc(-8px * calc(1 - var(--tw-space-x-reverse)));
}
.-space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-12px * var(--tw-space-x-reverse));
  margin-left: calc(-12px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(4px * var(--tw-space-x-reverse));
  margin-left: calc(4px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(6px * var(--tw-space-x-reverse));
  margin-left: calc(6px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(8px * var(--tw-space-x-reverse));
  margin-left: calc(8px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(12px * var(--tw-space-x-reverse));
  margin-left: calc(12px * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(16px * var(--tw-space-x-reverse));
  margin-left: calc(16px * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0px * var(--tw-space-y-reverse));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2px * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(4px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(4px * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(6px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(6px * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(48px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(48px * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(8px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(8px * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(10px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(10px * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(12px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(12px * var(--tw-space-y-reverse));
}
.space-y-3\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(14px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(14px * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(20px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(20px * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(24px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(24px * var(--tw-space-y-reverse));
}
.space-y-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(28px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(28px * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(32px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(32px * var(--tw-space-y-reverse));
}
.space-y-lp-md > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(24px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(24px * var(--tw-space-y-reverse));
}
.space-y-lp-sm > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(16px * var(--tw-space-y-reverse));
}
.space-y-lp-xs > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(8px * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(8px * var(--tw-space-y-reverse));
}
.space-x-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 1;
}
.divide-x > :not([hidden]) ~ :not([hidden]){
  --tw-divide-x-reverse: 0;
  border-right-width: calc(1px * var(--tw-divide-x-reverse));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-gray-50 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-divide-opacity, 1));
}
.divide-neutral-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-divide-opacity, 1));
}
.divide-white\\/10 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.1);
}
.divide-white\\/5 > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.05);
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.self-center{
  align-self: center;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-line{
  white-space: pre-line;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 6px;
}
.rounded-2xl{
  border-radius: 16px;
}
.rounded-3xl{
  border-radius: 20px;
}
.rounded-\\[18px\\]{
  border-radius: 18px;
}
.rounded-\\[28px\\]{
  border-radius: 28px;
}
.rounded-\\[36px\\]{
  border-radius: 36px;
}
.rounded-\\[40px\\]{
  border-radius: 40px;
}
.rounded-\\[44px\\]{
  border-radius: 44px;
}
.rounded-\\[48px\\]{
  border-radius: 48px;
}
.rounded-\\[64px\\]{
  border-radius: 64px;
}
.rounded-dash-lg{
  border-radius: 16px;
}
.rounded-dash-md{
  border-radius: 12px;
}
.rounded-dash-xl{
  border-radius: 20px;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 10px;
}
.rounded-md{
  border-radius: 8px;
}
.rounded-none{
  border-radius: 0;
}
.rounded-sm{
  border-radius: 4px;
}
.rounded-xl{
  border-radius: 12px;
}
.rounded-b-2xl{
  border-bottom-right-radius: 16px;
  border-bottom-left-radius: 16px;
}
.rounded-b-full{
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
}
.rounded-b-sm{
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}
.rounded-t{
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
}
.rounded-t-2xl{
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}
.rounded-t-3xl{
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}
.rounded-t-lg{
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-md{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.rounded-t-sm{
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.rounded-t-xl{
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.rounded-bl-2xl{
  border-bottom-left-radius: 16px;
}
.rounded-bl-sm{
  border-bottom-left-radius: 4px;
}
.rounded-br-2xl{
  border-bottom-right-radius: 16px;
}
.rounded-br-sm{
  border-bottom-right-radius: 4px;
}
.rounded-tl-2xl{
  border-top-left-radius: 16px;
}
.rounded-tl-sm{
  border-top-left-radius: 4px;
}
.rounded-tr-2xl{
  border-top-right-radius: 16px;
}
.rounded-tr-sm{
  border-top-right-radius: 4px;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[10px\\]{
  border-width: 10px;
}
.border-\\[2\\.5px\\]{
  border-width: 2.5px;
}
.border-\\[3px\\]{
  border-width: 3px;
}
.border-\\[8px\\]{
  border-width: 8px;
}
.border-x{
  border-left-width: 1px;
  border-right-width: 1px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-8{
  border-bottom-width: 8px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-l-\\[3px\\]{
  border-left-width: 3px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#171A23\\]{
  --tw-border-opacity: 1;
  border-color: rgb(23 26 35 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1a0533\\]{
  --tw-border-opacity: 1;
  border-color: rgb(26 5 51 / var(--tw-border-opacity, 1));
}
.border-\\[\\#1d1148\\]{
  --tw-border-opacity: 1;
  border-color: rgb(29 17 72 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2563EB\\]{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-\\[\\#2563EB\\]\\/30{
  border-color: rgb(37 99 235 / 0.3);
}
.border-\\[\\#2563EB\\]\\/35{
  border-color: rgb(37 99 235 / 0.35);
}
.border-\\[\\#2563EB\\]\\/40{
  border-color: rgb(37 99 235 / 0.4);
}
.border-\\[\\#2563EB\\]\\/50{
  border-color: rgb(37 99 235 / 0.5);
}
.border-\\[\\#2563eb\\]\\/55{
  border-color: rgb(37 99 235 / 0.55);
}
.border-\\[\\#2A3042\\]{
  --tw-border-opacity: 1;
  border-color: rgb(42 48 66 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E0DFDC\\]{
  --tw-border-opacity: 1;
  border-color: rgb(224 223 220 / var(--tw-border-opacity, 1));
}
.border-\\[\\#E0E0E0\\]{
  --tw-border-opacity: 1;
  border-color: rgb(224 224 224 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ddd0bc\\]{
  --tw-border-opacity: 1;
  border-color: rgb(221 208 188 / var(--tw-border-opacity, 1));
}
.border-\\[\\#e5dcc8\\]{
  --tw-border-opacity: 1;
  border-color: rgb(229 220 200 / var(--tw-border-opacity, 1));
}
.border-amber-100{
  --tw-border-opacity: 1;
  border-color: rgb(254 243 199 / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-blue-100\\/50{
  border-color: rgb(219 234 254 / 0.5);
}
.border-blue-100\\/70{
  border-color: rgb(219 234 254 / 0.7);
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-blue-200\\/70{
  border-color: rgb(191 219 254 / 0.7);
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-blue-400\\/40{
  border-color: rgb(96 165 250 / 0.4);
}
.border-blue-400\\/50{
  border-color: rgb(96 165 250 / 0.5);
}
.border-blue-500\\/20{
  border-color: rgb(59 130 246 / 0.2);
}
.border-blue-500\\/25{
  border-color: rgb(59 130 246 / 0.25);
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-dashboard-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-dashboard-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-dashboard-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-dashboard-500{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-emerald-100{
  --tw-border-opacity: 1;
  border-color: rgb(209 250 229 / var(--tw-border-opacity, 1));
}
.border-emerald-100\\/60{
  border-color: rgb(209 250 229 / 0.6);
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-200\\/50{
  border-color: rgb(167 243 208 / 0.5);
}
.border-emerald-200\\/60{
  border-color: rgb(167 243 208 / 0.6);
}
.border-emerald-300{
  --tw-border-opacity: 1;
  border-color: rgb(110 231 183 / var(--tw-border-opacity, 1));
}
.border-emerald-400\\/25{
  border-color: rgb(52 211 153 / 0.25);
}
.border-emerald-500\\/30{
  border-color: rgb(16 185 129 / 0.3);
}
.border-error-100{
  border-color: rgba(37, 99, 235, 0.16);
}
.border-error-500{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-error-500\\/20{
  border-color: rgb(37 99 235 / 0.2);
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-gray-200\\/60{
  border-color: rgb(229 231 235 / 0.6);
}
.border-gray-200\\/70{
  border-color: rgb(229 231 235 / 0.7);
}
.border-gray-200\\/80{
  border-color: rgb(229 231 235 / 0.8);
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-gray-50{
  --tw-border-opacity: 1;
  border-color: rgb(249 250 251 / var(--tw-border-opacity, 1));
}
.border-gray-600{
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700{
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-gray-800\\/20{
  border-color: rgb(31 41 55 / 0.2);
}
.border-gray-900{
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-green-100{
  --tw-border-opacity: 1;
  border-color: rgb(220 252 231 / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-indigo-100{
  --tw-border-opacity: 1;
  border-color: rgb(224 231 255 / var(--tw-border-opacity, 1));
}
.border-indigo-100\\/50{
  border-color: rgb(224 231 255 / 0.5);
}
.border-indigo-100\\/60{
  border-color: rgb(224 231 255 / 0.6);
}
.border-indigo-100\\/80{
  border-color: rgb(224 231 255 / 0.8);
}
.border-indigo-200{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}
.border-indigo-200\\/30{
  border-color: rgb(199 210 254 / 0.3);
}
.border-indigo-200\\/40{
  border-color: rgb(199 210 254 / 0.4);
}
.border-indigo-200\\/50{
  border-color: rgb(199 210 254 / 0.5);
}
.border-indigo-300{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}
.border-indigo-300\\/40{
  border-color: rgb(165 180 252 / 0.4);
}
.border-indigo-400{
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-indigo-500\\/20{
  border-color: rgb(99 102 241 / 0.2);
}
.border-indigo-600{
  --tw-border-opacity: 1;
  border-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-lp-background{
  --tw-border-opacity: 1;
  border-color: rgb(16 19 26 / var(--tw-border-opacity, 1));
}
.border-lp-primary-container{
  --tw-border-opacity: 1;
  border-color: rgb(47 107 255 / var(--tw-border-opacity, 1));
}
.border-lp-surface-container-highest\\/80{
  border-color: rgb(50 53 60 / 0.8);
}
.border-neutral-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
}
.border-neutral-200{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}
.border-neutral-200\\/50{
  border-color: rgb(229 231 235 / 0.5);
}
.border-neutral-200\\/60{
  border-color: rgb(229 231 235 / 0.6);
}
.border-neutral-200\\/70{
  border-color: rgb(229 231 235 / 0.7);
}
.border-neutral-200\\/80{
  border-color: rgb(229 231 235 / 0.8);
}
.border-neutral-300{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}
.border-neutral-900{
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-orange-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 237 213 / var(--tw-border-opacity, 1));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-pink-200{
  --tw-border-opacity: 1;
  border-color: rgb(251 207 232 / var(--tw-border-opacity, 1));
}
.border-pink-300{
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity, 1));
}
.border-primary-100{
  --tw-border-opacity: 1;
  border-color: rgb(219 234 254 / var(--tw-border-opacity, 1));
}
.border-primary-200{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}
.border-primary-300{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}
.border-primary-400{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}
.border-primary-400\\/20{
  border-color: rgb(96 165 250 / 0.2);
}
.border-primary-400\\/25{
  border-color: rgb(96 165 250 / 0.25);
}
.border-primary-500{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-primary-500\\/20{
  border-color: rgb(59 130 246 / 0.2);
}
.border-primary-600{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-purple-100{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}
.border-purple-100\\/60{
  border-color: rgb(243 232 255 / 0.6);
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}
.border-purple-300{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}
.border-purple-500{
  --tw-border-opacity: 1;
  border-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-purple-600{
  --tw-border-opacity: 1;
  border-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-purple-800{
  --tw-border-opacity: 1;
  border-color: rgb(107 33 168 / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-red-500{
  --tw-border-opacity: 1;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1));
}
.border-red-500\\/20{
  border-color: rgb(239 68 68 / 0.2);
}
.border-rose-100{
  --tw-border-opacity: 1;
  border-color: rgb(255 228 230 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(226 232 240 / var(--tw-border-opacity, 1));
}
.border-success-100{
  border-color: rgba(37, 99, 235, 0.16);
}
.border-success-500\\/20{
  border-color: rgb(37 99 235 / 0.2);
}
.border-transparent{
  border-color: transparent;
}
.border-violet-100{
  --tw-border-opacity: 1;
  border-color: rgb(237 233 254 / var(--tw-border-opacity, 1));
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}
.border-violet-400{
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}
.border-warning-100{
  border-color: rgba(37, 99, 235, 0.16);
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/10{
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15{
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/5{
  border-color: rgb(255 255 255 / 0.05);
}
.border-white\\/50{
  border-color: rgb(255 255 255 / 0.5);
}
.border-white\\/60{
  border-color: rgb(255 255 255 / 0.6);
}
.border-white\\/90{
  border-color: rgb(255 255 255 / 0.9);
}
.border-white\\/\\[0\\.07\\]{
  border-color: rgb(255 255 255 / 0.07);
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-b-primary-600{
  --tw-border-opacity: 1;
  border-bottom-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-l-indigo-400{
  --tw-border-opacity: 1;
  border-left-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}
.border-l-indigo-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}
.border-l-lp-primary{
  --tw-border-opacity: 1;
  border-left-color: rgb(181 196 255 / var(--tw-border-opacity, 1));
}
.border-l-primary-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-l-purple-500{
  --tw-border-opacity: 1;
  border-left-color: rgb(168 85 247 / var(--tw-border-opacity, 1));
}
.border-t-\\[\\#2563EB\\]{
  --tw-border-opacity: 1;
  border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-t-blue-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-t-indigo-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(79 70 229 / var(--tw-border-opacity, 1));
}
.border-t-neutral-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-t-neutral-900{
  --tw-border-opacity: 1;
  border-top-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}
.border-t-primary-500{
  --tw-border-opacity: 1;
  border-top-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}
.border-t-primary-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}
.border-t-purple-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(147 51 234 / var(--tw-border-opacity, 1));
}
.border-t-transparent{
  border-top-color: transparent;
}
.border-t-violet-600{
  --tw-border-opacity: 1;
  border-top-color: rgb(124 58 237 / var(--tw-border-opacity, 1));
}
.border-t-white{
  --tw-border-opacity: 1;
  border-top-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.bg-\\[\\#0F1117\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 17 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0a66c2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(10 102 194 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0b0b15\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(11 11 21 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0c0c12\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(12 12 18 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0c1222\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(12 18 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#0f172a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#10101e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#13131f\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(19 19 31 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#13151f\\]\\/60{
  background-color: rgb(19 21 31 / 0.6);
}
.bg-\\[\\#13151f\\]\\/80{
  background-color: rgb(19 21 31 / 0.8);
}
.bg-\\[\\#161622\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 22 34 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#161628\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(22 22 40 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#171A23\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(23 26 35 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#171A23\\]\\/55{
  background-color: rgb(23 26 35 / 0.55);
}
.bg-\\[\\#171A23\\]\\/90{
  background-color: rgb(23 26 35 / 0.9);
}
.bg-\\[\\#171A23\\]\\/95{
  background-color: rgb(23 26 35 / 0.95);
}
.bg-\\[\\#181717\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 23 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#181827\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 39 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E2230\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 34 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1E2230\\]\\/45{
  background-color: rgb(30 34 48 / 0.45);
}
.bg-\\[\\#1a1d2e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(26 29 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1c1c2c\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(28 28 44 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e1e2e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e1e36\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 54 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e2230\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(30 34 48 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2563EB\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2563EB\\]\\/10{
  background-color: rgb(37 99 235 / 0.1);
}
.bg-\\[\\#2563EB\\]\\/15{
  background-color: rgb(37 99 235 / 0.15);
}
.bg-\\[\\#2563eb\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2563eb\\]\\/10{
  background-color: rgb(37 99 235 / 0.1);
}
.bg-\\[\\#2563eb\\]\\/15{
  background-color: rgb(37 99 235 / 0.15);
}
.bg-\\[\\#2563eb\\]\\/25{
  background-color: rgb(37 99 235 / 0.25);
}
.bg-\\[\\#2563eb\\]\\/40{
  background-color: rgb(37 99 235 / 0.4);
}
.bg-\\[\\#3d2a7a\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(61 42 122 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#60a5fa\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#6B7280\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#93c5fd\\]\\/80{
  background-color: rgb(147 197 253 / 0.8);
}
.bg-\\[\\#F3F2EF\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 242 239 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#e8dfd0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(232 223 208 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ebe4d6\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(235 228 214 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#efe6d8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(239 230 216 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3ebe0\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(243 235 224 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f3f7\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 243 247 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f4f4f8\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 248 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f8f9fc\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(248 249 252 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#faf6f1\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(250 246 241 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ff0000\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(255 0 0 / var(--tw-bg-opacity, 1));
}
.bg-accent-200\\/40{
  background-color: rgb(191 219 254 / 0.4);
}
.bg-accent-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-accent-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-300{
  --tw-bg-opacity: 1;
  background-color: rgb(252 211 77 / var(--tw-bg-opacity, 1));
}
.bg-amber-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 191 36 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-500\\/90{
  background-color: rgb(245 158 11 / 0.9);
}
.bg-background-page{
  --tw-bg-opacity: 1;
  background-color: rgb(15 17 23 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/55{
  background-color: rgb(0 0 0 / 0.55);
}
.bg-black\\/60{
  background-color: rgb(0 0 0 / 0.6);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-black\\/75{
  background-color: rgb(0 0 0 / 0.75);
}
.bg-black\\/80{
  background-color: rgb(0 0 0 / 0.8);
}
.bg-black\\/85{
  background-color: rgb(0 0 0 / 0.85);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}
.bg-blue-200\\/60{
  background-color: rgb(191 219 254 / 0.6);
}
.bg-blue-200\\/70{
  background-color: rgb(191 219 254 / 0.7);
}
.bg-blue-300{
  --tw-bg-opacity: 1;
  background-color: rgb(147 197 253 / var(--tw-bg-opacity, 1));
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(96 165 250 / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/30{
  background-color: rgb(239 246 255 / 0.3);
}
.bg-blue-50\\/40{
  background-color: rgb(239 246 255 / 0.4);
}
.bg-blue-50\\/60{
  background-color: rgb(239 246 255 / 0.6);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-blue-500\\/15{
  background-color: rgb(59 130 246 / 0.15);
}
.bg-blue-500\\/30{
  background-color: rgb(59 130 246 / 0.3);
}
.bg-blue-500\\/5{
  background-color: rgb(59 130 246 / 0.05);
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-blue-600\\/10{
  background-color: rgb(37 99 235 / 0.1);
}
.bg-blue-700{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-current{
  background-color: currentColor;
}
.bg-cyan-100{
  --tw-bg-opacity: 1;
  background-color: rgb(207 250 254 / var(--tw-bg-opacity, 1));
}
.bg-cyan-400\\/15{
  background-color: rgb(34 211 238 / 0.15);
}
.bg-cyan-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 254 255 / var(--tw-bg-opacity, 1));
}
.bg-cyan-500{
  --tw-bg-opacity: 1;
  background-color: rgb(6 182 212 / var(--tw-bg-opacity, 1));
}
.bg-dashboard-200\\/40{
  background-color: rgb(191 219 254 / 0.4);
}
.bg-dashboard-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-dashboard-50\\/40{
  background-color: rgb(239 246 255 / 0.4);
}
.bg-dashboard-50\\/60{
  background-color: rgb(239 246 255 / 0.6);
}
.bg-dashboard-500{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-200\\/70{
  background-color: rgb(167 243 208 / 0.7);
}
.bg-emerald-300{
  --tw-bg-opacity: 1;
  background-color: rgb(110 231 183 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400\\/40{
  background-color: rgb(52 211 153 / 0.4);
}
.bg-emerald-400\\/80{
  background-color: rgb(52 211 153 / 0.8);
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/15{
  background-color: rgb(16 185 129 / 0.15);
}
.bg-emerald-500\\/20{
  background-color: rgb(16 185 129 / 0.2);
}
.bg-emerald-600{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-error-100{
  background-color: rgba(37, 99, 235, 0.16);
}
.bg-error-50{
  background-color: rgba(37, 99, 235, 0.10);
}
.bg-error-50\\/60{
  background-color: rgba(37, 99, 235, 0.6);
}
.bg-error-50\\/80{
  background-color: rgba(37, 99, 235, 0.8);
}
.bg-error-500{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-error-500\\/90{
  background-color: rgb(37 99 235 / 0.9);
}
.bg-error-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-fuchsia-100{
  --tw-bg-opacity: 1;
  background-color: rgb(250 232 255 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-100\\/80{
  background-color: rgb(243 244 246 / 0.8);
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/40{
  background-color: rgb(249 250 251 / 0.4);
}
.bg-gray-50\\/50{
  background-color: rgb(249 250 251 / 0.5);
}
.bg-gray-50\\/60{
  background-color: rgb(249 250 251 / 0.6);
}
.bg-gray-50\\/80{
  background-color: rgb(249 250 251 / 0.8);
}
.bg-gray-500{
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}
.bg-gray-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.bg-gray-700\\/50{
  background-color: rgb(55 65 81 / 0.5);
}
.bg-gray-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-300{
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-50\\/50{
  background-color: rgb(240 253 244 / 0.5);
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-100{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200{
  --tw-bg-opacity: 1;
  background-color: rgb(199 210 254 / var(--tw-bg-opacity, 1));
}
.bg-indigo-200\\/70{
  background-color: rgb(199 210 254 / 0.7);
}
.bg-indigo-300{
  --tw-bg-opacity: 1;
  background-color: rgb(165 180 252 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400{
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}
.bg-indigo-400\\/15{
  background-color: rgb(129 140 248 / 0.15);
}
.bg-indigo-400\\/60{
  background-color: rgb(129 140 248 / 0.6);
}
.bg-indigo-400\\/70{
  background-color: rgb(129 140 248 / 0.7);
}
.bg-indigo-50{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50\\/40{
  background-color: rgb(238 242 255 / 0.4);
}
.bg-indigo-50\\/50{
  background-color: rgb(238 242 255 / 0.5);
}
.bg-indigo-50\\/60{
  background-color: rgb(238 242 255 / 0.6);
}
.bg-indigo-50\\/70{
  background-color: rgb(238 242 255 / 0.7);
}
.bg-indigo-50\\/80{
  background-color: rgb(238 242 255 / 0.8);
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(99 102 241 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500\\/15{
  background-color: rgb(99 102 241 / 0.15);
}
.bg-indigo-500\\/20{
  background-color: rgb(99 102 241 / 0.2);
}
.bg-indigo-600{
  --tw-bg-opacity: 1;
  background-color: rgb(79 70 229 / var(--tw-bg-opacity, 1));
}
.bg-info-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-lp-background{
  --tw-bg-opacity: 1;
  background-color: rgb(16 19 26 / var(--tw-bg-opacity, 1));
}
.bg-lp-primary{
  --tw-bg-opacity: 1;
  background-color: rgb(181 196 255 / var(--tw-bg-opacity, 1));
}
.bg-lp-primary-container\\/90{
  background-color: rgb(47 107 255 / 0.9);
}
.bg-lp-primary\\/10{
  background-color: rgb(181 196 255 / 0.1);
}
.bg-lp-primary\\/20{
  background-color: rgb(181 196 255 / 0.2);
}
.bg-lp-primary\\/5{
  background-color: rgb(181 196 255 / 0.05);
}
.bg-lp-surface-container-high\\/40{
  background-color: rgb(39 42 49 / 0.4);
}
.bg-lp-surface-container-low\\/20{
  background-color: rgb(25 28 34 / 0.2);
}
.bg-lp-surface-container-lowest{
  --tw-bg-opacity: 1;
  background-color: rgb(11 14 20 / var(--tw-bg-opacity, 1));
}
.bg-lp-surface-container-lowest\\/20{
  background-color: rgb(11 14 20 / 0.2);
}
.bg-lp-surface-container-lowest\\/30{
  background-color: rgb(11 14 20 / 0.3);
}
.bg-lp-surface-container\\/60{
  background-color: rgb(29 32 38 / 0.6);
}
.bg-lp-surface\\/40{
  background-color: rgb(16 19 26 / 0.4);
}
.bg-neutral-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-neutral-100\\/80{
  background-color: rgb(243 244 246 / 0.8);
}
.bg-neutral-200{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-neutral-400{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}
.bg-neutral-50{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}
.bg-neutral-50\\/30{
  background-color: rgb(249 250 251 / 0.3);
}
.bg-neutral-50\\/40{
  background-color: rgb(249 250 251 / 0.4);
}
.bg-neutral-50\\/60{
  background-color: rgb(249 250 251 / 0.6);
}
.bg-neutral-600{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}
.bg-neutral-800{
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}
.bg-neutral-900{
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}
.bg-neutral-900\\/40{
  background-color: rgb(17 24 39 / 0.4);
}
.bg-neutral-900\\/90{
  background-color: rgb(17 24 39 / 0.9);
}
.bg-orange-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}
.bg-orange-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 186 116 / var(--tw-bg-opacity, 1));
}
.bg-orange-400{
  --tw-bg-opacity: 1;
  background-color: rgb(251 146 60 / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-orange-500{
  --tw-bg-opacity: 1;
  background-color: rgb(249 115 22 / var(--tw-bg-opacity, 1));
}
.bg-orange-600{
  --tw-bg-opacity: 1;
  background-color: rgb(234 88 12 / var(--tw-bg-opacity, 1));
}
.bg-pink-100{
  --tw-bg-opacity: 1;
  background-color: rgb(252 231 243 / var(--tw-bg-opacity, 1));
}
.bg-pink-300{
  --tw-bg-opacity: 1;
  background-color: rgb(249 168 212 / var(--tw-bg-opacity, 1));
}
.bg-pink-400{
  --tw-bg-opacity: 1;
  background-color: rgb(244 114 182 / var(--tw-bg-opacity, 1));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-pink-500{
  --tw-bg-opacity: 1;
  background-color: rgb(236 72 153 / var(--tw-bg-opacity, 1));
}
.bg-primary-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-primary-200\\/80{
  background-color: rgb(191 219 254 / 0.8);
}
.bg-primary-400\\/15{
  background-color: rgb(96 165 250 / 0.15);
}
.bg-primary-50{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-primary-50\\/50{
  background-color: rgb(239 246 255 / 0.5);
}
.bg-primary-50\\/60{
  background-color: rgb(239 246 255 / 0.6);
}
.bg-primary-50\\/80{
  background-color: rgb(239 246 255 / 0.8);
}
.bg-primary-500{
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}
.bg-primary-500\\/10{
  background-color: rgb(59 130 246 / 0.1);
}
.bg-primary-500\\/15{
  background-color: rgb(59 130 246 / 0.15);
}
.bg-primary-500\\/20{
  background-color: rgb(59 130 246 / 0.2);
}
.bg-primary-500\\/85{
  background-color: rgb(59 130 246 / 0.85);
}
.bg-primary-500\\/90{
  background-color: rgb(59 130 246 / 0.9);
}
.bg-primary-600{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-primary-600\\/90{
  background-color: rgb(37 99 235 / 0.9);
}
.bg-primary-700{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}
.bg-purple-100{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-200{
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-300{
  --tw-bg-opacity: 1;
  background-color: rgb(216 180 254 / var(--tw-bg-opacity, 1));
}
.bg-purple-400{
  --tw-bg-opacity: 1;
  background-color: rgb(192 132 252 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-purple-50\\/30{
  background-color: rgb(250 245 255 / 0.3);
}
.bg-purple-50\\/40{
  background-color: rgb(250 245 255 / 0.4);
}
.bg-purple-50\\/50{
  background-color: rgb(250 245 255 / 0.5);
}
.bg-purple-500{
  --tw-bg-opacity: 1;
  background-color: rgb(168 85 247 / var(--tw-bg-opacity, 1));
}
.bg-purple-500\\/20{
  background-color: rgb(168 85 247 / 0.2);
}
.bg-purple-500\\/30{
  background-color: rgb(168 85 247 / 0.3);
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}
.bg-purple-600\\/10{
  background-color: rgb(147 51 234 / 0.1);
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-400{
  --tw-bg-opacity: 1;
  background-color: rgb(248 113 113 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-50\\/30{
  background-color: rgb(254 242 242 / 0.3);
}
.bg-red-50\\/50{
  background-color: rgb(254 242 242 / 0.5);
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10{
  background-color: rgb(239 68 68 / 0.1);
}
.bg-red-500\\/90{
  background-color: rgb(239 68 68 / 0.9);
}
.bg-red-500\\/95{
  background-color: rgb(239 68 68 / 0.95);
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 164 175 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-600{
  --tw-bg-opacity: 1;
  background-color: rgb(225 29 72 / var(--tw-bg-opacity, 1));
}
.bg-secondary-100{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-sky-400{
  --tw-bg-opacity: 1;
  background-color: rgb(56 189 248 / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(248 250 252 / var(--tw-bg-opacity, 1));
}
.bg-slate-500{
  --tw-bg-opacity: 1;
  background-color: rgb(100 116 139 / var(--tw-bg-opacity, 1));
}
.bg-success-100{
  background-color: rgba(37, 99, 235, 0.16);
}
.bg-success-50{
  background-color: rgba(37, 99, 235, 0.10);
}
.bg-success-500{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-teal-100{
  --tw-bg-opacity: 1;
  background-color: rgb(204 251 241 / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(237 233 254 / var(--tw-bg-opacity, 1));
}
.bg-violet-100\\/60{
  background-color: rgb(237 233 254 / 0.6);
}
.bg-violet-300{
  --tw-bg-opacity: 1;
  background-color: rgb(196 181 253 / var(--tw-bg-opacity, 1));
}
.bg-violet-400\\/20{
  background-color: rgb(167 139 250 / 0.2);
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/50{
  background-color: rgb(245 243 255 / 0.5);
}
.bg-violet-50\\/60{
  background-color: rgb(245 243 255 / 0.6);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(139 92 246 / var(--tw-bg-opacity, 1));
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(124 58 237 / var(--tw-bg-opacity, 1));
}
.bg-violet-600\\/95{
  background-color: rgb(124 58 237 / 0.95);
}
.bg-violet-700{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1));
}
.bg-warning-100{
  background-color: rgba(37, 99, 235, 0.16);
}
.bg-warning-50{
  background-color: rgba(37, 99, 235, 0.10);
}
.bg-warning-50\\/60{
  background-color: rgba(37, 99, 235, 0.6);
}
.bg-warning-500{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/15{
  background-color: rgb(255 255 255 / 0.15);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/5{
  background-color: rgb(255 255 255 / 0.05);
}
.bg-white\\/50{
  background-color: rgb(255 255 255 / 0.5);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-white\\/\\[0\\.03\\]{
  background-color: rgb(255 255 255 / 0.03);
}
.bg-white\\/\\[0\\.04\\]{
  background-color: rgb(255 255 255 / 0.04);
}
.bg-white\\/\\[0\\.06\\]{
  background-color: rgb(255 255 255 / 0.06);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-300{
  --tw-bg-opacity: 1;
  background-color: rgb(253 224 71 / var(--tw-bg-opacity, 1));
}
.bg-yellow-400{
  --tw-bg-opacity: 1;
  background-color: rgb(250 204 21 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.bg-opacity-40{
  --tw-bg-opacity: 0.4;
}
.bg-opacity-50{
  --tw-bg-opacity: 0.5;
}
.bg-opacity-60{
  --tw-bg-opacity: 0.6;
}
.bg-opacity-75{
  --tw-bg-opacity: 0.75;
}
.bg-\\[linear-gradient\\(180deg\\2c \\#fafafc_0\\%\\2c \\#f3f4f9_100\\%\\)\\]{
  background-image: linear-gradient(180deg,#fafafc 0%,#f3f4f9 100%);
}
.bg-\\[radial-gradient\\(circle_at_center\\2c _rgba\\(255\\2c 255\\2c 255\\2c 0\\.12\\)_0\\%\\2c _transparent_70\\%\\)\\]{
  background-image: radial-gradient(circle at center, rgba(255,255,255,0.12) 0%, transparent 70%);
}
.bg-\\[radial-gradient\\(circle_at_center\\2c _rgba\\(255\\2c 255\\2c 255\\2c 0\\.15\\)_0\\%\\2c _transparent_70\\%\\)\\]{
  background-image: radial-gradient(circle at center, rgba(255,255,255,0.15) 0%, transparent 70%);
}
.bg-\\[radial-gradient\\(ellipse_at_top_right\\2c _rgba\\(99\\2c 102\\2c 241\\2c 0\\.15\\)\\2c _transparent_55\\%\\)\\]{
  background-image: radial-gradient(ellipse at top right, rgba(99,102,241,0.15), transparent 55%);
}
.bg-gradient-dashboard-hero{
  background-image: none;
}
.bg-gradient-dashboard-primary{
  background-image: none;
}
.bg-gradient-dashboard-soft{
  background-image: none;
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--tw-gradient-stops));
}
.from-\\[\\#0c0c14\\]{
  --tw-gradient-from: #0c0c14 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(12 12 20 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1a0533\\]{
  --tw-gradient-from: #1a0533 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 5 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1a0533\\]\\/60{
  --tw-gradient-from: rgb(26 5 51 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 5 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1a0533\\]\\/90{
  --tw-gradient-from: rgb(26 5 51 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(26 5 51 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1d1148\\]{
  --tw-gradient-from: #1d1148 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 17 72 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#1d1148\\]\\/95{
  --tw-gradient-from: rgb(29 17 72 / 0.95) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 17 72 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#4c1d95\\]{
  --tw-gradient-from: #4c1d95 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(76 29 149 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#6366f1\\]{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-\\[\\#feda75\\]{
  --tw-gradient-from: #feda75 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 218 117 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-100{
  --tw-gradient-from: #fef3c7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 243 199 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-400{
  --tw-gradient-from: #fbbf24 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 191 36 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-50{
  --tw-gradient-from: #fffbeb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 251 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500{
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/30{
  --tw-gradient-from: rgb(0 0 0 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/55{
  --tw-gradient-from: rgb(0 0 0 / 0.55) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/70{
  --tw-gradient-from: rgb(0 0 0 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/75{
  --tw-gradient-from: rgb(0 0 0 / 0.75) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/80{
  --tw-gradient-from: rgb(0 0 0 / 0.8) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-black\\/85{
  --tw-gradient-from: rgb(0 0 0 / 0.85) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-100{
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400{
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400\\/30{
  --tw-gradient-from: rgb(96 165 250 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400\\/40{
  --tw-gradient-from: rgb(96 165 250 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50{
  --tw-gradient-from: #eff6ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500\\/40{
  --tw-gradient-from: rgb(59 130 246 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500{
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-100{
  --tw-gradient-from: #d1fae5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 250 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-400{
  --tw-gradient-from: #34d399 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(52 211 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-50\\/70{
  --tw-gradient-from: rgb(236 253 245 / 0.7) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 253 245 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-200{
  --tw-gradient-from: #e5e7eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(229 231 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-300{
  --tw-gradient-from: #d1d5db var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 213 219 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50{
  --tw-gradient-from: #f9fafb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 250 251 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-700{
  --tw-gradient-from: #374151 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(55 65 81 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-800{
  --tw-gradient-from: #1f2937 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(31 41 55 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-900{
  --tw-gradient-from: #111827 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(17 24 39 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-100{
  --tw-gradient-from: #dcfce7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(220 252 231 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-400{
  --tw-gradient-from: #4ade80 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(74 222 128 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50{
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500{
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-100{
  --tw-gradient-from: #e0e7ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(224 231 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-300{
  --tw-gradient-from: #a5b4fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(165 180 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400{
  --tw-gradient-from: #818cf8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-400\\/30{
  --tw-gradient-from: rgb(129 140 248 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(129 140 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50{
  --tw-gradient-from: #eef2ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/50{
  --tw-gradient-from: rgb(238 242 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-50\\/60{
  --tw-gradient-from: rgb(238 242 255 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(238 242 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: #6366f1 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-600{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lp-background\\/50{
  --tw-gradient-from: rgb(16 19 26 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 19 26 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-lp-background\\/60{
  --tw-gradient-from: rgb(16 19 26 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 19 26 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-300{
  --tw-gradient-from: #D1D5DB var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(209 213 219 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-neutral-400{
  --tw-gradient-from: #9CA3AF var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(156 163 175 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-300{
  --tw-gradient-from: #fdba74 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 186 116 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-400{
  --tw-gradient-from: #fb923c var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(251 146 60 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-50{
  --tw-gradient-from: #fff7ed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 247 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500{
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-100{
  --tw-gradient-from: #fce7f3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(252 231 243 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-400\\/40{
  --tw-gradient-from: rgb(244 114 182 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(244 114 182 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-50{
  --tw-gradient-from: #fdf2f8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 242 248 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500{
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-100{
  --tw-gradient-from: #dbeafe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(219 234 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-300{
  --tw-gradient-from: #93c5fd var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 197 253 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-400{
  --tw-gradient-from: #60a5fa var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(96 165 250 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-50\\/50{
  --tw-gradient-from: rgb(239 246 255 / 0.5) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 246 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-500{
  --tw-gradient-from: #3b82f6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(59 130 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-600{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-primary-700{
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-100{
  --tw-gradient-from: #f3e8ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(243 232 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-300{
  --tw-gradient-from: #d8b4fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(216 180 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-400{
  --tw-gradient-from: #c084fc var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-400\\/40{
  --tw-gradient-from: rgb(192 132 252 / 0.4) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(192 132 252 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50{
  --tw-gradient-from: #faf5ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 245 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: #a855f7 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500\\/30{
  --tw-gradient-from: rgb(168 85 247 / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(168 85 247 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-600{
  --tw-gradient-from: #9333ea var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(147 51 234 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-700{
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-900{
  --tw-gradient-from: #581c87 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-900\\/60{
  --tw-gradient-from: rgb(88 28 135 / 0.6) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-900\\/90{
  --tw-gradient-from: rgb(88 28 135 / 0.9) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(88 28 135 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-100{
  --tw-gradient-from: #fee2e2 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 226 226 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-100{
  --tw-gradient-from: #f1f5f9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(241 245 249 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-slate-500{
  --tw-gradient-from: #64748b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(100 116 139 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent{
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-100{
  --tw-gradient-from: #ede9fe var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(237 233 254 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-50{
  --tw-gradient-from: #f5f3ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 243 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500{
  --tw-gradient-from: #8b5cf6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-500\\/20{
  --tw-gradient-from: rgb(139 92 246 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-600{
  --tw-gradient-from: #7c3aed var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(124 58 237 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-violet-700{
  --tw-gradient-from: #6d28d9 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(109 40 217 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-100{
  --tw-gradient-from: #fef9c3 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(254 249 195 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-400{
  --tw-gradient-from: #facc15 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(250 204 21 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-500{
  --tw-gradient-from: #eab308 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(234 179 8 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-\\[\\#161628\\]{
  --tw-gradient-to: rgb(22 22 40 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #161628 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#1a0533\\]\\/80{
  --tw-gradient-to: rgb(26 5 51 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(26 5 51 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#1d1148\\]\\/70{
  --tw-gradient-to: rgb(29 17 72 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(29 17 72 / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#1e1145\\]{
  --tw-gradient-to: rgb(30 17 69 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1e1145 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#3d2a7a\\]\\/70{
  --tw-gradient-to: rgb(61 42 122 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(61 42 122 / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#3d2a7a\\]\\/75{
  --tw-gradient-to: rgb(61 42 122 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(61 42 122 / 0.75) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-\\[\\#fa7e1e\\]{
  --tw-gradient-to: rgb(250 126 30 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fa7e1e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/10{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/20{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-black\\/40{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(0 0 0 / 0.4) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-cyan-500{
  --tw-gradient-to: rgb(6 182 212 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #06b6d4 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-emerald-50{
  --tw-gradient-to: rgb(236 253 245 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ecfdf5 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-300{
  --tw-gradient-to: rgb(165 180 252 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a5b4fc var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-500\\/20{
  --tw-gradient-to: rgb(99 102 241 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(99 102 241 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-600{
  --tw-gradient-to: rgb(79 70 229 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #4f46e5 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-indigo-800{
  --tw-gradient-to: rgb(55 48 163 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #3730a3 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-500{
  --tw-gradient-to: rgb(249 115 22 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f97316 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-pink-500{
  --tw-gradient-to: rgb(236 72 153 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ec4899 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-primary-600{
  --tw-gradient-to: rgb(37 99 235 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #2563eb var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-100{
  --tw-gradient-to: rgb(243 232 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f3e8ff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-50\\/50{
  --tw-gradient-to: rgb(250 245 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(250 245 255 / 0.5) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-500{
  --tw-gradient-to: rgb(168 85 247 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #a855f7 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-600{
  --tw-gradient-to: rgb(147 51 234 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #9333ea var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-700{
  --tw-gradient-to: rgb(126 34 206 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #7e22ce var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-800{
  --tw-gradient-to: rgb(107 33 168 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6b21a8 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-purple-800\\/70{
  --tw-gradient-to: rgb(107 33 168 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(107 33 168 / 0.7) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-red-500{
  --tw-gradient-to: rgb(239 68 68 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #ef4444 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-rose-500{
  --tw-gradient-to: rgb(244 63 94 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #f43f5e var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-transparent{
  --tw-gradient-to: rgb(0 0 0 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), transparent var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-violet-700{
  --tw-gradient-to: rgb(109 40 217 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #6d28d9 var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/20{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.2) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white\\/30{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.3) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#0f1a3a\\]{
  --tw-gradient-to: #0f1a3a var(--tw-gradient-to-position);
}
.to-\\[\\#0f1a3d\\]{
  --tw-gradient-to: #0f1a3d var(--tw-gradient-to-position);
}
.to-\\[\\#0f1a3d\\]\\/70{
  --tw-gradient-to: rgb(15 26 61 / 0.7) var(--tw-gradient-to-position);
}
.to-\\[\\#3d2a7a\\]\\/30{
  --tw-gradient-to: rgb(61 42 122 / 0.3) var(--tw-gradient-to-position);
}
.to-\\[\\#3d2a7a\\]\\/35{
  --tw-gradient-to: rgb(61 42 122 / 0.35) var(--tw-gradient-to-position);
}
.to-\\[\\#6d28d9\\]{
  --tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);
}
.to-\\[\\#8b5cf6\\]{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-\\[\\#d62976\\]{
  --tw-gradient-to: #d62976 var(--tw-gradient-to-position);
}
.to-amber-400{
  --tw-gradient-to: #fbbf24 var(--tw-gradient-to-position);
}
.to-amber-50{
  --tw-gradient-to: #fffbeb var(--tw-gradient-to-position);
}
.to-amber-500{
  --tw-gradient-to: #f59e0b var(--tw-gradient-to-position);
}
.to-amber-600{
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}
.to-black\\/0{
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
}
.to-black\\/20{
  --tw-gradient-to: rgb(0 0 0 / 0.2) var(--tw-gradient-to-position);
}
.to-blue-400{
  --tw-gradient-to: #60a5fa var(--tw-gradient-to-position);
}
.to-blue-50{
  --tw-gradient-to: #eff6ff var(--tw-gradient-to-position);
}
.to-blue-500{
  --tw-gradient-to: #3b82f6 var(--tw-gradient-to-position);
}
.to-blue-500\\/20{
  --tw-gradient-to: rgb(59 130 246 / 0.2) var(--tw-gradient-to-position);
}
.to-blue-500\\/30{
  --tw-gradient-to: rgb(59 130 246 / 0.3) var(--tw-gradient-to-position);
}
.to-blue-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-cyan-100{
  --tw-gradient-to: #cffafe var(--tw-gradient-to-position);
}
.to-cyan-400{
  --tw-gradient-to: #22d3ee var(--tw-gradient-to-position);
}
.to-cyan-400\\/30{
  --tw-gradient-to: rgb(34 211 238 / 0.3) var(--tw-gradient-to-position);
}
.to-cyan-500{
  --tw-gradient-to: #06b6d4 var(--tw-gradient-to-position);
}
.to-cyan-600{
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-100{
  --tw-gradient-to: #d1fae5 var(--tw-gradient-to-position);
}
.to-emerald-50{
  --tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);
}
.to-emerald-50\\/40{
  --tw-gradient-to: rgb(236 253 245 / 0.4) var(--tw-gradient-to-position);
}
.to-emerald-500{
  --tw-gradient-to: #10b981 var(--tw-gradient-to-position);
}
.to-emerald-600{
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-gray-100{
  --tw-gradient-to: #f3f4f6 var(--tw-gradient-to-position);
}
.to-gray-400{
  --tw-gradient-to: #9ca3af var(--tw-gradient-to-position);
}
.to-gray-900{
  --tw-gradient-to: #111827 var(--tw-gradient-to-position);
}
.to-green-500{
  --tw-gradient-to: #22c55e var(--tw-gradient-to-position);
}
.to-indigo-100{
  --tw-gradient-to: #e0e7ff var(--tw-gradient-to-position);
}
.to-indigo-200{
  --tw-gradient-to: #c7d2fe var(--tw-gradient-to-position);
}
.to-indigo-400{
  --tw-gradient-to: #818cf8 var(--tw-gradient-to-position);
}
.to-indigo-400\\/40{
  --tw-gradient-to: rgb(129 140 248 / 0.4) var(--tw-gradient-to-position);
}
.to-indigo-50{
  --tw-gradient-to: #eef2ff var(--tw-gradient-to-position);
}
.to-indigo-50\\/40{
  --tw-gradient-to: rgb(238 242 255 / 0.4) var(--tw-gradient-to-position);
}
.to-indigo-500{
  --tw-gradient-to: #6366f1 var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: #4f46e5 var(--tw-gradient-to-position);
}
.to-indigo-700{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}
.to-indigo-800{
  --tw-gradient-to: #3730a3 var(--tw-gradient-to-position);
}
.to-indigo-900{
  --tw-gradient-to: #312e81 var(--tw-gradient-to-position);
}
.to-indigo-950\\/50{
  --tw-gradient-to: rgb(30 27 75 / 0.5) var(--tw-gradient-to-position);
}
.to-neutral-400{
  --tw-gradient-to: #9CA3AF var(--tw-gradient-to-position);
}
.to-neutral-500{
  --tw-gradient-to: #6B7280 var(--tw-gradient-to-position);
}
.to-orange-100{
  --tw-gradient-to: #ffedd5 var(--tw-gradient-to-position);
}
.to-orange-400{
  --tw-gradient-to: #fb923c var(--tw-gradient-to-position);
}
.to-orange-50{
  --tw-gradient-to: #fff7ed var(--tw-gradient-to-position);
}
.to-orange-500{
  --tw-gradient-to: #f97316 var(--tw-gradient-to-position);
}
.to-orange-600{
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-pink-300{
  --tw-gradient-to: #f9a8d4 var(--tw-gradient-to-position);
}
.to-pink-400{
  --tw-gradient-to: #f472b6 var(--tw-gradient-to-position);
}
.to-pink-500{
  --tw-gradient-to: #ec4899 var(--tw-gradient-to-position);
}
.to-primary-100\\/30{
  --tw-gradient-to: rgb(219 234 254 / 0.3) var(--tw-gradient-to-position);
}
.to-primary-200{
  --tw-gradient-to: #bfdbfe var(--tw-gradient-to-position);
}
.to-primary-600{
  --tw-gradient-to: #2563eb var(--tw-gradient-to-position);
}
.to-primary-700{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}
.to-primary-800{
  --tw-gradient-to: #1e40af var(--tw-gradient-to-position);
}
.to-purple-100{
  --tw-gradient-to: #f3e8ff var(--tw-gradient-to-position);
}
.to-purple-200{
  --tw-gradient-to: #e9d5ff var(--tw-gradient-to-position);
}
.to-purple-400{
  --tw-gradient-to: #c084fc var(--tw-gradient-to-position);
}
.to-purple-400\\/30{
  --tw-gradient-to: rgb(192 132 252 / 0.3) var(--tw-gradient-to-position);
}
.to-purple-400\\/40{
  --tw-gradient-to: rgb(192 132 252 / 0.4) var(--tw-gradient-to-position);
}
.to-purple-50{
  --tw-gradient-to: #faf5ff var(--tw-gradient-to-position);
}
.to-purple-50\\/40{
  --tw-gradient-to: rgb(250 245 255 / 0.4) var(--tw-gradient-to-position);
}
.to-purple-500{
  --tw-gradient-to: #a855f7 var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: #9333ea var(--tw-gradient-to-position);
}
.to-purple-700{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}
.to-red-500{
  --tw-gradient-to: #ef4444 var(--tw-gradient-to-position);
}
.to-red-600{
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-rose-100{
  --tw-gradient-to: #ffe4e6 var(--tw-gradient-to-position);
}
.to-rose-400{
  --tw-gradient-to: #fb7185 var(--tw-gradient-to-position);
}
.to-rose-50{
  --tw-gradient-to: #fff1f2 var(--tw-gradient-to-position);
}
.to-rose-500{
  --tw-gradient-to: #f43f5e var(--tw-gradient-to-position);
}
.to-rose-600{
  --tw-gradient-to: #e11d48 var(--tw-gradient-to-position);
}
.to-slate-200{
  --tw-gradient-to: #e2e8f0 var(--tw-gradient-to-position);
}
.to-slate-900{
  --tw-gradient-to: #0f172a var(--tw-gradient-to-position);
}
.to-teal-400{
  --tw-gradient-to: #2dd4bf var(--tw-gradient-to-position);
}
.to-teal-50{
  --tw-gradient-to: #f0fdfa var(--tw-gradient-to-position);
}
.to-teal-500{
  --tw-gradient-to: #14b8a6 var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-transparent{
  --tw-gradient-to: transparent var(--tw-gradient-to-position);
}
.to-violet-400\\/60{
  --tw-gradient-to: rgb(167 139 250 / 0.6) var(--tw-gradient-to-position);
}
.to-violet-50{
  --tw-gradient-to: #f5f3ff var(--tw-gradient-to-position);
}
.to-violet-50\\/30{
  --tw-gradient-to: rgb(245 243 255 / 0.3) var(--tw-gradient-to-position);
}
.to-violet-500{
  --tw-gradient-to: #8b5cf6 var(--tw-gradient-to-position);
}
.to-violet-500\\/40{
  --tw-gradient-to: rgb(139 92 246 / 0.4) var(--tw-gradient-to-position);
}
.to-violet-600{
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}
.to-violet-700{
  --tw-gradient-to: #6d28d9 var(--tw-gradient-to-position);
}
.to-white{
  --tw-gradient-to: #fff var(--tw-gradient-to-position);
}
.to-yellow-100{
  --tw-gradient-to: #fef9c3 var(--tw-gradient-to-position);
}
.to-yellow-50{
  --tw-gradient-to: #fefce8 var(--tw-gradient-to-position);
}
.to-yellow-500{
  --tw-gradient-to: #eab308 var(--tw-gradient-to-position);
}
.bg-clip-text{
  background-clip: text;
}
.fill-amber-400{
  fill: #fbbf24;
}
.fill-current{
  fill: currentColor;
}
.fill-indigo-500{
  fill: #6366f1;
}
.fill-white{
  fill: #fff;
}
.fill-yellow-500{
  fill: #eab308;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.object-top{
  object-position: top;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 2px;
}
.p-1{
  padding: 4px;
}
.p-1\\.5{
  padding: 6px;
}
.p-10{
  padding: 40px;
}
.p-12{
  padding: 48px;
}
.p-16{
  padding: 64px;
}
.p-2{
  padding: 8px;
}
.p-2\\.5{
  padding: 10px;
}
.p-3{
  padding: 12px;
}
.p-3\\.5{
  padding: 14px;
}
.p-4{
  padding: 16px;
}
.p-5{
  padding: 20px;
}
.p-6{
  padding: 24px;
}
.p-7{
  padding: 28px;
}
.p-8{
  padding: 32px;
}
.p-\\[2px\\]{
  padding: 2px;
}
.p-lp-base{
  padding: 4px;
}
.p-lp-md{
  padding: 24px;
}
.p-lp-sm{
  padding: 16px;
}
.p-lp-xl{
  padding: 80px;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-0\\.5{
  padding-left: 2px;
  padding-right: 2px;
}
.px-1{
  padding-left: 4px;
  padding-right: 4px;
}
.px-1\\.5{
  padding-left: 6px;
  padding-right: 6px;
}
.px-2{
  padding-left: 8px;
  padding-right: 8px;
}
.px-2\\.5{
  padding-left: 10px;
  padding-right: 10px;
}
.px-3{
  padding-left: 12px;
  padding-right: 12px;
}
.px-3\\.5{
  padding-left: 14px;
  padding-right: 14px;
}
.px-4{
  padding-left: 16px;
  padding-right: 16px;
}
.px-5{
  padding-left: 20px;
  padding-right: 20px;
}
.px-6{
  padding-left: 24px;
  padding-right: 24px;
}
.px-7{
  padding-left: 28px;
  padding-right: 28px;
}
.px-8{
  padding-left: 32px;
  padding-right: 32px;
}
.px-lp-md{
  padding-left: 24px;
  padding-right: 24px;
}
.px-lp-sm{
  padding-left: 16px;
  padding-right: 16px;
}
.px-lp-xl{
  padding-left: 80px;
  padding-right: 80px;
}
.py-0\\.5{
  padding-top: 2px;
  padding-bottom: 2px;
}
.py-1{
  padding-top: 4px;
  padding-bottom: 4px;
}
.py-1\\.5{
  padding-top: 6px;
  padding-bottom: 6px;
}
.py-10{
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-12{
  padding-top: 48px;
  padding-bottom: 48px;
}
.py-16{
  padding-top: 64px;
  padding-bottom: 64px;
}
.py-2{
  padding-top: 8px;
  padding-bottom: 8px;
}
.py-2\\.5{
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-20{
  padding-top: 80px;
  padding-bottom: 80px;
}
.py-3{
  padding-top: 12px;
  padding-bottom: 12px;
}
.py-3\\.5{
  padding-top: 14px;
  padding-bottom: 14px;
}
.py-4{
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-5{
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-6{
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-7{
  padding-top: 28px;
  padding-bottom: 28px;
}
.py-8{
  padding-top: 32px;
  padding-bottom: 32px;
}
.py-\\[5px\\]{
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-lp-lg{
  padding-top: 40px;
  padding-bottom: 40px;
}
.py-lp-md{
  padding-top: 24px;
  padding-bottom: 24px;
}
.py-lp-sm{
  padding-top: 16px;
  padding-bottom: 16px;
}
.py-lp-xl{
  padding-top: 80px;
  padding-bottom: 80px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 2px;
}
.pb-1{
  padding-bottom: 4px;
}
.pb-10{
  padding-bottom: 40px;
}
.pb-16{
  padding-bottom: 64px;
}
.pb-2{
  padding-bottom: 8px;
}
.pb-20{
  padding-bottom: 80px;
}
.pb-24{
  padding-bottom: 96px;
}
.pb-3{
  padding-bottom: 12px;
}
.pb-4{
  padding-bottom: 16px;
}
.pb-5{
  padding-bottom: 20px;
}
.pb-6{
  padding-bottom: 24px;
}
.pb-8{
  padding-bottom: 32px;
}
.pb-lp-lg{
  padding-bottom: 40px;
}
.pb-lp-xl{
  padding-bottom: 80px;
}
.pl-1{
  padding-left: 4px;
}
.pl-10{
  padding-left: 40px;
}
.pl-11{
  padding-left: 44px;
}
.pl-12{
  padding-left: 48px;
}
.pl-2{
  padding-left: 8px;
}
.pl-3{
  padding-left: 12px;
}
.pl-3\\.5{
  padding-left: 14px;
}
.pl-4{
  padding-left: 16px;
}
.pl-6{
  padding-left: 24px;
}
.pl-7{
  padding-left: 28px;
}
.pl-8{
  padding-left: 32px;
}
.pl-9{
  padding-left: 36px;
}
.pr-0{
  padding-right: 0px;
}
.pr-1{
  padding-right: 4px;
}
.pr-10{
  padding-right: 40px;
}
.pr-12{
  padding-right: 48px;
}
.pr-16{
  padding-right: 64px;
}
.pr-2{
  padding-right: 8px;
}
.pr-24{
  padding-right: 96px;
}
.pr-3{
  padding-right: 12px;
}
.pr-4{
  padding-right: 16px;
}
.pr-7{
  padding-right: 28px;
}
.pr-8{
  padding-right: 32px;
}
.pr-9{
  padding-right: 36px;
}
.pt-0{
  padding-top: 0px;
}
.pt-0\\.5{
  padding-top: 2px;
}
.pt-1{
  padding-top: 4px;
}
.pt-1\\.5{
  padding-top: 6px;
}
.pt-12{
  padding-top: 48px;
}
.pt-14{
  padding-top: 56px;
}
.pt-16{
  padding-top: 64px;
}
.pt-2{
  padding-top: 8px;
}
.pt-24{
  padding-top: 96px;
}
.pt-28{
  padding-top: 112px;
}
.pt-3{
  padding-top: 12px;
}
.pt-4{
  padding-top: 16px;
}
.pt-40{
  padding-top: 160px;
}
.pt-5{
  padding-top: 20px;
}
.pt-6{
  padding-top: 24px;
}
.pt-lp-lg{
  padding-top: 40px;
}
.pt-lp-md{
  padding-top: 24px;
}
.pt-lp-xl{
  padding-top: 80px;
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.align-middle{
  vertical-align: middle;
}
.font-lp-body{
  font-family: Inter, sans-serif;
}
.font-lp-headline{
  font-family: "Plus Jakarta Sans", Inter, sans-serif;
}
.font-lp-label{
  font-family: "Hanken Grotesk", Inter, sans-serif;
}
.font-mono{
  font-family: JetBrains Mono, Fira Code, monospace;
}
.font-sans{
  font-family: Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif;
}
.font-serif{
  font-family: ui-serif, Georgia, Cambria, "Times New Roman", Times, serif;
}
.text-2xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: -0.02em;
}
.text-3xl{
  font-size: 1.5rem;
  line-height: 2rem;
  letter-spacing: -0.02em;
}
.text-4xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
  letter-spacing: -0.025em;
}
.text-5xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
  letter-spacing: -0.025em;
}
.text-\\[10\\.5px\\]{
  font-size: 10.5px;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11\\.5px\\]{
  font-size: 11.5px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12\\.5px\\]{
  font-size: 12.5px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[13\\.5px\\]{
  font-size: 13.5px;
}
.text-\\[13px\\]{
  font-size: 13px;
}
.text-\\[14\\.5px\\]{
  font-size: 14.5px;
}
.text-\\[14px\\]{
  font-size: 14px;
}
.text-\\[15\\.5px\\]{
  font-size: 15.5px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[17px\\]{
  font-size: 17px;
}
.text-\\[18px\\]{
  font-size: 18px;
}
.text-\\[20px\\]{
  font-size: 20px;
}
.text-\\[22px\\]{
  font-size: 22px;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[26px\\]{
  font-size: 26px;
}
.text-\\[28px\\]{
  font-size: 28px;
}
.text-\\[44px\\]{
  font-size: 44px;
}
.text-\\[56px\\]{
  font-size: 56px;
}
.text-\\[6px\\]{
  font-size: 6px;
}
.text-\\[7px\\]{
  font-size: 7px;
}
.text-\\[80px\\]{
  font-size: 80px;
}
.text-\\[8px\\]{
  font-size: 8px;
}
.text-\\[9\\.5px\\]{
  font-size: 9.5px;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 0.875rem;
  line-height: 1.375rem;
  letter-spacing: 0;
}
.text-lg{
  font-size: 1rem;
  line-height: 1.5rem;
  letter-spacing: -0.01em;
}
.text-lp-body-lg{
  font-size: 18px;
  line-height: 1.6;
  font-weight: 400;
}
.text-lp-body-md{
  font-size: 16px;
  line-height: 1.5;
  font-weight: 400;
}
.text-lp-body-sm{
  font-size: 14px;
  line-height: 1.5;
  font-weight: 400;
}
.text-lp-headline-lg{
  font-size: 32px;
  line-height: 1.2;
  letter-spacing: -0.03em;
  font-weight: 700;
}
.text-lp-headline-md{
  font-size: 24px;
  line-height: 1.3;
  font-weight: 700;
}
.text-lp-headline-sm{
  font-size: 20px;
  line-height: 1.4;
  font-weight: 600;
}
.text-lp-headline-xl{
  font-size: 48px;
  line-height: 1.1;
  letter-spacing: -0.04em;
  font-weight: 700;
}
.text-lp-headline-xl-mobile{
  font-size: 36px;
  line-height: 1.1;
  font-weight: 700;
}
.text-lp-label-caps{
  font-size: 12px;
  line-height: 1;
  letter-spacing: 0.1em;
  font-weight: 700;
}
.text-md{
  font-size: 0.9375rem;
  line-height: 1.5rem;
  letter-spacing: -0.01em;
}
.text-sm{
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0;
}
.text-xl{
  font-size: 1.125rem;
  line-height: 1.75rem;
  letter-spacing: -0.015em;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
  letter-spacing: 0.01em;
}
.font-black{
  font-weight: 900;
}
.font-bold{
  font-weight: 700;
}
.font-extrabold{
  font-weight: 800;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.not-italic{
  font-style: normal;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-7{
  line-height: 1.75rem;
}
.leading-\\[1\\.2\\]{
  line-height: 1.2;
}
.leading-\\[1\\.6\\]{
  line-height: 1.6;
}
.leading-\\[1\\.85\\]{
  line-height: 1.85;
}
.leading-none{
  line-height: 1;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.08em\\]{
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.2em\\]{
  letter-spacing: 0.2em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-tighter{
  letter-spacing: -0.05em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#111827\\]{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1a1408\\]{
  --tw-text-opacity: 1;
  color: rgb(26 20 8 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2563EB\\]{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-\\[\\#2563eb\\]\\/20{
  color: rgb(37 99 235 / 0.2);
}
.text-\\[\\#2c2419\\]{
  --tw-text-opacity: 1;
  color: rgb(44 36 25 / var(--tw-text-opacity, 1));
}
.text-\\[\\#374151\\]{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-\\[\\#3d3428\\]{
  --tw-text-opacity: 1;
  color: rgb(61 52 40 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5c4f3f\\]{
  --tw-text-opacity: 1;
  color: rgb(92 79 63 / var(--tw-text-opacity, 1));
}
.text-\\[\\#60a5fa\\]{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6B7280\\]{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b5f4f\\]{
  --tw-text-opacity: 1;
  color: rgb(107 95 79 / var(--tw-text-opacity, 1));
}
.text-\\[\\#6b7280\\]{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-\\[\\#93c5fd\\]{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A1A8B8\\]{
  --tw-text-opacity: 1;
  color: rgb(161 168 184 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FFFFFF\\]{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a1a8b8\\]{
  --tw-text-opacity: 1;
  color: rgb(161 168 184 / var(--tw-text-opacity, 1));
}
.text-accent-500{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-accent-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-accent-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-400{
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-blue-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-blue-200{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}
.text-blue-300{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-blue-300\\/80{
  color: rgb(147 197 253 / 0.8);
}
.text-blue-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-blue-400\\/80{
  color: rgb(96 165 250 / 0.8);
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-blue-700\\/90{
  color: rgb(29 78 216 / 0.9);
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-cyan-600{
  --tw-text-opacity: 1;
  color: rgb(8 145 178 / var(--tw-text-opacity, 1));
}
.text-cyan-700{
  --tw-text-opacity: 1;
  color: rgb(14 116 144 / var(--tw-text-opacity, 1));
}
.text-dashboard-500{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-dashboard-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-dashboard-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-dashboard-800{
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity, 1));
}
.text-emerald-200{
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-400\\/90{
  color: rgb(52 211 153 / 0.9);
}
.text-emerald-500{
  --tw-text-opacity: 1;
  color: rgb(16 185 129 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-error-500{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-error-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-error-600\\/90{
  color: rgb(37 99 235 / 0.9);
}
.text-error-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-fuchsia-700{
  --tw-text-opacity: 1;
  color: rgb(162 28 175 / var(--tw-text-opacity, 1));
}
.text-gray-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-gray-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-green-400{
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-green-900{
  --tw-text-opacity: 1;
  color: rgb(20 83 45 / var(--tw-text-opacity, 1));
}
.text-indigo-100{
  --tw-text-opacity: 1;
  color: rgb(224 231 255 / var(--tw-text-opacity, 1));
}
.text-indigo-300{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}
.text-indigo-300\\/80{
  color: rgb(165 180 252 / 0.8);
}
.text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}
.text-indigo-400\\/40{
  color: rgb(129 140 248 / 0.4);
}
.text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}
.text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}
.text-indigo-700{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}
.text-indigo-900{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}
.text-info-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-info-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-inherit{
  color: inherit;
}
.text-lp-accent-cyan{
  --tw-text-opacity: 1;
  color: rgb(0 245 255 / var(--tw-text-opacity, 1));
}
.text-lp-accent-cyan\\/70{
  color: rgb(0 245 255 / 0.7);
}
.text-lp-accent-cyan\\/80{
  color: rgb(0 245 255 / 0.8);
}
.text-lp-on-background{
  --tw-text-opacity: 1;
  color: rgb(225 226 235 / var(--tw-text-opacity, 1));
}
.text-lp-on-primary-container{
  --tw-text-opacity: 1;
  color: rgb(0 3 24 / var(--tw-text-opacity, 1));
}
.text-lp-on-surface{
  --tw-text-opacity: 1;
  color: rgb(225 226 235 / var(--tw-text-opacity, 1));
}
.text-lp-on-surface-variant{
  --tw-text-opacity: 1;
  color: rgb(195 197 216 / var(--tw-text-opacity, 1));
}
.text-lp-on-surface-variant\\/60{
  color: rgb(195 197 216 / 0.6);
}
.text-lp-primary{
  --tw-text-opacity: 1;
  color: rgb(181 196 255 / var(--tw-text-opacity, 1));
}
.text-lp-primary-container{
  --tw-text-opacity: 1;
  color: rgb(47 107 255 / var(--tw-text-opacity, 1));
}
.text-lp-secondary{
  --tw-text-opacity: 1;
  color: rgb(206 189 255 / var(--tw-text-opacity, 1));
}
.text-neutral-100{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}
.text-neutral-200{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}
.text-neutral-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-neutral-400{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-neutral-500{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-neutral-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-neutral-700{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-neutral-800{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-neutral-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}
.text-orange-200{
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity, 1));
}
.text-orange-300{
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}
.text-orange-500{
  --tw-text-opacity: 1;
  color: rgb(249 115 22 / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-pink-500{
  --tw-text-opacity: 1;
  color: rgb(236 72 153 / var(--tw-text-opacity, 1));
}
.text-pink-600{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-primary-100{
  --tw-text-opacity: 1;
  color: rgb(219 234 254 / var(--tw-text-opacity, 1));
}
.text-primary-300{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}
.text-primary-400{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}
.text-primary-500{
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity, 1));
}
.text-primary-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-primary-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-primary-900{
  --tw-text-opacity: 1;
  color: rgb(30 58 138 / var(--tw-text-opacity, 1));
}
.text-purple-100{
  --tw-text-opacity: 1;
  color: rgb(243 232 255 / var(--tw-text-opacity, 1));
}
.text-purple-200{
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}
.text-purple-300{
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}
.text-purple-300\\/70{
  color: rgb(216 180 254 / 0.7);
}
.text-purple-500{
  --tw-text-opacity: 1;
  color: rgb(168 85 247 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}
.text-purple-800{
  --tw-text-opacity: 1;
  color: rgb(107 33 168 / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-red-900{
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-500{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-secondary-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-sky-500{
  --tw-text-opacity: 1;
  color: rgb(14 165 233 / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}
.text-success-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-success-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-teal-600{
  --tw-text-opacity: 1;
  color: rgb(13 148 136 / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-violet-100\\/90{
  color: rgb(237 233 254 / 0.9);
}
.text-violet-200{
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}
.text-violet-300{
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}
.text-violet-300\\/80{
  color: rgb(196 181 253 / 0.8);
}
.text-violet-400{
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}
.text-violet-500{
  --tw-text-opacity: 1;
  color: rgb(139 92 246 / var(--tw-text-opacity, 1));
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}
.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(76 29 149 / var(--tw-text-opacity, 1));
}
.text-warning-500{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-warning-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-warning-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/20{
  color: rgb(255 255 255 / 0.2);
}
.text-white\\/30{
  color: rgb(255 255 255 / 0.3);
}
.text-white\\/40{
  color: rgb(255 255 255 / 0.4);
}
.text-white\\/50{
  color: rgb(255 255 255 / 0.5);
}
.text-white\\/55{
  color: rgb(255 255 255 / 0.55);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/65{
  color: rgb(255 255 255 / 0.65);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-white\\/95{
  color: rgb(255 255 255 / 0.95);
}
.text-yellow-300{
  --tw-text-opacity: 1;
  color: rgb(253 224 71 / var(--tw-text-opacity, 1));
}
.text-yellow-400{
  --tw-text-opacity: 1;
  color: rgb(250 204 21 / var(--tw-text-opacity, 1));
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900{
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.line-through{
  text-decoration-line: line-through;
}
.no-underline{
  text-decoration-line: none;
}
.decoration-white\\/30{
  text-decoration-color: rgb(255 255 255 / 0.3);
}
.underline-offset-4{
  text-underline-offset: 4px;
}
.underline-offset-8{
  text-underline-offset: 8px;
}
.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.placeholder-\\[\\#6B7280\\]::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.placeholder-gray-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-neutral-400::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(156 163 175 / var(--tw-placeholder-opacity, 1));
}
.placeholder-neutral-500::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}
.accent-blue-600{
  accent-color: #2563eb;
}
.accent-indigo-600{
  accent-color: #4f46e5;
}
.accent-purple-600{
  accent-color: #9333ea;
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-25{
  opacity: 0.25;
}
.opacity-30{
  opacity: 0.3;
}
.opacity-40{
  opacity: 0.4;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-75{
  opacity: 0.75;
}
.opacity-80{
  opacity: 0.8;
}
.opacity-90{
  opacity: 0.9;
}
.shadow{
  --tw-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 2px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 24px 48px -12px rgba(0, 0, 0, 0.12);
  --tw-shadow-colored: 0 24px 48px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_14px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 0 14px rgba(37,99,235,0.55);
  --tw-shadow-colored: 0 0 14px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_24px_rgba\\(47\\2c 107\\2c 255\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 0 24px rgba(47,107,255,0.25);
  --tw-shadow-colored: 0 0 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 0 40px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 0 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_50px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 0 50px rgba(0,0,0,0.5);
  --tw-shadow-colored: 0 0 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_30px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 10px 30px rgba(255,255,255,0.2);
  --tw-shadow-colored: 0 10px 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_16px_40px_rgba\\(47\\2c 107\\2c 255\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 16px 40px rgba(47,107,255,0.35);
  --tw-shadow-colored: 0 16px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_44px_-22px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 18px 44px -22px rgba(15,23,42,0.35);
  --tw-shadow-colored: 0 18px 44px -22px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_44px_-22px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.5\\)\\]{
  --tw-shadow: 0 18px 44px -22px rgba(15,23,42,0.5);
  --tw-shadow-colored: 0 18px 44px -22px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.03\\)\\]{
  --tw-shadow: 0 1px 2px rgba(0,0,0,0.03);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 1px 2px rgba(15,23,42,0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(139\\2c 92\\2c 246\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 1px 3px rgba(139,92,246,0.06);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_3px_rgba\\(99\\2c 102\\2c 241\\2c 0\\.06\\)\\]{
  --tw-shadow: 0 1px 3px rgba(99,102,241,0.06);
  --tw-shadow-colored: 0 1px 3px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_4px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 1px 4px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 1px 4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_6px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
  --tw-shadow: 0 1px 6px rgba(0,0,0,0.04);
  --tw-shadow-colored: 0 1px 6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_50px_rgba\\(47\\2c 107\\2c 255\\2c 0\\.4\\)\\]{
  --tw-shadow: 0 20px 50px rgba(47,107,255,0.4);
  --tw-shadow-colored: 0 20px 50px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_70px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.28\\)\\]{
  --tw-shadow: 0 24px 70px rgba(0,0,0,0.28);
  --tw-shadow-colored: 0 24px 70px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_2px_10px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.08\\)\\]{
  --tw-shadow: 0 2px 10px rgba(37,99,235,0.08);
  --tw-shadow-colored: 0 2px 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_30px_90px_-20px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.45\\)\\]{
  --tw-shadow: 0 30px 90px -20px rgba(15,23,42,0.45);
  --tw-shadow-colored: 0 30px 90px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_12px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.35\\)\\]{
  --tw-shadow: 0 4px 12px rgba(37,99,235,0.35);
  --tw-shadow-colored: 0 4px 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_-4px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 4px 14px -4px rgba(37,99,235,0.55);
  --tw-shadow-colored: 0 4px 14px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_4px_14px_-6px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 4px 14px -6px rgba(0,0,0,0.2);
  --tw-shadow-colored: 0 4px 14px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_6px_18px_-8px_rgba\\(124\\2c 58\\2c 237\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 6px 18px -8px rgba(124,58,237,0.55);
  --tw-shadow-colored: 0 6px 18px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_22px_-6px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.55\\)\\]{
  --tw-shadow: 0 8px 22px -6px rgba(37,99,235,0.55);
  --tw-shadow-colored: 0 8px 22px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_22px_-8px_rgba\\(124\\2c 58\\2c 237\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 8px 22px -8px rgba(124,58,237,0.6);
  --tw-shadow-colored: 0 8px 22px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_22px_-8px_rgba\\(37\\2c 99\\2c 235\\2c 0\\.6\\)\\]{
  --tw-shadow: 0 8px 22px -8px rgba(37,99,235,0.6);
  --tw-shadow-colored: 0 8px 22px -8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_-16px_rgba\\(15\\2c 23\\2c 42\\2c 0\\.25\\)\\]{
  --tw-shadow: 0 8px 24px -16px rgba(15,23,42,0.25);
  --tw-shadow-colored: 0 8px 24px -16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_24px_rgba\\(255\\2c 255\\2c 255\\2c 0\\.2\\)\\]{
  --tw-shadow: 0 8px 24px rgba(255,255,255,0.2);
  --tw-shadow-colored: 0 8px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.02);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-cta{
  --tw-shadow: 0 8px 20px rgba(37, 99, 235, 0.22);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-dropdown{
  --tw-shadow: 0 8px 24px -4px rgba(0, 0, 0, 0.1), 0 4px 8px -2px rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: 0 8px 24px -4px var(--tw-shadow-color), 0 4px 8px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.07), 0 4px 6px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 8px 16px -4px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 8px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-nav{
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 16px 32px -8px rgba(0, 0, 0, 0.08), 0 8px 16px -4px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 16px 32px -8px var(--tw-shadow-color), 0 8px 16px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-amber-500\\/20{
  --tw-shadow-color: rgb(245 158 11 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/10{
  --tw-shadow-color: rgb(0 0 0 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-black\\/5{
  --tw-shadow-color: rgb(0 0 0 / 0.05);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-blue-200{
  --tw-shadow-color: #bfdbfe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-200{
  --tw-shadow-color: #bbf7d0;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-green-200\\/50{
  --tw-shadow-color: rgb(187 247 208 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-200{
  --tw-shadow-color: #c7d2fe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-200\\/50{
  --tw-shadow-color: rgb(199 210 254 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-indigo-200\\/60{
  --tw-shadow-color: rgb(199 210 254 / 0.6);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-neutral-900\\/\\[0\\.03\\]{
  --tw-shadow-color: rgb(17 24 39 / 0.03);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-orange-200\\/50{
  --tw-shadow-color: rgb(254 215 170 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-pink-100{
  --tw-shadow-color: #fce7f3;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-600\\/10{
  --tw-shadow-color: rgb(37 99 235 / 0.1);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-600\\/25{
  --tw-shadow-color: rgb(37 99 235 / 0.25);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-primary-900\\/20{
  --tw-shadow-color: rgb(30 58 138 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-200\\/50{
  --tw-shadow-color: rgb(233 213 255 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-300{
  --tw-shadow-color: #d8b4fe;
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-purple-500\\/20{
  --tw-shadow-color: rgb(168 85 247 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-200\\/50{
  --tw-shadow-color: rgb(254 202 202 / 0.5);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-red-500\\/30{
  --tw-shadow-color: rgb(239 68 68 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}
.shadow-sky-200{
  --tw-shadow-color: #bae6fd;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-4{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#1e2230\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(30 34 48 / var(--tw-ring-opacity, 1));
}
.ring-\\[\\#2563eb\\]\\/25{
  --tw-ring-color: rgb(37 99 235 / 0.25);
}
.ring-\\[\\#2563eb\\]\\/60{
  --tw-ring-color: rgb(37 99 235 / 0.6);
}
.ring-\\[\\#2A3042\\]{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(42 48 66 / var(--tw-ring-opacity, 1));
}
.ring-black\\/5{
  --tw-ring-color: rgb(0 0 0 / 0.05);
}
.ring-blue-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}
.ring-dashboard-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}
.ring-dashboard-300{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}
.ring-emerald-500\\/10{
  --tw-ring-color: rgb(16 185 129 / 0.1);
}
.ring-gray-900{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(17 24 39 / var(--tw-ring-opacity, 1));
}
.ring-indigo-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}
.ring-lp-primary\\/5{
  --tw-ring-color: rgb(181 196 255 / 0.05);
}
.ring-neutral-100{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 244 246 / var(--tw-ring-opacity, 1));
}
.ring-primary-500\\/15{
  --tw-ring-color: rgb(59 130 246 / 0.15);
}
.ring-primary-500\\/20{
  --tw-ring-color: rgb(59 130 246 / 0.2);
}
.ring-purple-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(233 213 255 / var(--tw-ring-opacity, 1));
}
.ring-transparent{
  --tw-ring-color: transparent;
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.ring-white\\/30{
  --tw-ring-color: rgb(255 255 255 / 0.3);
}
.ring-white\\/50{
  --tw-ring-color: rgb(255 255 255 / 0.5);
}
.ring-white\\/60{
  --tw-ring-color: rgb(255 255 255 / 0.6);
}
.blur{
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-2xl{
  --tw-blur: blur(40px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[100px\\]{
  --tw-blur: blur(100px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[60px\\]{
  --tw-blur: blur(60px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-\\[80px\\]{
  --tw-blur: blur(80px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-md{
  --tw-blur: blur(12px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-sm{
  --tw-blur: blur(4px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.blur-xl{
  --tw-blur: blur(24px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow{
  --tw-drop-shadow: drop-shadow(0 1px 2px rgb(0 0 0 / 0.1)) drop-shadow(0 1px 1px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-md{
  --tw-drop-shadow: drop-shadow(0 4px 3px rgb(0 0 0 / 0.07)) drop-shadow(0 2px 2px rgb(0 0 0 / 0.06));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.drop-shadow-sm{
  --tw-drop-shadow: drop-shadow(0 1px 1px rgb(0 0 0 / 0.05));
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale-\\[20\\%\\]{
  --tw-grayscale: grayscale(20%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.sepia{
  --tw-sepia: sepia(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-md{
  --tw-backdrop-blur: blur(12px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-xl{
  --tw-backdrop-blur: blur(24px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-filter{
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\]{
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150{
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.duration-500{
  transition-duration: 500ms;
}
.duration-700{
  transition-duration: 700ms;
}
.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
/* Hide scrollbar */
.scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
.scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
/* Company dashboard — hide scrollbars on all scrollable regions */
.dashboard-no-scrollbar,
  .dashboard-no-scrollbar *,
  html.dashboard-no-scrollbar {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
.dashboard-no-scrollbar *::-webkit-scrollbar,
  html.dashboard-no-scrollbar::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }
/* Hover lift effect */
.hover-lift{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}
.hover-lift:hover{
  --tw-translate-y: -2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 8px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
/* Truncate multiline */
.line-clamp-2 {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
.line-clamp-3 {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

/* ─── BASE LAYER ─────────────────────────────────────────────────────── */

/* ─── COMPONENT LAYER ────────────────────────────────────────────────── */

/* ─── UTILITY LAYER ──────────────────────────────────────────────────── */

/* ─── CUSTOM ANIMATIONS ──────────────────────────────────────────────── */
@keyframes shimmer {
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
}

.animate-shimmer {
  animation: shimmer 2s infinite;
  background: linear-gradient(to right, #f3f4f6 4%, #e5e7eb 25%, #f3f4f6 36%);
  background-size: 1000px 100%;
}

/* ─── FALLBACKS ──────────────────────────────────────────────────────── */
@supports not (backdrop-filter: blur(10px)) {
  .glass,
  .glass-strong{
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }
html.dark .glass,html.dark 
  .glass-strong {
  background-color: #161628;
  border-color: rgba(255, 255, 255, 0.08);
}
.glass,
  .glass-strong {
  background-color: #171A23;
  border-color: #2A3042;
    backdrop-filter: none;
}
}

/*
 * Dark-mode legacy overrides — placed AFTER Tailwind utilities so they
 * beat raw bg-white / text-gray-* classes on unconverted components.
 */
html.dark .bg-white {
  background-color: #161628 !important;
}
html.dark .bg-white\\/95 {
  background-color: rgba(22, 22, 40, 0.95) !important;
}
html.dark .bg-white\\/90 {
  background-color: rgba(22, 22, 40, 0.9) !important;
}
html.dark .bg-white\\/70 {
  background-color: rgba(22, 22, 40, 0.55) !important;
}
html.dark .bg-gradient-dashboard-hero {
  background-image: linear-gradient(135deg, #1e1b4b 0%, rgba(49, 46, 129, 0.45) 50%, #12121f 100%) !important;
}
html.dark [data-testid="sidebar-nav"] a[data-active="true"] {
  background-image: none !important;
  background-color: rgba(99, 102, 241, 0.22) !important;
  color: #e0e7ff !important;
}
html.dark [data-testid="sidebar-nav"] a[data-active="true"] svg {
  color: #a5b4fc !important;
}
html.dark [data-testid="modal-dialog"] footer {
  background-color: #12121f !important;
}
html.dark [data-testid="multi-step-form"] > div:first-child > div:last-child {
  background-color: #12121f !important;
}
html.dark [data-testid="create-job-flow"] h2.text-base {
  color: #f5f5fa !important;
}
html.dark [data-testid="create-job-flow"] .text-neutral-500 {
  color: #a0a0b0 !important;
}
html.dark [data-testid="create-job-flow"] .text-dashboard-600 {
  color: #a5b4fc !important;
}
html.dark .bg-gray-50,
html.dark .bg-neutral-50,
html.dark .bg-slate-50 {
  background-color: rgba(255, 255, 255, 0.04) !important;
}
html.dark .bg-gray-100,
html.dark .bg-neutral-100,
html.dark .bg-slate-100 {
  background-color: rgba(255, 255, 255, 0.06) !important;
}
html.dark .border-neutral-200,
html.dark .border-gray-200,
html.dark .border-slate-200,
html.dark .border-neutral-200\\/60,
html.dark .border-gray-200\\/60,
html.dark .border-neutral-200\\/80,
html.dark .border-gray-200\\/80 {
  border-color: rgba(255, 255, 255, 0.08) !important;
}
html.dark .border-neutral-100,
html.dark .border-gray-100,
html.dark .divide-neutral-100 > :not([hidden]) ~ :not([hidden]),
html.dark .divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  border-color: rgba(255, 255, 255, 0.06) !important;
}
html.dark .text-neutral-900,
html.dark .text-gray-900,
html.dark .text-slate-900 {
  color: #f5f5fa !important;
}
html.dark .text-neutral-800,
html.dark .text-gray-800,
html.dark .text-slate-800 {
  color: #ececf3 !important;
}
html.dark .text-neutral-700,
html.dark .text-gray-700,
html.dark .text-slate-700 {
  color: #d6d6e0 !important;
}
html.dark .text-neutral-600,
html.dark .text-gray-600,
html.dark .text-slate-600 {
  color: #c2c2cf !important;
}
html.dark .text-neutral-500,
html.dark .text-gray-500,
html.dark .text-slate-500 {
  color: #a0a0b0 !important;
}
html.dark .text-neutral-400,
html.dark .text-gray-400,
html.dark .text-slate-400 {
  color: #7a7a8a !important;
}
html.dark input::placeholder,
html.dark textarea::placeholder {
  color: rgba(255, 255, 255, 0.45) !important;
}
html.dark .placeholder\\:text-neutral-400::placeholder,
html.dark .placeholder-neutral-400::placeholder {
  color: rgba(255, 255, 255, 0.45) !important;
}
html.dark .placeholder\\:text-neutral-500::placeholder,
html.dark .placeholder-neutral-500::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
html.dark input.bg-transparent,
html.dark textarea.bg-transparent {
  color: #ececf3 !important;
}

/* Kill white focus ring offset in dark mode (caused white box in inputs) */
html.dark :focus-visible {
  --tw-ring-offset-color: #0b0b15;
}

html.dark .gossip-inline-input,
html.dark .gossip-inline-input:focus,
html.dark .gossip-inline-input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  --tw-ring-shadow: 0 0 #0000 !important;
  --tw-ring-offset-shadow: 0 0 #0000 !important;
}

html.dark .gossip-inline-input:-webkit-autofill,
html.dark .gossip-inline-input:-webkit-autofill:hover,
html.dark .gossip-inline-input:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px #12121f inset !important;
  -webkit-text-fill-color: #ececf3 !important;
  -webkit-transition: background-color 99999s ease-out 0s;
  transition: background-color 99999s ease-out 0s;
}

/* Event registration modal — hide scrollbars while keeping scroll */
[data-event-registration-modal] .evt-reg-scroll {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
[data-event-registration-modal] .evt-reg-scroll::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

/* Resume drop zone — subtle hover in dark mode (no indigo glow) */
[data-event-registration-modal] .evt-reg-upload-zone,
[data-event-registration-modal] .evt-reg-upload-zone:hover {
  box-shadow: none !important;
  outline: none;
}
html.dark [data-event-registration-modal] .evt-reg-upload-zone--idle:hover {
  border-color: rgba(255, 255, 255, 0.2) !important;
  background-color: rgba(255, 255, 255, 0.05) !important;
}

/* College profile — form fields match panel surface in dark mode */
html.dark [data-college-profile] .profile-field {
  background-color: #161628 !important;
  color: #ececf3 !important;
}
html.dark [data-college-profile] .profile-field:-webkit-autofill,
html.dark [data-college-profile] .profile-field:-webkit-autofill:hover,
html.dark [data-college-profile] .profile-field:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px #161628 inset !important;
  -webkit-text-fill-color: #ececf3 !important;
  -webkit-transition: background-color 99999s ease-out 0s;
  transition: background-color 99999s ease-out 0s;
}
html.dark [data-college-profile] .profile-field:focus {
  --tw-ring-offset-color: #161628;
}

/* Event registration modal — consistent inputs in dark mode (no browser gray fill) */
html.dark [data-event-registration-modal] input:not([type="checkbox"]):not([type="file"]),
html.dark [data-event-registration-modal] textarea,
html.dark [data-event-registration-modal] select {
  background-color: #161628 !important;
  color: #ececf3 !important;
}
html.dark [data-event-registration-modal] input:not([type="checkbox"]):not([type="file"]):-webkit-autofill,
html.dark [data-event-registration-modal] input:not([type="checkbox"]):not([type="file"]):-webkit-autofill:hover,
html.dark [data-event-registration-modal] input:not([type="checkbox"]):not([type="file"]):-webkit-autofill:focus,
html.dark [data-event-registration-modal] textarea:-webkit-autofill,
html.dark [data-event-registration-modal] textarea:-webkit-autofill:hover,
html.dark [data-event-registration-modal] textarea:-webkit-autofill:focus,
html.dark [data-event-registration-modal] select:-webkit-autofill,
html.dark [data-event-registration-modal] select:-webkit-autofill:hover,
html.dark [data-event-registration-modal] select:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px #161628 inset !important;
  -webkit-text-fill-color: #ececf3 !important;
  -webkit-transition: background-color 99999s ease-out 0s;
  transition: background-color 99999s ease-out 0s;
}

/* Category pills / badges — tinted for dark surfaces */
html.dark .bg-blue-50 { background-color: rgba(59, 130, 246, 0.12) !important; }
html.dark .text-blue-600 { color: #93c5fd !important; }
html.dark .border-blue-200 { border-color: rgba(59, 130, 246, 0.25) !important; }
html.dark .bg-green-50 { background-color: rgba(34, 197, 94, 0.12) !important; }
html.dark .text-green-600 { color: #86efac !important; }
html.dark .border-green-200 { border-color: rgba(34, 197, 94, 0.25) !important; }
html.dark .bg-orange-50 { background-color: rgba(249, 115, 22, 0.12) !important; }
html.dark .text-orange-600 { color: #fdba74 !important; }
html.dark .border-orange-200 { border-color: rgba(249, 115, 22, 0.25) !important; }
html.dark .bg-violet-50 { background-color: rgba(139, 92, 246, 0.12) !important; }
html.dark .text-violet-600 { color: #c4b5fd !important; }
html.dark .border-violet-200 { border-color: rgba(139, 92, 246, 0.25) !important; }
html.dark .bg-pink-50 { background-color: rgba(236, 72, 153, 0.12) !important; }
html.dark .text-pink-600 { color: #f9a8d4 !important; }
html.dark .border-pink-200 { border-color: rgba(236, 72, 153, 0.25) !important; }
html.dark .bg-purple-50 { background-color: rgba(168, 85, 247, 0.12) !important; }
html.dark .text-purple-600 { color: #d8b4fe !important; }
html.dark .border-purple-200 { border-color: rgba(168, 85, 247, 0.25) !important; }

/* Hover tints — Tailwind hover:bg-*-50 must not flash light surfaces in dark mode */
html.dark .hover\\:bg-blue-50:hover { background-color: rgba(59, 130, 246, 0.12) !important; }
html.dark .hover\\:bg-green-50:hover { background-color: rgba(34, 197, 94, 0.12) !important; }
html.dark .hover\\:bg-purple-50:hover { background-color: rgba(168, 85, 247, 0.12) !important; }
html.dark .hover\\:bg-orange-50:hover { background-color: rgba(249, 115, 22, 0.12) !important; }
html.dark .hover\\:bg-orange-100:hover { background-color: rgba(249, 115, 22, 0.18) !important; }
html.dark .hover\\:bg-red-50:hover { background-color: rgba(239, 68, 68, 0.12) !important; }
html.dark .hover\\:bg-violet-100:hover { background-color: rgba(139, 92, 246, 0.18) !important; }
html.dark .hover\\:bg-violet-50:hover { background-color: rgba(139, 92, 246, 0.12) !important; }
html.dark .hover\\:bg-primary-50:hover,
html.dark .hover\\:bg-primary-50\\/50:hover { background-color: rgba(99, 102, 241, 0.12) !important; }
html.dark .hover\\:bg-gray-50:hover,
html.dark .hover\\:bg-neutral-50:hover,
html.dark .hover\\:bg-slate-50:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
}
html.dark .hover\\:bg-gray-100:hover,
html.dark .hover\\:bg-neutral-100:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}
html.dark .bg-orange-100 { background-color: rgba(249, 115, 22, 0.18) !important; }

/* Pastel gossip category cards keep light gradients — force dark text */
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) .text-neutral-800,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) .text-neutral-700,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) .text-neutral-600,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) .text-neutral-500,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]).text-neutral-800,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]).text-neutral-700,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]).text-neutral-600,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) h3 {
  color: #1f2937 !important;
}
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) .text-neutral-600,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]).text-neutral-600 {
  color: #4b5563 !important;
}
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]) .text-neutral-500,
html.dark [class*="from-"][class*="-100"]:not([data-project-showcase-hero]).text-neutral-500 {
  color: #6b7280 !important;
}

/* Project showcase hero — white title on dark gradient */
html.dark [data-project-showcase-hero] .project-showcase-title,
html.dark [data-project-showcase-hero] h3.project-showcase-title {
  color: #ffffff !important;
}

/* Event detail — tint cards readable in dark mode (global text-gray-900 → white) */
[data-event-detail] .evt-tint-title {
  color: #111827;
}
[data-event-detail] .evt-tint-sub {
  color: #6b7280;
}
.evt-share-x {
  background-color: #171717;
  color: #ffffff;
}
.evt-share-x:hover {
  background-color: #000000;
}
[data-event-detail] .evt-sticky-cta {
  box-shadow: 0 4px 20px -6px rgba(0, 0, 0, 0.12);
}

html.dark [data-event-detail] .evt-tint-purple {
  background-color: rgba(168, 85, 247, 0.14) !important;
  border: 1px solid rgba(168, 85, 247, 0.22);
}
html.dark [data-event-detail] .evt-tint-amber {
  background-color: rgba(245, 158, 11, 0.14) !important;
  border: 1px solid rgba(245, 158, 11, 0.22);
}
html.dark [data-event-detail] .evt-tint-emerald {
  background-color: rgba(16, 185, 129, 0.14) !important;
  border: 1px solid rgba(16, 185, 129, 0.22);
}
html.dark [data-event-detail] .evt-tint-pink {
  background-color: rgba(236, 72, 153, 0.14) !important;
  border: 1px solid rgba(236, 72, 153, 0.22);
}
html.dark [data-event-detail] .evt-tint-blue {
  background-color: rgba(59, 130, 246, 0.14) !important;
  border: 1px solid rgba(59, 130, 246, 0.22);
}
html.dark [data-event-detail] .evt-tint-rose {
  background-color: rgba(244, 63, 94, 0.14) !important;
  border: 1px solid rgba(244, 63, 94, 0.22);
}
html.dark [data-event-detail] .evt-tint-title {
  color: #ffffff !important;
}
html.dark [data-event-detail] .evt-tint-sub {
  color: rgba(255, 255, 255, 0.65) !important;
}
html.dark [data-event-detail] .evt-share-x {
  background-color: #e5e7eb !important;
  color: #111827 !important;
}
html.dark [data-event-detail] .evt-share-x:hover {
  background-color: #f3f4f6 !important;
}
html.dark [data-event-detail] .evt-sticky-cta {
  box-shadow: 0 8px 28px -8px rgba(0, 0, 0, 0.65) !important;
}
html.dark [data-event-detail] .evt-sticky-title {
  color: #ffffff !important;
}

/* ─── LinkedIn-inspired dark platform theme ─────────────────────────────
   Final authority layer. The app has many legacy page-level colors and
   Tailwind classes; this block normalizes them to one dark grayscale system
   with a single blue accent (#2563EB). */
:root,
html,
html.dark {
  color-scheme: dark;
  --app-bg: #0F1117;
  --app-card: #171A23;
  --app-hover: #1E2230;
  --app-border: #2A3042;
  --app-text: #FFFFFF;
  --app-text-secondary: #A1A8B8;
  --app-text-muted: #6B7280;
  --app-blue: #2563EB;
  --app-blue-hover: #1D4ED8;
  --bg-app: #0F1117;
  --bg-card: #171A23;
  --bg-muted: #1E2230;
  --bg-glass: rgba(23, 26, 35, 0.9);
  --border-default: #2A3042;
  --border-strong: #2A3042;
  --border-focus: #2563EB;
  --border-glass: #2A3042;
  --text-primary: #FFFFFF;
  --text-secondary: #A1A8B8;
  --text-muted: #6B7280;
  --text-tertiary: #6B7280;
  --text-on-primary: #FFFFFF;
  --primary-500: #2563EB;
  --primary-600: #2563EB;
  --primary-700: #1D4ED8;
  --accent-500: #2563EB;
  --accent-600: #2563EB;
  --accent-700: #1D4ED8;
  --status-success: #2563EB;
  --status-warning: #2563EB;
  --status-danger: #2563EB;
  --status-info: #2563EB;
  --status-live: #2563EB;
  --gradient-primary: #2563EB;
  --gradient-hero: #0F1117;
  --gradient-soft: #171A23;
}

html,
body,
#root {
  background-color: #0F1117 !important;
  color: #FFFFFF;
}

body,
.App,
.min-h-screen,
[class*="bg-background"],
.bg-background-page,
.bg-background-primary,
.bg-background-secondary {
  background-color: #0F1117 !important;
}

/* Remove platform gradients while preserving actual image elements. */
[class*="bg-gradient"],
[class*="gradient-"],
.animate-shimmer,
.route-progress-bar,
.auth-shell-wrap,
.auth-brand,
.auth-submit,
.auth-otp-modal,
.landing-waitlist-submit,
.landing-nav-cta,
.fab,
.avatar,
[data-project-showcase-hero] {
  background-image: none !important;
}

/* Surfaces */
.card,
.glass,
.glass-strong,
.glass-card,
.bg-white,
.bg-white\\/95,
.bg-white\\/90,
.bg-white\\/80,
.bg-white\\/70,
.bg-gray-50,
.bg-gray-100,
.bg-gray-800,
.bg-neutral-50,
.bg-neutral-100,
.bg-neutral-800,
.bg-slate-50,
.bg-slate-100,
.bg-slate-800,
.bg-\\[\\#050510\\],
.bg-\\[\\#080814\\],
.bg-\\[\\#0b0b15\\],
.bg-\\[\\#12121f\\],
.bg-\\[\\#13131f\\],
.bg-\\[\\#161628\\],
.bg-\\[\\#171A23\\],
[data-leaderboard-page],
[data-testid="modal-dialog"],
[data-event-registration-modal],
[data-college-profile] {
  background-color: #171A23 !important;
  border-color: #2A3042 !important;
}

.bg-black,
.bg-\\[\\#020208\\],
.bg-\\[\\#04050c\\],
.bg-\\[\\#050508\\],
.auth-page,
.mlp-page {
  background-color: #0F1117 !important;
}

.hover\\:bg-gray-50:hover,
.hover\\:bg-gray-100:hover,
.hover\\:bg-neutral-50:hover,
.hover\\:bg-neutral-100:hover,
.hover\\:bg-slate-50:hover,
.hover\\:bg-slate-100:hover,
.hover\\:bg-\\[\\#1E2230\\]:hover,
[class*="hover:bg-"]:hover {
  background-color: #1E2230 !important;
}

/* Borders and dividers */
.border,
[class*="border-"],
[class*="divide-"] > :not([hidden]) ~ :not([hidden]),
hr,
input,
textarea,
select {
  border-color: #2A3042 !important;
}

/* Text hierarchy */
h1,
h2,
h3,
h4,
h5,
h6,
.text-white,
.text-neutral-950,
.text-neutral-900,
.text-neutral-800,
.text-gray-950,
.text-gray-900,
.text-gray-800,
.text-slate-950,
.text-slate-900,
.text-slate-800 {
  color: #FFFFFF !important;
}

p,
.text-neutral-700,
.text-neutral-600,
.text-gray-700,
.text-gray-600,
.text-slate-700,
.text-slate-600 {
  color: #A1A8B8 !important;
}

.text-neutral-500,
.text-neutral-400,
.text-gray-500,
.text-gray-400,
.text-slate-500,
.text-slate-400,
.text-muted,
.text-tertiary,
small,
time {
  color: #6B7280 !important;
}

/* Single accent color for every legacy category/status/brand class. */
[class^="text-blue"],
[class*=" text-blue"],
[class^="dark:text-blue"],
[class*=" dark:text-blue"],
[class^="text-indigo"],
[class*=" text-indigo"],
[class^="dark:text-indigo"],
[class*=" dark:text-indigo"],
[class^="text-purple"],
[class*=" text-purple"],
[class^="dark:text-purple"],
[class*=" dark:text-purple"],
[class^="text-violet"],
[class*=" text-violet"],
[class^="dark:text-violet"],
[class*=" dark:text-violet"],
[class^="text-pink"],
[class*=" text-pink"],
[class^="dark:text-pink"],
[class*=" dark:text-pink"],
[class^="text-rose"],
[class*=" text-rose"],
[class^="dark:text-rose"],
[class*=" dark:text-rose"],
[class^="text-red"],
[class*=" text-red"],
[class^="dark:text-red"],
[class*=" dark:text-red"],
[class^="text-orange"],
[class*=" text-orange"],
[class^="dark:text-orange"],
[class*=" dark:text-orange"],
[class^="text-amber"],
[class*=" text-amber"],
[class^="dark:text-amber"],
[class*=" dark:text-amber"],
[class^="text-yellow"],
[class*=" text-yellow"],
[class^="dark:text-yellow"],
[class*=" dark:text-yellow"],
[class^="text-green"],
[class*=" text-green"],
[class^="dark:text-green"],
[class*=" dark:text-green"],
[class^="text-emerald"],
[class*=" text-emerald"],
[class^="dark:text-emerald"],
[class*=" dark:text-emerald"],
[class^="text-teal"],
[class*=" text-teal"],
[class^="dark:text-teal"],
[class*=" dark:text-teal"],
[class^="text-cyan"],
[class*=" text-cyan"],
[class^="dark:text-cyan"],
[class*=" dark:text-cyan"],
.link,
a {
  color: #2563EB !important;
}

[class^="bg-blue"],
[class*=" bg-blue"],
[class^="dark:bg-blue"],
[class*=" dark:bg-blue"],
[class^="bg-indigo"],
[class*=" bg-indigo"],
[class^="dark:bg-indigo"],
[class*=" dark:bg-indigo"],
[class^="bg-purple"],
[class*=" bg-purple"],
[class^="dark:bg-purple"],
[class*=" dark:bg-purple"],
[class^="bg-violet"],
[class*=" bg-violet"],
[class^="dark:bg-violet"],
[class*=" dark:bg-violet"],
[class^="bg-pink"],
[class*=" bg-pink"],
[class^="dark:bg-pink"],
[class*=" dark:bg-pink"],
[class^="bg-rose"],
[class*=" bg-rose"],
[class^="dark:bg-rose"],
[class*=" dark:bg-rose"],
[class^="bg-red"],
[class*=" bg-red"],
[class^="dark:bg-red"],
[class*=" dark:bg-red"],
[class^="bg-orange"],
[class*=" bg-orange"],
[class^="dark:bg-orange"],
[class*=" dark:bg-orange"],
[class^="bg-amber"],
[class*=" bg-amber"],
[class^="dark:bg-amber"],
[class*=" dark:bg-amber"],
[class^="bg-yellow"],
[class*=" bg-yellow"],
[class^="dark:bg-yellow"],
[class*=" dark:bg-yellow"],
[class^="bg-green"],
[class*=" bg-green"],
[class^="dark:bg-green"],
[class*=" dark:bg-green"],
[class^="bg-emerald"],
[class*=" bg-emerald"],
[class^="dark:bg-emerald"],
[class*=" dark:bg-emerald"],
[class^="bg-teal"],
[class*=" bg-teal"],
[class^="dark:bg-teal"],
[class*=" dark:bg-teal"],
[class^="bg-cyan"],
[class*=" bg-cyan"],
[class^="dark:bg-cyan"],
[class*=" dark:bg-cyan"],
.badge-primary,
.badge-success,
.badge-warning,
.badge-error,
.badge-info,
.btn-primary,
.auth-submit,
.auth-otp-submit,
.landing-waitlist-submit,
.landing-nav-cta,
.fab {
  background-color: rgba(37, 99, 235, 0.14) !important;
  color: #93c5fd !important;
  border-color: rgba(37, 99, 235, 0.32) !important;
}

[class^="bg-blue-500"],
[class*=" bg-blue-500"],
[class^="bg-blue-600"],
[class*=" bg-blue-600"],
[class^="bg-primary-500"],
[class*=" bg-primary-500"],
[class^="bg-primary-600"],
[class*=" bg-primary-600"],
[class^="bg-dashboard-500"],
[class*=" bg-dashboard-500"],
[class^="bg-dashboard-600"],
[class*=" bg-dashboard-600"],
[class^="bg-red-500"],
[class*=" bg-red-500"],
[class^="bg-green-500"],
[class*=" bg-green-500"],
[class^="bg-amber-500"],
[class*=" bg-amber-500"],
.bg-\\[\\#2563EB\\],
.bg-gradient-dashboard-primary,
.badge-primary,
.btn-primary,
.auth-submit,
.auth-otp-submit,
.landing-waitlist-submit,
.landing-nav-cta,
.fab {
  background-color: #2563EB !important;
  color: #FFFFFF !important;
  border-color: #2563EB !important;
}

.bg-gradient-dashboard-soft,
.bg-gradient-dashboard-hero {
  background-color: #1E2230 !important;
  color: #FFFFFF !important;
  border-color: #2A3042 !important;
}

[class*="hover:bg-blue"]:hover,
[class*="hover:bg-indigo"]:hover,
[class*="hover:bg-purple"]:hover,
[class*="hover:bg-violet"]:hover,
[class*="hover:bg-pink"]:hover,
[class*="hover:bg-rose"]:hover,
[class*="hover:bg-red"]:hover,
[class*="hover:bg-orange"]:hover,
[class*="hover:bg-amber"]:hover,
[class*="hover:bg-yellow"]:hover,
[class*="hover:bg-green"]:hover,
[class*="hover:bg-emerald"]:hover,
[class*="hover:bg-teal"]:hover,
[class*="hover:bg-cyan"]:hover,
.btn-primary:hover,
.auth-submit:hover,
.auth-otp-submit:hover,
.landing-waitlist-submit:hover,
.landing-nav-cta:hover,
.fab:hover {
  background-color: #1D4ED8 !important;
  color: #FFFFFF !important;
  border-color: #1D4ED8 !important;
}

[class^="border-blue"],
[class*=" border-blue"],
[class^="dark:border-blue"],
[class*=" dark:border-blue"],
[class^="border-indigo"],
[class*=" border-indigo"],
[class^="dark:border-indigo"],
[class*=" dark:border-indigo"],
[class^="border-purple"],
[class*=" border-purple"],
[class^="dark:border-purple"],
[class*=" dark:border-purple"],
[class^="border-violet"],
[class*=" border-violet"],
[class^="dark:border-violet"],
[class*=" dark:border-violet"],
[class^="border-pink"],
[class*=" border-pink"],
[class^="dark:border-pink"],
[class*=" dark:border-pink"],
[class^="border-rose"],
[class*=" border-rose"],
[class^="dark:border-rose"],
[class*=" dark:border-rose"],
[class^="border-red"],
[class*=" border-red"],
[class^="dark:border-red"],
[class*=" dark:border-red"],
[class^="border-orange"],
[class*=" border-orange"],
[class^="dark:border-orange"],
[class*=" dark:border-orange"],
[class^="border-amber"],
[class*=" border-amber"],
[class^="dark:border-amber"],
[class*=" dark:border-amber"],
[class^="border-yellow"],
[class*=" border-yellow"],
[class^="dark:border-yellow"],
[class*=" dark:border-yellow"],
[class^="border-green"],
[class*=" border-green"],
[class^="dark:border-green"],
[class*=" dark:border-green"],
[class^="border-emerald"],
[class*=" border-emerald"],
[class^="dark:border-emerald"],
[class*=" dark:border-emerald"],
[class^="border-teal"],
[class*=" border-teal"],
[class^="dark:border-teal"],
[class*=" dark:border-teal"],
[class^="border-cyan"],
[class*=" border-cyan"],
[class^="dark:border-cyan"],
[class*=" dark:border-cyan"] {
  border-color: #2563EB !important;
}

/* Inputs, selects, textareas */
input:not([type="checkbox"]):not([type="radio"]):not([type="file"]),
textarea,
select,
.input,
.profile-field {
  background-color: #171A23 !important;
  border-color: #2A3042 !important;
  color: #FFFFFF !important;
}

/* Auth fields — styled in auth.css; inner controls stay transparent inside wrap */
.auth-page .auth-input-wrap .auth-input,
.auth-page .auth-input-wrap .auth-select {
  background-color: transparent !important;
  border: none !important;
}

input::placeholder,
textarea::placeholder {
  color: #6B7280 !important;
}

/* Buttons and interactive neutral actions */
button,
.btn,
[role="button"] {
  border-color: #2A3042;
}

.btn-secondary,
.btn-ghost,
.auth-google-btn,
.auth-mode-card,
.auth-type-btn,
.auth-otp-resend,
.badge-secondary {
  background-color: transparent !important;
  color: #A1A8B8 !important;
  border-color: #2A3042 !important;
}

.btn-secondary:hover,
.btn-ghost:hover,
.auth-google-btn:hover,
.auth-mode-card:hover,
.auth-type-btn:hover,
.auth-type-btn--active,
.auth-otp-resend:hover,
[aria-selected="true"],
[data-active="true"] {
  background-color: #1E2230 !important;
  color: #FFFFFF !important;
  border-color: #2563EB !important;
}

/* Focus, selection, notification dots and icons */
:focus-visible,
.focus\\:ring-primary-500:focus,
.focus\\:ring-blue-500:focus,
.focus-visible\\:ring-primary-500:focus-visible,
.focus-visible\\:ring-blue-500:focus-visible {
  outline: none !important;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.35) !important;
  --tw-ring-color: rgba(37, 99, 235, 0.45) !important;
  --tw-ring-offset-color: #0F1117 !important;
}

::selection {
  background-color: rgba(37, 99, 235, 0.32);
  color: #FFFFFF;
}

svg,
.lucide,
[class*="icon"] {
  color: currentColor;
}

.live-pulse-dot,
.notification-dot,
[class*="badge-dot"],
[class*="status-dot"] {
  background-color: #2563EB !important;
  box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.45) !important;
}

/* Auth and landing decorative layers */
.auth-page-ambient-blob,
.auth-brand-glow,
.auth-ambient-orb,
.auth-orbit-dot,
.mlp-page::before,
.landing-whatsapp-icon,
.landing-whatsapp-modal {
  background: #171A23 !important;
  background-image: none !important;
  border-color: #2A3042 !important;
  box-shadow: none !important;
}

.auth-shell-wrap {
  background: #2A3042 !important;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.36) !important;
}

.auth-shell,
.auth-brand,
.auth-form-panel,
.auth-otp-modal,
.landing-waitlist-card,
.landing-whatsapp-modal {
  background: #171A23 !important;
  border-color: #2A3042 !important;
}

.auth-error-banner,
.auth-success-banner,
.landing-waitlist-error {
  background: rgba(37, 99, 235, 0.12) !important;
  border-color: rgba(37, 99, 235, 0.32) !important;
  color: #A1A8B8 !important;
}

/* Category cards and pastel panels should never keep multicolor fills. */
[class*="from-"][class*="-100"],
[class*="to-"][class*="-100"],
[class*="via-"][class*="-100"],
[class*="from-"][class*="-200"],
[class*="to-"][class*="-200"],
[class*="via-"][class*="-200"],
[class*="evt-tint-"] {
  background-color: #171A23 !important;
  background-image: none !important;
  border-color: #2A3042 !important;
}

.message-highlight {
  background-color: rgba(37, 99, 235, 0.12) !important;
}

.messaging-search-shell .messaging-search-input,
.messaging-search-shell .messaging-search-input:focus,
.messaging-search-shell .messaging-search-input:focus-visible {
  background: transparent !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: 0 !important;
  padding: 0 !important;
  min-height: 0 !important;
}

/* College header search — no inner focus ring; highlight outer shell only */
.college-header-search-input,
.college-header-search-input:focus,
.college-header-search-input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  --tw-ring-shadow: 0 0 #0000 !important;
  --tw-ring-offset-shadow: 0 0 #0000 !important;
}

@media (max-width: 639px) {
  .college-header-search-input {
    border: none !important;
    background: transparent !important;
  }
}

.community-chat-input,
.community-chat-input:focus,
.community-chat-input:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
  background-color: transparent !important;
  background: transparent !important;
  --tw-ring-shadow: 0 0 #0000 !important;
  --tw-ring-offset-shadow: 0 0 #0000 !important;
}

/* Community hero — black fade for readable text (Tailwind bg-gradient-* is stripped in dark mode) */
.community-hero-overlay {
  background: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.96) 0%,
    rgba(0, 0, 0, 0.88) 22%,
    rgba(0, 0, 0, 0.55) 50%,
    rgba(0, 0, 0, 0.12) 78%,
    rgba(0, 0, 0, 0) 100%
  ) !important;
  pointer-events: none;
}

/* Event share menu — keep dropdown items out of global button overrides */
.event-share-menu,
.event-share-menu * {
  max-width: none !important;
}

.event-share-menu {
  background-color: #ffffff !important;
  border-color: #e5e7eb !important;
  min-width: 288px !important;
}

html.dark .event-share-menu {
  background-color: #161628 !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.event-share-menu__item,
.event-share-menu__item:hover,
.event-share-menu__item:focus-visible {
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 100% !important;
  min-height: 2.75rem !important;
  min-width: 0 !important;
  background-color: transparent !important;
  background-image: none !important;
  border: 0 !important;
  box-shadow: none !important;
  text-align: left !important;
  white-space: nowrap !important;
  overflow: visible !important;
}

.event-share-menu__item span:last-child {
  overflow: visible !important;
  text-overflow: unset !important;
  flex: 1 1 auto !important;
}

html.dark .event-share-menu__item {
  color: rgba(255, 255, 255, 0.88) !important;
}

html.dark .event-share-menu__item:hover {
  background-color: rgba(255, 255, 255, 0.06) !important;
  color: #ffffff !important;
}

/* Event detail hero — square icon buttons (avoid global bg-white / stretch overrides) */
.event-detail-hero-icon-btn,
.event-detail-hero-share-btn {
  background-color: rgba(255, 255, 255, 0.1) !important;
  background-image: none !important;
  border-color: rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  box-shadow: none !important;
}

.event-detail-hero-icon-btn {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 2.25rem !important;
  height: 2.25rem !important;
  min-width: 2.25rem !important;
  max-width: 2.25rem !important;
  min-height: 2.25rem !important;
  max-height: 2.25rem !important;
  padding: 0 !important;
  flex: 0 0 auto !important;
}

.event-detail-hero-icon-btn:hover,
.event-detail-hero-share-btn:hover {
  background-color: rgba(255, 255, 255, 0.18) !important;
}

/* Landing waitlist — preserve field shell + gradient submit on desktop landing */
.dt-waitlist-card .landing-field,
.dt-waitlist-form-shell .landing-field {
  background-color: #0b0e14 !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field,
.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field {
  flex: 1 1;
  width: 100%;
  min-width: 0;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;
  appearance: none;
  -webkit-appearance: none;
}

.dt-waitlist-card .landing-field select.landing-input.landing-input-in-field,
.dt-waitlist-form-shell .landing-field select.landing-input.landing-input-in-field {
  flex: 1 1;
  width: 100%;
  min-width: 0;
  background-color: transparent !important;
  border: none !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  outline: none !important;
}

.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:focus,
.dt-waitlist-card .landing-field select.landing-input.landing-input-in-field:focus,
.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:focus-visible,
.dt-waitlist-card .landing-field select.landing-input.landing-input-in-field:focus-visible,
.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:focus,
.dt-waitlist-form-shell .landing-field select.landing-input.landing-input-in-field:focus,
.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:focus-visible,
.dt-waitlist-form-shell .landing-field select.landing-input.landing-input-in-field:focus-visible {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:-webkit-autofill,
.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:hover,
.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:focus,
.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:-webkit-autofill,
.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:hover,
.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:focus {
  box-shadow: 0 0 0 1000px #0b0e14 inset !important;
  -webkit-text-fill-color: #e1e2eb !important;
  -webkit-transition: background-color 99999s ease-out 0s;
  transition: background-color 99999s ease-out 0s;
}

.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-input-in-field,
.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-select {
  color: #e1e2eb !important;
}

.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-input-in-field::placeholder {
  color: #6b7280 !important;
}

.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-select:invalid {
  color: #6b7280 !important;
}

.dt-landing .landing-waitlist-submit,
.dt-waitlist-card .landing-waitlist-submit,
.dt-waitlist-form-shell .landing-waitlist-submit {
  background: linear-gradient(135deg, #2f6bff 0%, #003cac 100%) !important;
  background-image: linear-gradient(135deg, #2f6bff 0%, #003cac 100%) !important;
  color: #ffffff !important;
  border: none !important;
  border-color: transparent !important;
}

.selection\\:bg-lp-primary *::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(181 196 255 / var(--tw-bg-opacity, 1));
}

.selection\\:text-lp-on-primary-container *::selection{
  --tw-text-opacity: 1;
  color: rgb(0 3 24 / var(--tw-text-opacity, 1));
}

.selection\\:bg-lp-primary::selection{
  --tw-bg-opacity: 1;
  background-color: rgb(181 196 255 / var(--tw-bg-opacity, 1));
}

.selection\\:text-lp-on-primary-container::selection{
  --tw-text-opacity: 1;
  color: rgb(0 3 24 / var(--tw-text-opacity, 1));
}

.file\\:mr-3::file-selector-button{
  margin-right: 12px;
}

.file\\:rounded-lg::file-selector-button{
  border-radius: 10px;
}

.file\\:rounded-md::file-selector-button{
  border-radius: 8px;
}

.file\\:border-0::file-selector-button{
  border-width: 0px;
}

.file\\:bg-dashboard-50::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.file\\:bg-purple-50::file-selector-button{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}

.file\\:px-3::file-selector-button{
  padding-left: 12px;
  padding-right: 12px;
}

.file\\:px-4::file-selector-button{
  padding-left: 16px;
  padding-right: 16px;
}

.file\\:py-2::file-selector-button{
  padding-top: 8px;
  padding-bottom: 8px;
}

.file\\:text-sm::file-selector-button{
  font-size: 0.8125rem;
  line-height: 1.25rem;
  letter-spacing: 0;
}

.file\\:font-medium::file-selector-button{
  font-weight: 500;
}

.file\\:text-dashboard-700::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.file\\:text-purple-600::file-selector-button{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-300::placeholder{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-gray-500::placeholder{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-neutral-400::placeholder{
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.placeholder\\:text-white\\/50::placeholder{
  color: rgb(255 255 255 / 0.5);
}

.placeholder\\:text-white\\/60::placeholder{
  color: rgb(255 255 255 / 0.6);
}

.first\\:ml-0:first-child{
  margin-left: 0px;
}

.first\\:pt-0:first-child{
  padding-top: 0px;
}

.last\\:mb-0:last-child{
  margin-bottom: 0px;
}

.last\\:border-0:last-child{
  border-width: 0px;
}

.last\\:border-b-0:last-child{
  border-bottom-width: 0px;
}

.last\\:pb-0:last-child{
  padding-bottom: 0px;
}

.focus-within\\:border-\\[\\#2563EB\\]:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-blue-300:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.focus-within\\:border-purple-300:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-blue-100:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-purple-100:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(243 232 255 / var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-violet-400:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 139 250 / var(--tw-ring-opacity, 1));
}

.hover\\:-translate-y-0\\.5:hover{
  --tw-translate-y: -2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-125:hover{
  --tw-scale-x: 1.25;
  --tw-scale-y: 1.25;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.02\\]:hover{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-\\[1\\.03\\]:hover{
  --tw-scale-x: 1.03;
  --tw-scale-y: 1.03;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:gap-lp-md:hover{
  gap: 24px;
}

.hover\\:border-\\[\\#2563EB\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[\\#2563EB\\]\\/50:hover{
  border-color: rgb(37 99 235 / 0.5);
}

.hover\\:border-\\[\\#2A3042\\]:hover{
  --tw-border-opacity: 1;
  border-color: rgb(42 48 66 / var(--tw-border-opacity, 1));
}

.hover\\:border-amber-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-600:hover{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-dashboard-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-emerald-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(199 210 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-indigo-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-lp-primary\\/20:hover{
  border-color: rgb(181 196 255 / 0.2);
}

.hover\\:border-lp-primary\\/30:hover{
  border-color: rgb(181 196 255 / 0.3);
}

.hover\\:border-neutral-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity, 1));
}

.hover\\:border-neutral-300\\/60:hover{
  border-color: rgb(209 213 219 / 0.6);
}

.hover\\:border-neutral-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity, 1));
}

.hover\\:border-pink-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(249 168 212 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(191 219 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-300\\/40:hover{
  border-color: rgb(147 197 253 / 0.4);
}

.hover\\:border-primary-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.hover\\:border-primary-500:hover{
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-100:hover{
  --tw-border-opacity: 1;
  border-color: rgb(243 232 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(233 213 255 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-purple-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}

.hover\\:border-violet-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(221 214 254 / var(--tw-border-opacity, 1));
}

.hover\\:border-violet-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(196 181 253 / var(--tw-border-opacity, 1));
}

.hover\\:border-white\\/40:hover{
  border-color: rgb(255 255 255 / 0.4);
}

.hover\\:bg-\\[\\#171A23\\]\\/80:hover{
  background-color: rgb(23 26 35 / 0.8);
}

.hover\\:bg-\\[\\#1D4ED8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1E2230\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 34 48 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#1E2230\\]\\/70:hover{
  background-color: rgb(30 34 48 / 0.7);
}

.hover\\:bg-\\[\\#1d4ed8\\]:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-black\\/30:hover{
  background-color: rgb(0 0 0 / 0.3);
}

.hover\\:bg-black\\/70:hover{
  background-color: rgb(0 0 0 / 0.7);
}

.hover\\:bg-black\\/80:hover{
  background-color: rgb(0 0 0 / 0.8);
}

.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50\\/40:hover{
  background-color: rgb(239 246 255 / 0.4);
}

.hover\\:bg-blue-50\\/50:hover{
  background-color: rgb(239 246 255 / 0.5);
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-error-100:hover{
  background-color: rgba(37, 99, 235, 0.16);
}

.hover\\:bg-error-50:hover{
  background-color: rgba(37, 99, 235, 0.10);
}

.hover\\:bg-error-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-300:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50\\/50:hover{
  background-color: rgb(249 250 251 / 0.5);
}

.hover\\:bg-gray-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(224 231 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-indigo-50\\/30:hover{
  background-color: rgb(238 242 255 / 0.3);
}

.hover\\:bg-indigo-50\\/40:hover{
  background-color: rgb(238 242 255 / 0.4);
}

.hover\\:bg-indigo-50\\/60:hover{
  background-color: rgb(238 242 255 / 0.6);
}

.hover\\:bg-indigo-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(67 56 202 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-lp-primary\\/20:hover{
  background-color: rgb(181 196 255 / 0.2);
}

.hover\\:bg-neutral-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-150:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 238 241 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-neutral-50\\/50:hover{
  background-color: rgb(249 250 251 / 0.5);
}

.hover\\:bg-neutral-50\\/60:hover{
  background-color: rgb(249 250 251 / 0.6);
}

.hover\\:bg-orange-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 237 213 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-orange-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(194 65 12 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-pink-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(191 219 254 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(29 78 216 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(233 213 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(147 51 234 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-rose-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-sky-500:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(14 165 233 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-success-100:hover{
  background-color: rgba(37, 99, 235, 0.16);
}

.hover\\:bg-violet-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(245 243 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(109 40 217 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-violet-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(91 33 182 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/15:hover{
  background-color: rgb(255 255 255 / 0.15);
}

.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/25:hover{
  background-color: rgb(255 255 255 / 0.25);
}

.hover\\:bg-white\\/30:hover{
  background-color: rgb(255 255 255 / 0.3);
}

.hover\\:bg-white\\/5:hover{
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:bg-white\\/50:hover{
  background-color: rgb(255 255 255 / 0.5);
}

.hover\\:bg-white\\/60:hover{
  background-color: rgb(255 255 255 / 0.6);
}

.hover\\:bg-white\\/65:hover{
  background-color: rgb(255 255 255 / 0.65);
}

.hover\\:bg-white\\/70:hover{
  background-color: rgb(255 255 255 / 0.7);
}

.hover\\:bg-white\\/90:hover{
  background-color: rgb(255 255 255 / 0.9);
}

.hover\\:bg-white\\/\\[0\\.03\\]:hover{
  background-color: rgb(255 255 255 / 0.03);
}

.hover\\:bg-white\\/\\[0\\.04\\]:hover{
  background-color: rgb(255 255 255 / 0.04);
}

.hover\\:bg-white\\/\\[0\\.07\\]:hover{
  background-color: rgb(255 255 255 / 0.07);
}

.hover\\:bg-opacity-100:hover{
  --tw-bg-opacity: 1;
}

.hover\\:bg-opacity-75:hover{
  --tw-bg-opacity: 0.75;
}

.hover\\:from-\\[\\#4f46e5\\]:hover{
  --tw-gradient-from: #4f46e5 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(79 70 229 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-indigo-700:hover{
  --tw-gradient-from: #4338ca var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(67 56 202 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-primary-600:hover{
  --tw-gradient-from: #2563eb var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(37 99 235 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-primary-700:hover{
  --tw-gradient-from: #1d4ed8 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(29 78 216 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-purple-700:hover{
  --tw-gradient-from: #7e22ce var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(126 34 206 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-\\[\\#7c3aed\\]:hover{
  --tw-gradient-to: #7c3aed var(--tw-gradient-to-position);
}

.hover\\:to-indigo-700:hover{
  --tw-gradient-to: #4338ca var(--tw-gradient-to-position);
}

.hover\\:to-indigo-800:hover{
  --tw-gradient-to: #3730a3 var(--tw-gradient-to-position);
}

.hover\\:to-primary-700:hover{
  --tw-gradient-to: #1d4ed8 var(--tw-gradient-to-position);
}

.hover\\:to-primary-800:hover{
  --tw-gradient-to: #1e40af var(--tw-gradient-to-position);
}

.hover\\:to-purple-700:hover{
  --tw-gradient-to: #7e22ce var(--tw-gradient-to-position);
}

.hover\\:to-purple-800:hover{
  --tw-gradient-to: #6b21a8 var(--tw-gradient-to-position);
}

.hover\\:text-\\[\\#2563EB\\]:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-300:hover{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-dashboard-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-error-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-error-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-100:hover{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-200:hover{
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-500:hover{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-600:hover{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.hover\\:text-green-700:hover{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-300:hover{
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-600:hover{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-700:hover{
  --tw-text-opacity: 1;
  color: rgb(67 56 202 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-800:hover{
  --tw-text-opacity: 1;
  color: rgb(55 48 163 / var(--tw-text-opacity, 1));
}

.hover\\:text-indigo-900:hover{
  --tw-text-opacity: 1;
  color: rgb(49 46 129 / var(--tw-text-opacity, 1));
}

.hover\\:text-lp-primary:hover{
  --tw-text-opacity: 1;
  color: rgb(181 196 255 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-100:hover{
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-500:hover{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-600:hover{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-700:hover{
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-800:hover{
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}

.hover\\:text-neutral-900:hover{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.hover\\:text-pink-600:hover{
  --tw-text-opacity: 1;
  color: rgb(219 39 119 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-200:hover{
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-300:hover{
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-400:hover{
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-600:hover{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.hover\\:text-primary-700:hover{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-600:hover{
  --tw-text-opacity: 1;
  color: rgb(147 51 234 / var(--tw-text-opacity, 1));
}

.hover\\:text-purple-700:hover{
  --tw-text-opacity: 1;
  color: rgb(126 34 206 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-400:hover{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-500:hover{
  --tw-text-opacity: 1;
  color: rgb(244 63 94 / var(--tw-text-opacity, 1));
}

.hover\\:text-rose-600:hover{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-600:hover{
  --tw-text-opacity: 1;
  color: rgb(124 58 237 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-700:hover{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}

.hover\\:text-violet-800:hover{
  --tw-text-opacity: 1;
  color: rgb(91 33 182 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-70:hover{
  opacity: 0.7;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:opacity-95:hover{
  opacity: 0.95;
}

.hover\\:shadow-\\[0_0_30px_rgba\\(47\\2c 107\\2c 255\\2c 0\\.3\\)\\]:hover{
  --tw-shadow: 0 0 30px rgba(47,107,255,0.3);
  --tw-shadow-colored: 0 0 30px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-card-hover:hover{
  --tw-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.08), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 12px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-cta-lg:hover{
  --tw-shadow: 0 12px 28px rgba(37, 99, 235, 0.26);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 8px 16px -4px rgba(0, 0, 0, 0.07), 0 4px 6px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 8px 16px -4px var(--tw-shadow-color), 0 4px 6px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 8px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 16px 32px -8px rgba(0, 0, 0, 0.08), 0 8px 16px -4px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 16px 32px -8px var(--tw-shadow-color), 0 8px 16px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-primary-600\\/20:hover{
  --tw-shadow-color: rgb(37 99 235 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:shadow-primary-600\\/30:hover{
  --tw-shadow-color: rgb(37 99 235 / 0.3);
  --tw-shadow: var(--tw-shadow-colored);
}

.hover\\:grayscale-0:hover{
  --tw-grayscale: grayscale(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.hover\\:file\\:bg-dashboard-100::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}

.hover\\:file\\:bg-purple-100::file-selector-button:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(243 232 255 / var(--tw-bg-opacity, 1));
}

.focus\\:border-\\[\\#2563EB\\]:focus{
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.focus\\:border-blue-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.focus\\:border-dashboard-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.focus\\:border-dashboard-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(165 180 252 / var(--tw-border-opacity, 1));
}

.focus\\:border-indigo-400\\/40:focus{
  border-color: rgb(129 140 248 / 0.4);
}

.focus\\:border-indigo-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.focus\\:border-primary-500\\/50:focus{
  border-color: rgb(59 130 246 / 0.5);
}

.focus\\:border-purple-300:focus{
  --tw-border-opacity: 1;
  border-color: rgb(216 180 254 / var(--tw-border-opacity, 1));
}

.focus\\:border-purple-400:focus{
  --tw-border-opacity: 1;
  border-color: rgb(192 132 252 / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:bg-white:focus{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.focus\\:shadow-none:focus{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-1:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:\\!ring-error-100:focus{
  --tw-ring-color: rgba(37, 99, 235, 0.16) !important;
}

.focus\\:ring-\\[\\#2563EB\\]:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(37 99 235 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-\\[\\#2563EB\\]\\/25:focus{
  --tw-ring-color: rgb(37 99 235 / 0.25);
}

.focus\\:ring-\\[\\#2563EB\\]\\/35:focus{
  --tw-ring-color: rgb(37 99 235 / 0.35);
}

.focus\\:ring-blue-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-dashboard-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-dashboard-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(224 231 255 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(129 140 248 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-400\\/30:focus{
  --tw-ring-color: rgb(129 140 248 / 0.3);
}

.focus\\:ring-indigo-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(99 102 241 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-indigo-500\\/20:focus{
  --tw-ring-color: rgb(99 102 241 / 0.2);
}

.focus\\:ring-indigo-500\\/25:focus{
  --tw-ring-color: rgb(99 102 241 / 0.25);
}

.focus\\:ring-indigo-500\\/30:focus{
  --tw-ring-color: rgb(99 102 241 / 0.3);
}

.focus\\:ring-primary-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(219 234 254 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary-500\\/20:focus{
  --tw-ring-color: rgb(59 130 246 / 0.2);
}

.focus\\:ring-primary-500\\/25:focus{
  --tw-ring-color: rgb(59 130 246 / 0.25);
}

.focus\\:ring-primary-500\\/30:focus{
  --tw-ring-color: rgb(59 130 246 / 0.3);
}

.focus\\:ring-primary-500\\/50:focus{
  --tw-ring-color: rgb(59 130 246 / 0.5);
}

.focus\\:ring-purple-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(192 132 252 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(168 85 247 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-purple-500\\/20:focus{
  --tw-ring-color: rgb(168 85 247 / 0.2);
}

.focus\\:ring-red-300:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(252 165 165 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-red-600:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(220 38 38 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-violet-400:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(167 139 250 / var(--tw-ring-opacity, 1));
}

.focus\\:ring-white\\/50:focus{
  --tw-ring-color: rgb(255 255 255 / 0.5);
}

.focus\\:ring-offset-0:focus{
  --tw-ring-offset-width: 0px;
}

.focus\\:ring-offset-1:focus{
  --tw-ring-offset-width: 1px;
}

.focus\\:ring-offset-2:focus{
  --tw-ring-offset-width: 2px;
}

.focus\\:ring-offset-red-50:focus{
  --tw-ring-offset-color: #fef2f2;
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-0:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-4:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-dashboard-200:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(191 219 254 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-dashboard-300:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(147 197 253 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-violet-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(139 92 246 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-offset-0:focus-visible{
  --tw-ring-offset-width: 0px;
}

.active\\:scale-90:active{
  --tw-scale-x: .9;
  --tw-scale-y: .9;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-95:active{
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.94\\]:active{
  --tw-scale-x: 0.94;
  --tw-scale-y: 0.94;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.96\\]:active{
  --tw-scale-x: 0.96;
  --tw-scale-y: 0.96;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.97\\]:active{
  --tw-scale-x: 0.97;
  --tw-scale-y: 0.97;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:scale-\\[0\\.98\\]:active{
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.active\\:cursor-grabbing:active{
  cursor: grabbing;
}

.active\\:bg-gray-50:active{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.active\\:bg-neutral-200:active{
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}

.active\\:bg-white\\/25:active{
  background-color: rgb(255 255 255 / 0.25);
}

.active\\:opacity-100:active{
  opacity: 1;
}

.disabled\\:cursor-default:disabled{
  cursor: default;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-gray-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-400:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-gray-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-300:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-50:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(249 250 251 / var(--tw-bg-opacity, 1));
}

.disabled\\:bg-neutral-600:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.disabled\\:opacity-70:disabled{
  opacity: 0.7;
}

.disabled\\:hover\\:bg-transparent:hover:disabled{
  background-color: transparent;
}

.disabled\\:hover\\:text-gray-500:hover:disabled{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:-translate-x-0\\.5{
  --tw-translate-x: -2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-0\\.5{
  --tw-translate-x: 2px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:translate-x-1{
  --tw-translate-x: 4px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-\\[1\\.02\\]{
  --tw-scale-x: 1.02;
  --tw-scale-y: 1.02;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:border-indigo-500{
  --tw-border-opacity: 1;
  border-color: rgb(99 102 241 / var(--tw-border-opacity, 1));
}

.group:hover .group-hover\\:bg-black\\/10{
  background-color: rgb(0 0 0 / 0.1);
}

.group:hover .group-hover\\:bg-black\\/15{
  background-color: rgb(0 0 0 / 0.15);
}

.group:hover .group-hover\\:bg-gray-700{
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.group:hover .group-hover\\:bg-lp-primary\\/10{
  background-color: rgb(181 196 255 / 0.1);
}

.group:hover .group-hover\\:text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-dashboard-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-400{
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-500{
  --tw-text-opacity: 1;
  color: rgb(99 102 241 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-indigo-600{
  --tw-text-opacity: 1;
  color: rgb(79 70 229 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-lp-primary{
  --tw-text-opacity: 1;
  color: rgb(181 196 255 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-neutral-300{
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-neutral-600{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-primary-700{
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(109 40 217 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:underline{
  text-decoration-line: underline;
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

.group:hover .group-hover\\:shadow-md{
  --tw-shadow: 0 4px 8px -2px rgba(0, 0, 0, 0.06), 0 2px 4px -2px rgba(0, 0, 0, 0.03);
  --tw-shadow-colored: 0 4px 8px -2px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.group:hover .group-hover\\:shadow-primary-500\\/20{
  --tw-shadow-color: rgb(59 130 246 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:divide-white\\/10:is(.dark *) > :not([hidden]) ~ :not([hidden]){
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:border:is(.dark *){
  border-width: 1px;
}

.dark\\:\\!border-error-500:is(.dark *){
  --tw-border-opacity: 1 !important;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1)) !important;
}

.dark\\:border-\\[\\#10101e\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(16 16 30 / var(--tw-border-opacity, 1));
}

.dark\\:border-\\[\\#161628\\]:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(22 22 40 / var(--tw-border-opacity, 1));
}

.dark\\:border-amber-500\\/30:is(.dark *){
  border-color: rgb(245 158 11 / 0.3);
}

.dark\\:border-blue-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
}

.dark\\:border-blue-500\\/25:is(.dark *){
  border-color: rgb(59 130 246 / 0.25);
}

.dark\\:border-blue-500\\/30:is(.dark *){
  border-color: rgb(59 130 246 / 0.3);
}

.dark\\:border-blue-500\\/40:is(.dark *){
  border-color: rgb(59 130 246 / 0.4);
}

.dark\\:border-blue-500\\/50:is(.dark *){
  border-color: rgb(59 130 246 / 0.5);
}

.dark\\:border-dashboard-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.dark\\:border-emerald-400\\/20:is(.dark *){
  border-color: rgb(52 211 153 / 0.2);
}

.dark\\:border-emerald-500\\/25:is(.dark *){
  border-color: rgb(16 185 129 / 0.25);
}

.dark\\:border-emerald-500\\/30:is(.dark *){
  border-color: rgb(16 185 129 / 0.3);
}

.dark\\:border-emerald-500\\/40:is(.dark *){
  border-color: rgb(16 185 129 / 0.4);
}

.dark\\:border-error-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(37 99 235 / var(--tw-border-opacity, 1));
}

.dark\\:border-green-500\\/30:is(.dark *){
  border-color: rgb(34 197 94 / 0.3);
}

.dark\\:border-green-500\\/40:is(.dark *){
  border-color: rgb(34 197 94 / 0.4);
}

.dark\\:border-indigo-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(129 140 248 / var(--tw-border-opacity, 1));
}

.dark\\:border-indigo-400\\/20:is(.dark *){
  border-color: rgb(129 140 248 / 0.2);
}

.dark\\:border-indigo-500\\/15:is(.dark *){
  border-color: rgb(99 102 241 / 0.15);
}

.dark\\:border-indigo-500\\/20:is(.dark *){
  border-color: rgb(99 102 241 / 0.2);
}

.dark\\:border-indigo-500\\/25:is(.dark *){
  border-color: rgb(99 102 241 / 0.25);
}

.dark\\:border-indigo-500\\/30:is(.dark *){
  border-color: rgb(99 102 241 / 0.3);
}

.dark\\:border-indigo-500\\/40:is(.dark *){
  border-color: rgb(99 102 241 / 0.4);
}

.dark\\:border-indigo-500\\/50:is(.dark *){
  border-color: rgb(99 102 241 / 0.5);
}

.dark\\:border-neutral-500:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(107 114 128 / var(--tw-border-opacity, 1));
}

.dark\\:border-neutral-900:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(17 24 39 / var(--tw-border-opacity, 1));
}

.dark\\:border-primary-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.dark\\:border-primary-400\\/20:is(.dark *){
  border-color: rgb(96 165 250 / 0.2);
}

.dark\\:border-primary-400\\/25:is(.dark *){
  border-color: rgb(96 165 250 / 0.25);
}

.dark\\:border-primary-400\\/30:is(.dark *){
  border-color: rgb(96 165 250 / 0.3);
}

.dark\\:border-primary-400\\/40:is(.dark *){
  border-color: rgb(96 165 250 / 0.4);
}

.dark\\:border-primary-400\\/50:is(.dark *){
  border-color: rgb(96 165 250 / 0.5);
}

.dark\\:border-primary-500\\/25:is(.dark *){
  border-color: rgb(59 130 246 / 0.25);
}

.dark\\:border-purple-500\\/30:is(.dark *){
  border-color: rgb(168 85 247 / 0.3);
}

.dark\\:border-red-400\\/30:is(.dark *){
  border-color: rgb(248 113 113 / 0.3);
}

.dark\\:border-red-400\\/40:is(.dark *){
  border-color: rgb(248 113 113 / 0.4);
}

.dark\\:border-red-500\\/25:is(.dark *){
  border-color: rgb(239 68 68 / 0.25);
}

.dark\\:border-red-500\\/30:is(.dark *){
  border-color: rgb(239 68 68 / 0.3);
}

.dark\\:border-rose-500\\/25:is(.dark *){
  border-color: rgb(244 63 94 / 0.25);
}

.dark\\:border-violet-400:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}

.dark\\:border-violet-400\\/20:is(.dark *){
  border-color: rgb(167 139 250 / 0.2);
}

.dark\\:border-violet-400\\/30:is(.dark *){
  border-color: rgb(167 139 250 / 0.3);
}

.dark\\:border-violet-500\\/30:is(.dark *){
  border-color: rgb(139 92 246 / 0.3);
}

.dark\\:border-white\\/10:is(.dark *){
  border-color: rgb(255 255 255 / 0.1);
}

.dark\\:border-white\\/15:is(.dark *){
  border-color: rgb(255 255 255 / 0.15);
}

.dark\\:border-white\\/20:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:border-white\\/5:is(.dark *){
  border-color: rgb(255 255 255 / 0.05);
}

.dark\\:border-white\\/\\[0\\.08\\]:is(.dark *){
  border-color: rgb(255 255 255 / 0.08);
}

.dark\\:bg-\\[\\#0b0b15\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(11 11 21 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#0b0b15\\]\\/95:is(.dark *){
  background-color: rgb(11 11 21 / 0.95);
}

.dark\\:bg-\\[\\#0c0c14\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(12 12 20 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#0d0d18\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(13 13 24 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#10101a\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 26 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#10101e\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(16 16 30 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#10101e\\]\\/90:is(.dark *){
  background-color: rgb(16 16 30 / 0.9);
}

.dark\\:bg-\\[\\#12121f\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(18 18 31 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#13131f\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(19 19 31 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#13151f\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(19 21 31 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#161628\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(22 22 40 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#161628\\]\\/95:is(.dark *){
  background-color: rgb(22 22 40 / 0.95);
}

.dark\\:bg-\\[\\#1a1a2e\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 46 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-\\[\\#202033\\]:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(32 32 51 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-accent-500\\/15:is(.dark *){
  background-color: rgb(37 99 235 / 0.15);
}

.dark\\:bg-accent-600\\/20:is(.dark *){
  background-color: rgb(37 99 235 / 0.2);
}

.dark\\:bg-amber-500\\/15:is(.dark *){
  background-color: rgb(245 158 11 / 0.15);
}

.dark\\:bg-black\\/65:is(.dark *){
  background-color: rgb(0 0 0 / 0.65);
}

.dark\\:bg-blue-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-blue-500\\/10:is(.dark *){
  background-color: rgb(59 130 246 / 0.1);
}

.dark\\:bg-blue-500\\/15:is(.dark *){
  background-color: rgb(59 130 246 / 0.15);
}

.dark\\:bg-blue-500\\/20:is(.dark *){
  background-color: rgb(59 130 246 / 0.2);
}

.dark\\:bg-blue-500\\/25:is(.dark *){
  background-color: rgb(59 130 246 / 0.25);
}

.dark\\:bg-blue-500\\/30:is(.dark *){
  background-color: rgb(59 130 246 / 0.3);
}

.dark\\:bg-dashboard-500\\/10:is(.dark *){
  background-color: rgb(37 99 235 / 0.1);
}

.dark\\:bg-dashboard-500\\/15:is(.dark *){
  background-color: rgb(37 99 235 / 0.15);
}

.dark\\:bg-dashboard-600\\/25:is(.dark *){
  background-color: rgb(37 99 235 / 0.25);
}

.dark\\:bg-emerald-500\\/10:is(.dark *){
  background-color: rgb(16 185 129 / 0.1);
}

.dark\\:bg-emerald-500\\/15:is(.dark *){
  background-color: rgb(16 185 129 / 0.15);
}

.dark\\:bg-emerald-500\\/20:is(.dark *){
  background-color: rgb(16 185 129 / 0.2);
}

.dark\\:bg-emerald-500\\/25:is(.dark *){
  background-color: rgb(16 185 129 / 0.25);
}

.dark\\:bg-green-500\\/10:is(.dark *){
  background-color: rgb(34 197 94 / 0.1);
}

.dark\\:bg-green-500\\/15:is(.dark *){
  background-color: rgb(34 197 94 / 0.15);
}

.dark\\:bg-indigo-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(129 140 248 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-indigo-500\\/10:is(.dark *){
  background-color: rgb(99 102 241 / 0.1);
}

.dark\\:bg-indigo-500\\/15:is(.dark *){
  background-color: rgb(99 102 241 / 0.15);
}

.dark\\:bg-indigo-500\\/20:is(.dark *){
  background-color: rgb(99 102 241 / 0.2);
}

.dark\\:bg-indigo-500\\/30:is(.dark *){
  background-color: rgb(99 102 241 / 0.3);
}

.dark\\:bg-indigo-500\\/40:is(.dark *){
  background-color: rgb(99 102 241 / 0.4);
}

.dark\\:bg-neutral-500:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-neutral-600:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-neutral-700:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-neutral-800:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(31 41 55 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-neutral-900:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(17 24 39 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-neutral-900\\/95:is(.dark *){
  background-color: rgb(17 24 39 / 0.95);
}

.dark\\:bg-orange-500\\/15:is(.dark *){
  background-color: rgb(249 115 22 / 0.15);
}

.dark\\:bg-pink-500\\/15:is(.dark *){
  background-color: rgb(236 72 153 / 0.15);
}

.dark\\:bg-primary-500\\/10:is(.dark *){
  background-color: rgb(59 130 246 / 0.1);
}

.dark\\:bg-primary-500\\/15:is(.dark *){
  background-color: rgb(59 130 246 / 0.15);
}

.dark\\:bg-primary-500\\/20:is(.dark *){
  background-color: rgb(59 130 246 / 0.2);
}

.dark\\:bg-primary-500\\/35:is(.dark *){
  background-color: rgb(59 130 246 / 0.35);
}

.dark\\:bg-purple-500\\/10:is(.dark *){
  background-color: rgb(168 85 247 / 0.1);
}

.dark\\:bg-purple-500\\/15:is(.dark *){
  background-color: rgb(168 85 247 / 0.15);
}

.dark\\:bg-red-500\\/10:is(.dark *){
  background-color: rgb(239 68 68 / 0.1);
}

.dark\\:bg-red-500\\/15:is(.dark *){
  background-color: rgb(239 68 68 / 0.15);
}

.dark\\:bg-red-500\\/20:is(.dark *){
  background-color: rgb(239 68 68 / 0.2);
}

.dark\\:bg-rose-500\\/10:is(.dark *){
  background-color: rgb(244 63 94 / 0.1);
}

.dark\\:bg-rose-500\\/15:is(.dark *){
  background-color: rgb(244 63 94 / 0.15);
}

.dark\\:bg-sky-500\\/10:is(.dark *){
  background-color: rgb(14 165 233 / 0.1);
}

.dark\\:bg-teal-500\\/15:is(.dark *){
  background-color: rgb(20 184 166 / 0.15);
}

.dark\\:bg-transparent:is(.dark *){
  background-color: transparent;
}

.dark\\:bg-violet-400:is(.dark *){
  --tw-bg-opacity: 1;
  background-color: rgb(167 139 250 / var(--tw-bg-opacity, 1));
}

.dark\\:bg-violet-500\\/10:is(.dark *){
  background-color: rgb(139 92 246 / 0.1);
}

.dark\\:bg-violet-500\\/15:is(.dark *){
  background-color: rgb(139 92 246 / 0.15);
}

.dark\\:bg-violet-500\\/20:is(.dark *){
  background-color: rgb(139 92 246 / 0.2);
}

.dark\\:bg-white\\/10:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:bg-white\\/15:is(.dark *){
  background-color: rgb(255 255 255 / 0.15);
}

.dark\\:bg-white\\/5:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:bg-white\\/\\[0\\.02\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.02);
}

.dark\\:bg-white\\/\\[0\\.03\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}

.dark\\:bg-white\\/\\[0\\.045\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.045);
}

.dark\\:bg-white\\/\\[0\\.04\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.04);
}

.dark\\:bg-white\\/\\[0\\.06\\]:is(.dark *){
  background-color: rgb(255 255 255 / 0.06);
}

.dark\\:bg-yellow-500\\/10:is(.dark *){
  background-color: rgb(234 179 8 / 0.1);
}

.dark\\:from-\\[\\#10101a\\]:is(.dark *){
  --tw-gradient-from: #10101a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 16 26 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-emerald-500\\/10:is(.dark *){
  --tw-gradient-from: rgb(16 185 129 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-emerald-500\\/20:is(.dark *){
  --tw-gradient-from: rgb(16 185 129 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-indigo-500\\/10:is(.dark *){
  --tw-gradient-from: rgb(99 102 241 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-indigo-500\\/15:is(.dark *){
  --tw-gradient-from: rgb(99 102 241 / 0.15) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-indigo-500\\/5:is(.dark *){
  --tw-gradient-from: rgb(99 102 241 / 0.05) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(99 102 241 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-violet-500\\/20:is(.dark *){
  --tw-gradient-from: rgb(139 92 246 / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-violet-500\\/25:is(.dark *){
  --tw-gradient-from: rgb(139 92 246 / 0.25) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(139 92 246 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:from-white\\/10:is(.dark *){
  --tw-gradient-from: rgb(255 255 255 / 0.1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.dark\\:via-\\[\\#10101a\\]:is(.dark *){
  --tw-gradient-to: rgb(16 16 26 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #10101a var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-\\[\\#1a1a2e\\]:is(.dark *){
  --tw-gradient-to: rgb(26 26 46 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #1a1a2e var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:via-neutral-900:is(.dark *){
  --tw-gradient-to: rgb(17 24 39 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #111827 var(--tw-gradient-via-position), var(--tw-gradient-to);
}

.dark\\:to-\\[\\#0d0d18\\]:is(.dark *){
  --tw-gradient-to: #0d0d18 var(--tw-gradient-to-position);
}

.dark\\:to-\\[\\#13131f\\]:is(.dark *){
  --tw-gradient-to: #13131f var(--tw-gradient-to-position);
}

.dark\\:to-emerald-500\\/5:is(.dark *){
  --tw-gradient-to: rgb(16 185 129 / 0.05) var(--tw-gradient-to-position);
}

.dark\\:to-indigo-500\\/20:is(.dark *){
  --tw-gradient-to: rgb(99 102 241 / 0.2) var(--tw-gradient-to-position);
}

.dark\\:to-indigo-500\\/25:is(.dark *){
  --tw-gradient-to: rgb(99 102 241 / 0.25) var(--tw-gradient-to-position);
}

.dark\\:to-violet-500\\/10:is(.dark *){
  --tw-gradient-to: rgb(139 92 246 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-violet-500\\/5:is(.dark *){
  --tw-gradient-to: rgb(139 92 246 / 0.05) var(--tw-gradient-to-position);
}

.dark\\:to-violet-600\\/10:is(.dark *){
  --tw-gradient-to: rgb(124 58 237 / 0.1) var(--tw-gradient-to-position);
}

.dark\\:to-white\\/5:is(.dark *){
  --tw-gradient-to: rgb(255 255 255 / 0.05) var(--tw-gradient-to-position);
}

.dark\\:stroke-blue-500\\/20:is(.dark *){
  stroke: rgb(59 130 246 / 0.2);
}

.dark\\:text-\\[\\#a0a0b0\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(160 160 176 / var(--tw-text-opacity, 1));
}

.dark\\:text-\\[\\#f3f4f6\\]:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-accent-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 230 138 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}

.dark\\:text-amber-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-200\\/80:is(.dark *){
  color: rgb(191 219 254 / 0.8);
}

.dark\\:text-blue-200\\/90:is(.dark *){
  color: rgb(191 219 254 / 0.9);
}

.dark\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-blue-300\\/80:is(.dark *){
  color: rgb(147 197 253 / 0.8);
}

.dark\\:text-blue-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-dashboard-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.dark\\:text-emerald-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}

.dark\\:text-green-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(74 222 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(199 210 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:text-neutral-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:text-neutral-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:text-neutral-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:text-neutral-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-neutral-50:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity, 1));
}

.dark\\:text-neutral-500:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:text-neutral-600:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 215 170 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}

.dark\\:text-orange-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 146 60 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 207 232 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(249 168 212 / var(--tw-text-opacity, 1));
}

.dark\\:text-pink-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(244 114 182 / var(--tw-text-opacity, 1));
}

.dark\\:text-primary-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-primary-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(233 213 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-purple-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(192 132 252 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:text-red-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(254 205 211 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 164 175 / var(--tw-text-opacity, 1));
}

.dark\\:text-rose-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:text-teal-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(153 246 228 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-100:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(237 233 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.dark\\:text-violet-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(167 139 250 / var(--tw-text-opacity, 1));
}

.dark\\:text-white:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:text-white\\/10:is(.dark *){
  color: rgb(255 255 255 / 0.1);
}

.dark\\:placeholder-neutral-500:is(.dark *)::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(107 114 128 / var(--tw-placeholder-opacity, 1));
}

.dark\\:shadow-\\[0_12px_48px_-16px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.65\\)\\]:is(.dark *){
  --tw-shadow: 0 12px 48px -16px rgba(0,0,0,0.65);
  --tw-shadow-colored: 0 12px 48px -16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0_30px_90px_-20px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.8\\)\\]:is(.dark *){
  --tw-shadow: 0 30px 90px -20px rgba(0,0,0,0.8);
  --tw-shadow-colored: 0 30px 90px -20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-\\[0_4px_24px_-12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\]:is(.dark *){
  --tw-shadow: 0 4px 24px -12px rgba(0,0,0,0.6);
  --tw-shadow-colored: 0 4px 24px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-none:is(.dark *){
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark\\:shadow-black\\/20:is(.dark *){
  --tw-shadow-color: rgb(0 0 0 / 0.2);
  --tw-shadow: var(--tw-shadow-colored);
}

.dark\\:ring-blue-500\\/20:is(.dark *){
  --tw-ring-color: rgb(59 130 246 / 0.2);
}

.dark\\:ring-indigo-500\\/20:is(.dark *){
  --tw-ring-color: rgb(99 102 241 / 0.2);
}

.dark\\:ring-neutral-200:is(.dark *){
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(229 231 235 / var(--tw-ring-opacity, 1));
}

.dark\\:ring-white\\/10:is(.dark *){
  --tw-ring-color: rgb(255 255 255 / 0.1);
}

.dark\\:brightness-125:is(.dark *){
  --tw-brightness: brightness(1.25);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.dark\\:placeholder\\:text-neutral-500:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}

.dark\\:placeholder\\:text-neutral-600:is(.dark *)::placeholder{
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}

.dark\\:focus-within\\:border-blue-500\\/40:focus-within:is(.dark *){
  border-color: rgb(59 130 246 / 0.4);
}

.dark\\:focus-within\\:border-purple-500\\/50:focus-within:is(.dark *){
  border-color: rgb(168 85 247 / 0.5);
}

.dark\\:focus-within\\:ring-blue-500\\/25:focus-within:is(.dark *){
  --tw-ring-color: rgb(59 130 246 / 0.25);
}

.dark\\:focus-within\\:ring-purple-500\\/15:focus-within:is(.dark *){
  --tw-ring-color: rgb(168 85 247 / 0.15);
}

.dark\\:hover\\:border-blue-400\\/40:hover:is(.dark *){
  border-color: rgb(96 165 250 / 0.4);
}

.dark\\:hover\\:border-blue-500\\/30:hover:is(.dark *){
  border-color: rgb(59 130 246 / 0.3);
}

.dark\\:hover\\:border-dashboard-400:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-indigo-400\\/40:hover:is(.dark *){
  border-color: rgb(129 140 248 / 0.4);
}

.dark\\:hover\\:border-indigo-500\\/30:hover:is(.dark *){
  border-color: rgb(99 102 241 / 0.3);
}

.dark\\:hover\\:border-indigo-500\\/40:hover:is(.dark *){
  border-color: rgb(99 102 241 / 0.4);
}

.dark\\:hover\\:border-primary-400\\/40:hover:is(.dark *){
  border-color: rgb(96 165 250 / 0.4);
}

.dark\\:hover\\:border-primary-500\\/40:hover:is(.dark *){
  border-color: rgb(59 130 246 / 0.4);
}

.dark\\:hover\\:border-violet-400:hover:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(167 139 250 / var(--tw-border-opacity, 1));
}

.dark\\:hover\\:border-violet-500\\/30:hover:is(.dark *){
  border-color: rgb(139 92 246 / 0.3);
}

.dark\\:hover\\:border-white\\/15:hover:is(.dark *){
  border-color: rgb(255 255 255 / 0.15);
}

.dark\\:hover\\:border-white\\/20:hover:is(.dark *){
  border-color: rgb(255 255 255 / 0.2);
}

.dark\\:hover\\:border-white\\/25:hover:is(.dark *){
  border-color: rgb(255 255 255 / 0.25);
}

.dark\\:hover\\:bg-blue-500\\/10:hover:is(.dark *){
  background-color: rgb(59 130 246 / 0.1);
}

.dark\\:hover\\:bg-blue-500\\/15:hover:is(.dark *){
  background-color: rgb(59 130 246 / 0.15);
}

.dark\\:hover\\:bg-blue-500\\/25:hover:is(.dark *){
  background-color: rgb(59 130 246 / 0.25);
}

.dark\\:hover\\:bg-emerald-500\\/10:hover:is(.dark *){
  background-color: rgb(16 185 129 / 0.1);
}

.dark\\:hover\\:bg-indigo-500\\/10:hover:is(.dark *){
  background-color: rgb(99 102 241 / 0.1);
}

.dark\\:hover\\:bg-orange-500\\/10:hover:is(.dark *){
  background-color: rgb(249 115 22 / 0.1);
}

.dark\\:hover\\:bg-orange-500\\/25:hover:is(.dark *){
  background-color: rgb(249 115 22 / 0.25);
}

.dark\\:hover\\:bg-pink-500\\/10:hover:is(.dark *){
  background-color: rgb(236 72 153 / 0.1);
}

.dark\\:hover\\:bg-primary-500\\/10:hover:is(.dark *){
  background-color: rgb(59 130 246 / 0.1);
}

.dark\\:hover\\:bg-primary-500\\/15:hover:is(.dark *){
  background-color: rgb(59 130 246 / 0.15);
}

.dark\\:hover\\:bg-primary-500\\/25:hover:is(.dark *){
  background-color: rgb(59 130 246 / 0.25);
}

.dark\\:hover\\:bg-red-500\\/10:hover:is(.dark *){
  background-color: rgb(239 68 68 / 0.1);
}

.dark\\:hover\\:bg-rose-500\\/10:hover:is(.dark *){
  background-color: rgb(244 63 94 / 0.1);
}

.dark\\:hover\\:bg-rose-500\\/15:hover:is(.dark *){
  background-color: rgb(244 63 94 / 0.15);
}

.dark\\:hover\\:bg-violet-500\\/10:hover:is(.dark *){
  background-color: rgb(139 92 246 / 0.1);
}

.dark\\:hover\\:bg-violet-500\\/15:hover:is(.dark *){
  background-color: rgb(139 92 246 / 0.15);
}

.dark\\:hover\\:bg-white\\/10:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:bg-white\\/15:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.15);
}

.dark\\:hover\\:bg-white\\/5:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:hover\\:bg-white\\/\\[0\\.03\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.03);
}

.dark\\:hover\\:bg-white\\/\\[0\\.04\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.04);
}

.dark\\:hover\\:bg-white\\/\\[0\\.06\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.06);
}

.dark\\:hover\\:bg-white\\/\\[0\\.07\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.07);
}

.dark\\:hover\\:bg-white\\/\\[0\\.08\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.08);
}

.dark\\:hover\\:bg-white\\/\\[0\\.1\\]:hover:is(.dark *){
  background-color: rgb(255 255 255 / 0.1);
}

.dark\\:hover\\:text-blue-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-dashboard-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-dashboard-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-indigo-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(165 180 252 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-indigo-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-neutral-100:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(243 244 246 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-neutral-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-neutral-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-neutral-50:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(249 250 251 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-primary-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(191 219 254 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-primary-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-red-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-red-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-rose-400:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-violet-200:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-violet-300:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(196 181 253 / var(--tw-text-opacity, 1));
}

.dark\\:hover\\:text-white:hover:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.dark\\:focus\\:border-blue-500\\/40:focus:is(.dark *){
  border-color: rgb(59 130 246 / 0.4);
}

.dark\\:focus\\:border-dashboard-400:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-indigo-400\\/50:focus:is(.dark *){
  border-color: rgb(129 140 248 / 0.5);
}

.dark\\:focus\\:border-primary-400:focus:is(.dark *){
  --tw-border-opacity: 1;
  border-color: rgb(96 165 250 / var(--tw-border-opacity, 1));
}

.dark\\:focus\\:border-purple-500\\/50:focus:is(.dark *){
  border-color: rgb(168 85 247 / 0.5);
}

.dark\\:focus\\:bg-white\\/\\[0\\.08\\]:focus:is(.dark *){
  background-color: rgb(255 255 255 / 0.08);
}

.dark\\:focus\\:\\!ring-error-500\\/20:focus:is(.dark *){
  --tw-ring-color: rgb(37 99 235 / 0.2) !important;
}

.dark\\:focus\\:ring-blue-500\\/25:focus:is(.dark *){
  --tw-ring-color: rgb(59 130 246 / 0.25);
}

.dark\\:focus\\:ring-blue-500\\/40:focus:is(.dark *){
  --tw-ring-color: rgb(59 130 246 / 0.4);
}

.dark\\:focus\\:ring-dashboard-500\\/20:focus:is(.dark *){
  --tw-ring-color: rgb(37 99 235 / 0.2);
}

.dark\\:focus\\:ring-error-500\\/20:focus:is(.dark *){
  --tw-ring-color: rgb(37 99 235 / 0.2);
}

.dark\\:focus\\:ring-indigo-500\\/15:focus:is(.dark *){
  --tw-ring-color: rgb(99 102 241 / 0.15);
}

.dark\\:focus\\:ring-primary-400\\/30:focus:is(.dark *){
  --tw-ring-color: rgb(96 165 250 / 0.3);
}

.dark\\:disabled\\:bg-white\\/5:disabled:is(.dark *){
  background-color: rgb(255 255 255 / 0.05);
}

.dark\\:disabled\\:hover\\:text-neutral-400:hover:disabled:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-blue-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(147 197 253 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-emerald-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(110 231 183 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-indigo-400:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(129 140 248 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-neutral-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(229 231 235 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-neutral-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-orange-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(253 186 116 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-red-300:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}

.group:hover .dark\\:group-hover\\:text-violet-200:is(.dark *){
  --tw-text-opacity: 1;
  color: rgb(221 214 254 / var(--tw-text-opacity, 1));
}

@media not all and (min-width: 1024px){

  .max-lg\\:fixed{
    position: fixed;
  }

  .max-lg\\:inset-x-0{
    left: 0px;
    right: 0px;
  }

  .max-lg\\:bottom-\\[calc\\(3\\.5rem\\+env\\(safe-area-inset-bottom\\)\\)\\]{
    bottom: calc(3.5rem + env(safe-area-inset-bottom));
  }

  .max-lg\\:z-30{
    z-index: 30;
  }

  .max-lg\\:mx-0{
    margin-left: 0px;
    margin-right: 0px;
  }

  .max-lg\\:mb-1{
    margin-bottom: 4px;
  }

  .max-lg\\:mb-3{
    margin-bottom: 12px;
  }

  .max-lg\\:w-full{
    width: 100%;
  }

  .max-lg\\:max-w-none{
    max-width: none;
  }

  .max-lg\\:gap-0{
    gap: 0px;
  }

  .max-lg\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .max-lg\\:rounded-none{
    border-radius: 0;
  }

  .max-lg\\:border-0{
    border-width: 0px;
  }

  .max-lg\\:border-x-0{
    border-left-width: 0px;
    border-right-width: 0px;
  }

  .max-lg\\:border-b{
    border-bottom-width: 1px;
  }

  .max-lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .max-lg\\:border-t-0{
    border-top-width: 0px;
  }

  .max-lg\\:border-white\\/10{
    border-color: rgb(255 255 255 / 0.1);
  }

  .max-lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .max-lg\\:pb-28{
    padding-bottom: 112px;
  }

  .max-lg\\:text-lg{
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: -0.01em;
  }

  .max-lg\\:text-sm{
    font-size: 0.8125rem;
    line-height: 1.25rem;
    letter-spacing: 0;
  }

  .max-lg\\:shadow-none{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .max-lg\\:hover\\:shadow-none:hover{
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 640px){

  .sm\\:left-6{
    left: 24px;
  }

  .sm\\:left-\\[18px\\]{
    left: 18px;
  }

  .sm\\:right-6{
    right: 24px;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:-mt-20{
    margin-top: -80px;
  }

  .sm\\:mb-4{
    margin-bottom: 16px;
  }

  .sm\\:mb-5{
    margin-bottom: 20px;
  }

  .sm\\:mb-6{
    margin-bottom: 24px;
  }

  .sm\\:ml-10{
    margin-left: 40px;
  }

  .sm\\:ml-2{
    margin-left: 8px;
  }

  .sm\\:ml-\\[40px\\]{
    margin-left: 40px;
  }

  .sm\\:ml-\\[52px\\]{
    margin-left: 52px;
  }

  .sm\\:ml-\\[66px\\]{
    margin-left: 66px;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:h-10{
    height: 40px;
  }

  .sm\\:h-12{
    height: 48px;
  }

  .sm\\:h-14{
    height: 56px;
  }

  .sm\\:h-16{
    height: 64px;
  }

  .sm\\:h-20{
    height: 80px;
  }

  .sm\\:h-32{
    height: 128px;
  }

  .sm\\:h-5{
    height: 20px;
  }

  .sm\\:h-7{
    height: 28px;
  }

  .sm\\:h-8{
    height: 32px;
  }

  .sm\\:h-9{
    height: 36px;
  }

  .sm\\:h-\\[18px\\]{
    height: 18px;
  }

  .sm\\:h-\\[52px\\]{
    height: 52px;
  }

  .sm\\:h-\\[72px\\]{
    height: 72px;
  }

  .sm\\:h-auto{
    height: auto;
  }

  .sm\\:max-h-\\[90vh\\]{
    max-height: 90vh;
  }

  .sm\\:min-h-\\[2\\.25rem\\]{
    min-height: 2.25rem;
  }

  .sm\\:min-h-\\[460px\\]{
    min-height: 460px;
  }

  .sm\\:w-10{
    width: 40px;
  }

  .sm\\:w-12{
    width: 48px;
  }

  .sm\\:w-14{
    width: 56px;
  }

  .sm\\:w-16{
    width: 64px;
  }

  .sm\\:w-20{
    width: 80px;
  }

  .sm\\:w-40{
    width: 160px;
  }

  .sm\\:w-44{
    width: 176px;
  }

  .sm\\:w-5{
    width: 20px;
  }

  .sm\\:w-7{
    width: 28px;
  }

  .sm\\:w-8{
    width: 32px;
  }

  .sm\\:w-80{
    width: 320px;
  }

  .sm\\:w-9{
    width: 36px;
  }

  .sm\\:w-\\[18px\\]{
    width: 18px;
  }

  .sm\\:w-\\[38\\%\\]{
    width: 38%;
  }

  .sm\\:w-\\[40px\\]{
    width: 40px;
  }

  .sm\\:w-\\[52px\\]{
    width: 52px;
  }

  .sm\\:w-\\[72px\\]{
    width: 72px;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:min-w-\\[112px\\]{
    min-width: 112px;
  }

  .sm\\:max-w-2xl{
    max-width: 42rem;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-none{
    max-width: none;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-nowrap{
    flex-wrap: nowrap;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:gap-1{
    gap: 4px;
  }

  .sm\\:gap-1\\.5{
    gap: 6px;
  }

  .sm\\:gap-2{
    gap: 8px;
  }

  .sm\\:gap-3{
    gap: 12px;
  }

  .sm\\:gap-3\\.5{
    gap: 14px;
  }

  .sm\\:gap-4{
    gap: 16px;
  }

  .sm\\:gap-5{
    gap: 20px;
  }

  .sm\\:gap-8{
    gap: 32px;
  }

  .sm\\:space-y-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(4px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(4px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(8px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(8px * var(--tw-space-y-reverse));
  }

  .sm\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(16px * var(--tw-space-y-reverse));
  }

  .sm\\:divide-x > :not([hidden]) ~ :not([hidden]){
    --tw-divide-x-reverse: 0;
    border-right-width: calc(1px * var(--tw-divide-x-reverse));
    border-left-width: calc(1px * calc(1 - var(--tw-divide-x-reverse)));
  }

  .sm\\:divide-y-0 > :not([hidden]) ~ :not([hidden]){
    --tw-divide-y-reverse: 0;
    border-top-width: calc(0px * calc(1 - var(--tw-divide-y-reverse)));
    border-bottom-width: calc(0px * var(--tw-divide-y-reverse));
  }

  .sm\\:overflow-visible{
    overflow: visible;
  }

  .sm\\:rounded-2xl{
    border-radius: 16px;
  }

  .sm\\:rounded-lg{
    border-radius: 10px;
  }

  .sm\\:rounded-xl{
    border-radius: 12px;
  }

  .sm\\:border{
    border-width: 1px;
  }

  .sm\\:border-r{
    border-right-width: 1px;
  }

  .sm\\:border-gray-100{
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
  }

  .sm\\:border-neutral-100{
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
  }

  .sm\\:border-neutral-200\\/60{
    border-color: rgb(229 231 235 / 0.6);
  }

  .sm\\:p-12{
    padding: 48px;
  }

  .sm\\:p-4{
    padding: 16px;
  }

  .sm\\:p-5{
    padding: 20px;
  }

  .sm\\:p-6{
    padding: 24px;
  }

  .sm\\:p-7{
    padding: 28px;
  }

  .sm\\:p-8{
    padding: 32px;
  }

  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-1\\.5{
    padding-left: 6px;
    padding-right: 6px;
  }

  .sm\\:px-2\\.5{
    padding-left: 10px;
    padding-right: 10px;
  }

  .sm\\:px-3{
    padding-left: 12px;
    padding-right: 12px;
  }

  .sm\\:px-3\\.5{
    padding-left: 14px;
    padding-right: 14px;
  }

  .sm\\:px-4{
    padding-left: 16px;
    padding-right: 16px;
  }

  .sm\\:px-5{
    padding-left: 20px;
    padding-right: 20px;
  }

  .sm\\:px-6{
    padding-left: 24px;
    padding-right: 24px;
  }

  .sm\\:px-7{
    padding-left: 28px;
    padding-right: 28px;
  }

  .sm\\:px-8{
    padding-left: 32px;
    padding-right: 32px;
  }

  .sm\\:py-1\\.5{
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .sm\\:py-10{
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .sm\\:py-12{
    padding-top: 48px;
    padding-bottom: 48px;
  }

  .sm\\:py-2{
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .sm\\:py-2\\.5{
    padding-top: 10px;
    padding-bottom: 10px;
  }

  .sm\\:py-3{
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .sm\\:py-5{
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .sm\\:py-\\[7px\\]{
    padding-top: 7px;
    padding-bottom: 7px;
  }

  .sm\\:pb-28{
    padding-bottom: 112px;
  }

  .sm\\:pb-5{
    padding-bottom: 20px;
  }

  .sm\\:pb-6{
    padding-bottom: 24px;
  }

  .sm\\:pr-20{
    padding-right: 80px;
  }

  .sm\\:pt-4{
    padding-top: 16px;
  }

  .sm\\:pt-6{
    padding-top: 24px;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-2xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
    letter-spacing: -0.02em;
  }

  .sm\\:text-3xl{
    font-size: 1.5rem;
    line-height: 2rem;
    letter-spacing: -0.02em;
  }

  .sm\\:text-4xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
    letter-spacing: -0.025em;
  }

  .sm\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .sm\\:text-\\[11\\.5px\\]{
    font-size: 11.5px;
  }

  .sm\\:text-\\[11px\\]{
    font-size: 11px;
  }

  .sm\\:text-\\[12\\.5px\\]{
    font-size: 12.5px;
  }

  .sm\\:text-\\[12px\\]{
    font-size: 12px;
  }

  .sm\\:text-\\[13px\\]{
    font-size: 13px;
  }

  .sm\\:text-\\[15px\\]{
    font-size: 15px;
  }

  .sm\\:text-\\[16px\\]{
    font-size: 16px;
  }

  .sm\\:text-\\[17px\\]{
    font-size: 17px;
  }

  .sm\\:text-\\[18px\\]{
    font-size: 18px;
  }

  .sm\\:text-\\[24px\\]{
    font-size: 24px;
  }

  .sm\\:text-\\[26px\\]{
    font-size: 26px;
  }

  .sm\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .sm\\:text-\\[32px\\]{
    font-size: 32px;
  }

  .sm\\:text-\\[34px\\]{
    font-size: 34px;
  }

  .sm\\:text-\\[9px\\]{
    font-size: 9px;
  }

  .sm\\:text-base{
    font-size: 0.875rem;
    line-height: 1.375rem;
    letter-spacing: 0;
  }

  .sm\\:text-lg{
    font-size: 1rem;
    line-height: 1.5rem;
    letter-spacing: -0.01em;
  }

  .sm\\:text-sm{
    font-size: 0.8125rem;
    line-height: 1.25rem;
    letter-spacing: 0;
  }

  .sm\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.01em;
  }

  .sm\\:leading-\\[1\\.7\\]{
    line-height: 1.7;
  }

  .sm\\:shadow-\\[0_2px_12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.04\\)\\]{
    --tw-shadow: 0 2px 12px rgba(0,0,0,0.04);
    --tw-shadow-colored: 0 2px 12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .sm\\:shadow-sm{
    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .hover\\:sm\\:shadow-\\[0_4px_24px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.08\\)\\]:hover{
    --tw-shadow: 0 4px 24px rgba(0,0,0,0.08);
    --tw-shadow-colored: 0 4px 24px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .dark\\:sm\\:border-white\\/10:is(.dark *){
    border-color: rgb(255 255 255 / 0.1);
  }

  .dark\\:sm\\:shadow-\\[0_4px_24px_-12px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.6\\)\\]:is(.dark *){
    --tw-shadow: 0 4px 24px -12px rgba(0,0,0,0.6);
    --tw-shadow-colored: 0 4px 24px -12px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@media (min-width: 768px){

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:-mt-16{
    margin-top: -64px;
  }

  .md\\:mt-1\\.5{
    margin-top: 6px;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:inline-flex{
    display: inline-flex;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:h-4{
    height: 16px;
  }

  .md\\:h-44{
    height: 176px;
  }

  .md\\:h-48{
    height: 192px;
  }

  .md\\:h-60{
    height: 240px;
  }

  .md\\:h-64{
    height: 256px;
  }

  .md\\:h-8{
    height: 32px;
  }

  .md\\:h-\\[100px\\]{
    height: 100px;
  }

  .md\\:h-\\[220px\\]{
    height: 220px;
  }

  .md\\:h-\\[72px\\]{
    height: 72px;
  }

  .md\\:w-4{
    width: 16px;
  }

  .md\\:w-8{
    width: 32px;
  }

  .md\\:w-\\[100px\\]{
    width: 100px;
  }

  .md\\:w-\\[360px\\]{
    width: 360px;
  }

  .md\\:w-\\[72px\\]{
    width: 72px;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1fr_220px\\]{
    grid-template-columns: 1fr 220px;
  }

  .md\\:grid-cols-\\[1fr_minmax\\(220px\\2c 42\\%\\)\\]{
    grid-template-columns: 1fr minmax(220px,42%);
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:items-stretch{
    align-items: stretch;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:gap-1\\.5{
    gap: 6px;
  }

  .md\\:gap-2{
    gap: 8px;
  }

  .md\\:gap-3{
    gap: 12px;
  }

  .md\\:gap-5{
    gap: 20px;
  }

  .md\\:gap-lp-md{
    gap: 24px;
  }

  .md\\:border-b-0{
    border-bottom-width: 0px;
  }

  .md\\:border-r{
    border-right-width: 1px;
  }

  .md\\:border-gray-100{
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
  }

  .md\\:bg-\\[\\#F3F2EF\\]{
    --tw-bg-opacity: 1;
    background-color: rgb(243 242 239 / var(--tw-bg-opacity, 1));
  }

  .md\\:p-6{
    padding: 24px;
  }

  .md\\:p-8{
    padding: 32px;
  }

  .md\\:p-lp-lg{
    padding: 40px;
  }

  .md\\:p-lp-xl{
    padding: 80px;
  }

  .md\\:px-3{
    padding-left: 12px;
    padding-right: 12px;
  }

  .md\\:px-4{
    padding-left: 16px;
    padding-right: 16px;
  }

  .md\\:px-6{
    padding-left: 24px;
    padding-right: 24px;
  }

  .md\\:px-7{
    padding-left: 28px;
    padding-right: 28px;
  }

  .md\\:px-lp-lg{
    padding-left: 40px;
    padding-right: 40px;
  }

  .md\\:py-1\\.5{
    padding-top: 6px;
    padding-bottom: 6px;
  }

  .md\\:pb-5{
    padding-bottom: 20px;
  }

  .md\\:pr-6{
    padding-right: 24px;
  }

  .md\\:pr-lp-lg{
    padding-right: 40px;
  }

  .md\\:pt-14{
    padding-top: 56px;
  }

  .md\\:pt-4{
    padding-top: 16px;
  }

  .md\\:pt-6{
    padding-top: 24px;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-2xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
    letter-spacing: -0.02em;
  }

  .md\\:text-3xl{
    font-size: 1.5rem;
    line-height: 2rem;
    letter-spacing: -0.02em;
  }

  .md\\:text-\\[22px\\]{
    font-size: 22px;
  }

  .md\\:text-\\[26px\\]{
    font-size: 26px;
  }

  .md\\:text-\\[28px\\]{
    font-size: 28px;
  }

  .md\\:text-\\[34px\\]{
    font-size: 34px;
  }

  .md\\:text-lp-headline-lg{
    font-size: 32px;
    line-height: 1.2;
    letter-spacing: -0.03em;
    font-weight: 700;
  }

  .md\\:text-lp-headline-xl{
    font-size: 48px;
    line-height: 1.1;
    letter-spacing: -0.04em;
    font-weight: 700;
  }

  .md\\:text-sm{
    font-size: 0.8125rem;
    line-height: 1.25rem;
    letter-spacing: 0;
  }

  .md\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.01em;
  }

  .dark\\:md\\:border-white\\/10:is(.dark *){
    border-color: rgb(255 255 255 / 0.1);
  }
}

@media (min-width: 1024px){

  .lg\\:relative{
    position: relative;
  }

  .lg\\:left-3{
    left: 12px;
  }

  .lg\\:top-3{
    top: 12px;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .lg\\:mx-4{
    margin-left: 16px;
    margin-right: 16px;
  }

  .lg\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:mb-1{
    margin-bottom: 4px;
  }

  .lg\\:mb-2{
    margin-bottom: 8px;
  }

  .lg\\:mb-4{
    margin-bottom: 16px;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:inline{
    display: inline;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:inline-flex{
    display: inline-flex;
  }

  .lg\\:grid{
    display: grid;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:h-12{
    height: 48px;
  }

  .lg\\:h-6{
    height: 24px;
  }

  .lg\\:h-9{
    height: 36px;
  }

  .lg\\:h-\\[220px\\]{
    height: 220px;
  }

  .lg\\:h-\\[240px\\]{
    height: 240px;
  }

  .lg\\:h-\\[calc\\(100vh-4rem\\)\\]{
    height: calc(100vh - 4rem);
  }

  .lg\\:h-\\[calc\\(100vh-60px-16px\\)\\]{
    height: calc(100vh - 60px - 16px);
  }

  .lg\\:h-auto{
    height: auto;
  }

  .lg\\:h-screen{
    height: 100vh;
  }

  .lg\\:max-h-\\[92vh\\]{
    max-height: 92vh;
  }

  .lg\\:w-12{
    width: 48px;
  }

  .lg\\:w-6{
    width: 24px;
  }

  .lg\\:w-72{
    width: 288px;
  }

  .lg\\:w-9{
    width: 36px;
  }

  .lg\\:w-\\[280px\\]{
    width: 280px;
  }

  .lg\\:w-\\[300px\\]{
    width: 300px;
  }

  .lg\\:w-\\[320px\\]{
    width: 320px;
  }

  .lg\\:w-\\[555px\\]{
    width: 555px;
  }

  .lg\\:w-full{
    width: 100%;
  }

  .lg\\:min-w-0{
    min-width: 0px;
  }

  .lg\\:min-w-\\[24px\\]{
    min-width: 24px;
  }

  .lg\\:max-w-\\[1100px\\]{
    max-width: 1100px;
  }

  .lg\\:max-w-\\[1300px\\]{
    max-width: 1300px;
  }

  .lg\\:max-w-layout{
    max-width: 1320px;
  }

  .lg\\:max-w-md{
    max-width: 28rem;
  }

  .lg\\:max-w-sm{
    max-width: 24rem;
  }

  .lg\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1fr_280px\\]{
    grid-template-columns: 1fr 280px;
  }

  .lg\\:grid-cols-\\[1fr_340px\\]{
    grid-template-columns: 1fr 340px;
  }

  .lg\\:grid-cols-\\[1fr_minmax\\(280px\\2c 52\\%\\)\\]{
    grid-template-columns: 1fr minmax(280px,52%);
  }

  .lg\\:grid-cols-\\[220px_1fr\\]{
    grid-template-columns: 220px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_320px\\]{
    grid-template-columns: minmax(0,1fr) 320px;
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:justify-center{
    justify-content: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-0\\.5{
    gap: 2px;
  }

  .lg\\:gap-1{
    gap: 4px;
  }

  .lg\\:gap-1\\.5{
    gap: 6px;
  }

  .lg\\:gap-2{
    gap: 8px;
  }

  .lg\\:gap-2\\.5{
    gap: 10px;
  }

  .lg\\:gap-3{
    gap: 12px;
  }

  .lg\\:gap-6{
    gap: 24px;
  }

  .lg\\:space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(16px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(16px * var(--tw-space-y-reverse));
  }

  .lg\\:space-y-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0;
    margin-top: calc(20px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(20px * var(--tw-space-y-reverse));
  }

  .lg\\:overflow-hidden{
    overflow: hidden;
  }

  .lg\\:overflow-visible{
    overflow: visible;
  }

  .lg\\:overflow-x-auto{
    overflow-x: auto;
  }

  .lg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .lg\\:rounded-2xl{
    border-radius: 16px;
  }

  .lg\\:rounded-3xl{
    border-radius: 20px;
  }

  .lg\\:rounded-full{
    border-radius: 9999px;
  }

  .lg\\:rounded-xl{
    border-radius: 12px;
  }

  .lg\\:border{
    border-width: 1px;
  }

  .lg\\:border-2{
    border-width: 2px;
  }

  .lg\\:border-b{
    border-bottom-width: 1px;
  }

  .lg\\:border-dashed{
    border-style: dashed;
  }

  .lg\\:border-blue-300{
    --tw-border-opacity: 1;
    border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
  }

  .lg\\:border-blue-500{
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity, 1));
  }

  .lg\\:border-neutral-100{
    --tw-border-opacity: 1;
    border-color: rgb(243 244 246 / var(--tw-border-opacity, 1));
  }

  .lg\\:border-neutral-200{
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235 / var(--tw-border-opacity, 1));
  }

  .lg\\:bg-blue-50{
    --tw-bg-opacity: 1;
    background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-blue-500{
    --tw-bg-opacity: 1;
    background-color: rgb(59 130 246 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-blue-600{
    --tw-bg-opacity: 1;
    background-color: rgb(37 99 235 / var(--tw-bg-opacity, 1));
  }

  .lg\\:bg-white{
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  }

  .lg\\:p-0\\.5{
    padding: 2px;
  }

  .lg\\:p-1\\.5{
    padding: 6px;
  }

  .lg\\:p-10{
    padding: 40px;
  }

  .lg\\:p-3{
    padding: 12px;
  }

  .lg\\:p-4{
    padding: 16px;
  }

  .lg\\:p-8{
    padding: 32px;
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-3{
    padding-left: 12px;
    padding-right: 12px;
  }

  .lg\\:px-4{
    padding-left: 16px;
    padding-right: 16px;
  }

  .lg\\:px-6{
    padding-left: 24px;
    padding-right: 24px;
  }

  .lg\\:px-8{
    padding-left: 32px;
    padding-right: 32px;
  }

  .lg\\:py-10{
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .lg\\:py-2{
    padding-top: 8px;
    padding-bottom: 8px;
  }

  .lg\\:py-3{
    padding-top: 12px;
    padding-bottom: 12px;
  }

  .lg\\:py-4{
    padding-top: 16px;
    padding-bottom: 16px;
  }

  .lg\\:py-5{
    padding-top: 20px;
    padding-bottom: 20px;
  }

  .lg\\:pb-0{
    padding-bottom: 0px;
  }

  .lg\\:pb-3{
    padding-bottom: 12px;
  }

  .lg\\:pt-6{
    padding-top: 24px;
  }

  .lg\\:text-center{
    text-align: center;
  }

  .lg\\:text-4xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
    letter-spacing: -0.025em;
  }

  .lg\\:text-\\[10px\\]{
    font-size: 10px;
  }

  .lg\\:text-\\[13px\\]{
    font-size: 13px;
  }

  .lg\\:text-\\[22px\\]{
    font-size: 22px;
  }

  .lg\\:text-\\[36px\\]{
    font-size: 36px;
  }

  .lg\\:text-sm{
    font-size: 0.8125rem;
    line-height: 1.25rem;
    letter-spacing: 0;
  }

  .lg\\:text-xs{
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.01em;
  }

  .lg\\:font-bold{
    font-weight: 700;
  }

  .lg\\:font-medium{
    font-weight: 500;
  }

  .lg\\:font-semibold{
    font-weight: 600;
  }

  .lg\\:text-blue-400{
    --tw-text-opacity: 1;
    color: rgb(96 165 250 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-blue-600{
    --tw-text-opacity: 1;
    color: rgb(37 99 235 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-blue-700{
    --tw-text-opacity: 1;
    color: rgb(29 78 216 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-neutral-400{
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-neutral-500{
    --tw-text-opacity: 1;
    color: rgb(107 114 128 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-neutral-700{
    --tw-text-opacity: 1;
    color: rgb(55 65 81 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-neutral-800{
    --tw-text-opacity: 1;
    color: rgb(31 41 55 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-neutral-900{
    --tw-text-opacity: 1;
    color: rgb(17 24 39 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-red-500{
    --tw-text-opacity: 1;
    color: rgb(239 68 68 / var(--tw-text-opacity, 1));
  }

  .lg\\:text-white\\/60{
    color: rgb(255 255 255 / 0.6);
  }

  .lg\\:text-white\\/80{
    color: rgb(255 255 255 / 0.8);
  }

  .lg\\:shadow-sm{
    --tw-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04), 0 1px 2px -1px rgba(0, 0, 0, 0.03);
    --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .lg\\:transition-all{
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }

  .lg\\:transition-colors{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
  }
  .lg\\:scrollbar-hide {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .lg\\:scrollbar-hide::-webkit-scrollbar {
    display: none;
  }
  .lg\\:hover\\:border-blue-300:hover{
    --tw-border-opacity: 1;
    border-color: rgb(147 197 253 / var(--tw-border-opacity, 1));
  }
  .lg\\:hover\\:bg-blue-100:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
  }
  .lg\\:hover\\:bg-neutral-100:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
  }
  .lg\\:hover\\:text-neutral-600:hover{
    --tw-text-opacity: 1;
    color: rgb(75 85 99 / var(--tw-text-opacity, 1));
  }
  .lg\\:focus\\:border-transparent:focus{
    border-color: transparent;
  }
  .lg\\:focus\\:outline-none:focus{
    outline: 2px solid transparent;
    outline-offset: 2px;
  }
  .lg\\:focus\\:ring-2:focus{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  }
  .lg\\:focus\\:ring-blue-400:focus{
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(96 165 250 / var(--tw-ring-opacity, 1));
  }
  .dark\\:lg\\:border-white\\/10:is(.dark *){
    border-color: rgb(255 255 255 / 0.1);
  }
  .dark\\:lg\\:bg-blue-500\\/15:is(.dark *){
    background-color: rgb(59 130 246 / 0.15);
  }
  .dark\\:lg\\:bg-white\\/5:is(.dark *){
    background-color: rgb(255 255 255 / 0.05);
  }
  .dark\\:lg\\:text-blue-300:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(147 197 253 / var(--tw-text-opacity, 1));
  }
  .dark\\:lg\\:text-neutral-100:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(243 244 246 / var(--tw-text-opacity, 1));
  }
  .dark\\:lg\\:text-neutral-200:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(229 231 235 / var(--tw-text-opacity, 1));
  }
  .dark\\:lg\\:text-neutral-400:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(156 163 175 / var(--tw-text-opacity, 1));
  }
  .lg\\:dark\\:text-red-400:is(.dark *){
    --tw-text-opacity: 1;
    color: rgb(248 113 113 / var(--tw-text-opacity, 1));
  }
  .dark\\:lg\\:hover\\:bg-white\\/5:hover:is(.dark *){
    background-color: rgb(255 255 255 / 0.05);
  }
}

@media (min-width: 1280px){

  .xl\\:sticky{
    position: sticky;
  }

  .xl\\:bottom-6{
    bottom: 24px;
  }

  .xl\\:top-2{
    top: 8px;
  }

  .xl\\:block{
    display: block;
  }

  .xl\\:hidden{
    display: none;
  }

  .xl\\:max-h-\\[calc\\(100vh-76px\\)\\]{
    max-height: calc(100vh - 76px);
  }

  .xl\\:w-\\[280px\\]{
    width: 280px;
  }

  .xl\\:w-\\[300px\\]{
    width: 300px;
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[1fr_320px\\]{
    grid-template-columns: 1fr 320px;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_360px\\]{
    grid-template-columns: minmax(0,1fr) 360px;
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:self-start{
    align-self: flex-start;
  }

  .xl\\:overflow-y-auto{
    overflow-y: auto;
  }

  .xl\\:pb-8{
    padding-bottom: 32px;
  }

  .xl\\:pr-1{
    padding-right: 4px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;;;;EAIE;;AAGF;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;EAAc;;AAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,0GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,iDAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;IAAA,sBAAc;EAAA;;AAAd;IAAA,mCAAc;IAAd,kCAAc;IAAd,kCAAc;IAAd,kBAAc;IAAd,yBAAc;EAAA;;AAAd;EAAA,0GAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;IAAd,qDAAc;IAAd,gBAAc;IAAd,gBAAc;IAAd,yBAAc;AAAA;;AAAd;IAAA,gBAAc;IAAd,yBAAc;EAAA;;AAAd;;;wDAAc;;AAAd;IAAA,kBAAc;EAAA;;AAAd;EAAA,oBAAc;EAAd,mDAAc;IAAd;AAAc;;AAAd;IAAA,yBAAc;EAAA;;AAAd,qCAAc;;AAAd;IAAA,2CAAc;EAAA;;AAAd;IAAA,0CAAc;EAAA;;AAAd,0BAAc;;AAAd;;;IAAA,kBAAc;EAAA;;AAAd,yBAAc;;AAAd;EAAA,mBAAc;EAAd,oBAAc;EAAd,gBAAc;EAAd,wBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,iBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,wBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,kBAAc;EAAd,oBAAc;EAAd,uBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd,oBAAc;EAAd,wBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,eAAc;EAAd,mBAAc;EAAd,uBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,gBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;;;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,mBAAc;EAAd,qBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,oBAAc;EAAd;AAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd;;;EAAA,cAAc;AAAA;;AAAd;;EAAA,cAAc;AAAA;;AAAd;EAAA,cAAc;AAAA;;AAAd,iBAAc;;AAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,sCAAc;EAAd,2BAAc;EAAd;AAAc;;AAAd,cAAc;;AAAd;EAAA,kBAAc;EAAd,4DAAc;EAAd,oBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAsGlB,gBAAgB;AAEd;EAAA,mBAA+F;EAA/F,iBAA+F;EAA/F,oCAA+F;EAA/F,kBAA+F;EAA/F,4DAA+F;EAA/F,gFAA+F;EAA/F,8FAA+F;EAA/F,uGAA+F;EAA/F,wBAA+F;EAA/F,wDAA+F;EAA/F;AAA+F;AAA/F;EAAA,yBAA+F;AAAA;AAA/F;;EAAA,uCAA+F;AAAA;AAA/F;EAAA,yBAA+F;EAA/F,qBAA+F;AAAA;AAA/F;EAAA,mBAA+F;EAA/F,iBAA+F;EAA/F,oCAA+F;EAA/F,kBAA+F;EAA/F,4DAA+F;EAA/F,gFAA+F;EAA/F,8FAA+F;EAA/F,uGAA+F;EAA/F,wBAA+F;EAA/F,wDAA+F;EAA/F;AAA+F;AAA/F;EAAA,yBAA+F;AAAA;AAA/F;;EAAA,uCAA+F;AAAA;AAA/F;EAAA,yBAA+F;EAA/F,qBAA+F;AAAA;AAI/F;EAAA,oFAAwB;EAAxB,kGAAwB;EAAxB;AAAwB;AAAxB;EAAA,oFAAwB;EAAxB,kGAAwB;EAAxB;AAAwB;AAIxB;EAAA;AAAU;AAWZ,uCAAuC;AACvC;IACE,oBAAoB;IACpB,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,WAAW;EACb;AAcA;IACE,cAAc;EAChB;AAEA;IACE,cAAc;EAChB;AAEA,kBAAkB;AAEhB;EAAA,oBAI0B;EAJ1B,mBAI0B;EAJ1B,uBAI0B;EAJ1B,QAI0B;EAJ1B,mBAI0B;EAJ1B,gBAI0B;EAJ1B,wBAI0B;EAJ1B,wDAI0B;EAJ1B,0BAI0B;EAJ1B;AAI0B;AAJ1B;EAAA,8BAI0B;EAJ1B;AAI0B;AAJ1B;EAAA,2GAI0B;EAJ1B,yGAI0B;EAJ1B,4FAI0B;EAJ1B;AAI0B;AAJ1B;EAAA,kBAI0B;EAJ1B,kBAI0B;EAJ1B;AAI0B;AAJ1B;EAAA,oBAI0B;EAJ1B,mBAI0B;EAJ1B;AAI0B;AAoB1B;EAAA,kBAEqC;EAFrC,0DAEqC;EAFrC,oBAEqC;EAFrC,mDAEqC;EAFrC,gFAEqC;EAFrC,8FAEqC;EAFrC,uGAEqC;EAFrC;AAEqC;AAFrC;EAAA,aAEqC;EAFrC,6CAEqC;EAFrC,wCAEqC;EAFrC,+BAEqC;AAAA;AAFrC;EAAA,kBAEqC;EAFrC,0DAEqC;EAFrC,mFAEqC;EAFrC,iGAEqC;EAFrC;AAEqC;AAFrC;EAAA,oBAEqC;EAFrC;AAEqC;AAIrC;EAAA,iBAEqC;EAFrC,sBAEqC;EAFrC,4DAEqC;EAFrC,kBAEqC;EAFrC,4DAEqC;EAFrC,oBAEqC;EAFrC,gDAEqC;EAFrC,4CAEqC;EAFrC,uDAEqC;EAFrC;AAEqC;AAFrC;EAAA,yBAEqC;EAFrC,cAEqC;AAAA;AAFrC;;EAAA,2CAEqC;AAAA;AAFrC;;;EAAA,cAEqC;AAAA;AAFrC;EAAA,yBAEqC;EAFrC,qBAEqC;AAAA;AAFrC;EAAA,yBAEqC;AAAA;AAFrC;EAAA,qBAEqC;EAFrC,cAEqC;AAAA;AAFrC;EAAA,sBAEqC;EAFrC,4DAEqC;EAFrC,kBAEqC;EAFrC,4DAEqC;EAFrC,gFAEqC;EAFrC,8FAEqC;EAFrC;AAEqC;AAFrC;EAAA,oBAEqC;EAFrC;AAEqC;AAevC,iBAAiB;AAEf;EAAA,WAI+B;EAJ/B,mBAI+B;EAJ/B,iBAI+B;EAJ/B,sBAI+B;EAJ/B,4DAI+B;EAJ/B,kBAI+B;EAJ/B,4DAI+B;EAJ/B,kBAI+B;EAJ/B,mBAI+B;EAJ/B,iBAI+B;EAJ/B,oBAI+B;EAJ/B,oBAI+B;EAJ/B,oBAI+B;EAJ/B,iBAI+B;EAJ/B,oBAI+B;EAJ/B;AAI+B;AAJ/B;EAAA,2BAI+B;EAJ/B;AAI+B;AAJ/B;EAAA,wBAI+B;EAJ/B,wDAI+B;EAJ/B;AAI+B;AAJ/B;EAAA,yBAI+B;EAJ/B,cAI+B;AAAA;AAJ/B;;EAAA,gCAI+B;AAAA;AAJ/B;EAAA,yBAI+B;EAJ/B,qBAI+B;EAJ/B,cAI+B;AAAA;AAJ/B;EAAA,sBAI+B;EAJ/B;AAI+B;AAJ/B;EAAA,sBAI+B;EAJ/B,2DAI+B;EAJ/B,8BAI+B;EAJ/B,mBAI+B;EAJ/B,2GAI+B;EAJ/B,yGAI+B;EAJ/B,4FAI+B;EAJ/B;AAI+B;AAOjC,yEAAyE;AAKzE,yDAAyD;AAWzD;IACE,OAAO,2BAA2B,EAAE;IACpC,OAAO,2BAA2B,EAAE;EACtC;AAEA,8DAA8D;AAE5D;EAAA,oBAE4C;EAF5C,mBAE4C;EAF5C,QAE4C;EAF5C,kBAE4C;EAF5C,iBAE4C;EAF5C,sBAE4C;EAF5C,4DAE4C;EAF5C,kBAE4C;EAF5C,4DAE4C;EAF5C,kBAE4C;EAF5C,mBAE4C;EAF5C,gBAE4C;EAF5C,mBAE4C;EAF5C,kBAE4C;EAF5C,iBAE4C;EAF5C,sBAE4C;EAF5C,gBAE4C;EAF5C,oBAE4C;EAF5C,iDAE4C;EAF5C,+FAE4C;EAF5C,wDAE4C;EAF5C,0BAE4C;EAF5C;AAE4C;AAF5C;EAAA,kBAE4C;EAF5C;AAE4C;AAI5C;EAAA,4BAEmC;EAFnC,oBAEmC;EAFnC,mBAEmC;EAFnC,uBAEmC;EAFnC,kBAEmC;EAFnC,YAEmC;EAFnC,oBAEmC;EAFnC,mDAEmC;EAFnC,+FAEmC;EAFnC,wDAEmC;EAFnC;AAEmC;AAFnC;EAAA,cAEmC;AAAA;AAFnC;EAAA,cAEmC;AAAA;AAFnC;EAAA,yCAEmC;EAFnC,oBAEmC;EAFnC;AAEmC;AAGrC,iBAAiB;AAEf;EAAA,oBAA0E;EAA1E,mBAA0E;EAA1E,kBAA0E;EAA1E,iBAA0E;EAA1E,kBAA0E;EAA1E,gBAA0E;EAA1E,mBAA0E;EAA1E,kBAA0E;EAA1E,iBAA0E;EAA1E,sBAA0E;EAA1E;AAA0E;AAuB5E,iBAAiB;AAEf;EAAA,aAA+H;EAA/H,mBAA+H;EAA/H,uBAA+H;EAA/H,qBAA+H;EAA/H,4EAA+H;EAA/H,4DAA+H;EAA/H,oEAA+H;EAA/H,mEAA+H;EAA/H,wDAA+H;EAA/H,gBAA+H;EAA/H,oBAA+H;EAA/H,mDAA+H;EAA/H;AAA+H;AASjI,iBAAiB;AAqBjB,kBAAkB;AAEhB;EAAA,gBAAuC;EAAvC,mBAAuC;EAAvC,qBAAuC;EAAvC,sBAAuC;EAAvC;AAAuC;AAAvC;EAAA,uCAAuC;AAAA;AAGzC,eAAe;AAEb;EAAA,gBAAyF;EAAzF,oBAAyF;EAAzF,iDAAyF;EAAzF,+FAAyF;EAAzF,wDAAyF;EAAzF;AAAyF;AAAzF;EAAA,oBAAyF;EAAzF;AAAyF;AAAzF;EAAA,gBAAyF;EAAzF,oBAAyF;EAAzF,iDAAyF;EAAzF,+FAAyF;EAAzF,wDAAyF;EAAzF;AAAyF;AAAzF;EAAA,oBAAyF;EAAzF;AAAyF;AAG3F,mBAAmB;AAEjB;;EAAA;IAAA;EAA8C;AAAA;AAA9C;EAAA,yDAA8C;EAA9C,kBAA8C;EAA9C,kBAA8C;EAA9C;AAA8C;AAGhD,oBAAoB;AAcpB,gBAAgB;AAEd;EAAA,iBAA0D;EAA1D,oCAA0D;EAA1D,wCAA0D;EAA1D,8BAA0D;EAA1D,uQAA0D;EAA1D,yBAA0D;EAA1D;AAA0D;AAhV9D;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,UAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;;EAAnB;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,sBAAmB;IAAnB;EAAmB;;EAAnB;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,wBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,0BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,wBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uEAAmB;EAAnB,iEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wEAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,2EAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yEAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB,cAAmB;EAAnB,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qCAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,iDAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,6CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,kDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,oFAAmB;EAAnB,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mFAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,sFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,mCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wCAAmB;EAAnB;AAAmB;AAAnB;EAAA,yCAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AA8VjB,mBAAmB;AACnB;IACE,wBAAwB;IACxB,qBAAqB;EACvB;AACA;IACE,aAAa;EACf;AAEA,kEAAkE;AAClE;;;IAGE,wBAAwB;IACxB,qBAAqB;EACvB;AACA;;IAEE,aAAa;IACb,QAAQ;IACR,SAAS;EACX;AAEA,sBAAsB;AAEpB;EAAA,wBAAyE;EAAzE,wDAAyE;EAAzE;AAAyE;AAAzE;EAAA,sBAAyE;EAAzE,+LAAyE;EAAzE,mFAAyE;EAAzE,iGAAyE;EAAzE;AAAyE;AAG3E,uBAAuB;AACvB;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;AAEA;IACE,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;EAClB;;AArYF,2EAA2E;;AAgG3E,2EAA2E;;AAsP3E,2EAA2E;;AAkD3E,2EAA2E;AAC3E;EACE,KAAK,8BAA8B,EAAE;EACrC,OAAO,6BAA6B,EAAE;AACxC;;AAEA;EACE,8BAA8B;EAC9B,2EAA2E;EAC3E,4BAA4B;AAC9B;;AAEA,2EAA2E;AAC3E;EAGI;;IAAA,iBAAyC;IAAzC,sBAAyC;IAAzC,4DAAyC;IAAzC,kBAAyC;IAAzC;EAAyC;AAAzC;;EAAA,yBAAyC;EAAzC,uCAAyC;AAAA;AAAzC;;EAAA,yBAAyC;EAAzC,qBAAyC;IACzC,qBAAqB;AADoB;AAG7C;;AAEA;;;EAGE;AACF;EACE,oCAAoC;AACtC;AACA;EACE,mDAAmD;AACrD;AACA;EACE,kDAAkD;AACpD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,2GAA2G;AAC7G;AACA;EACE,iCAAiC;EACjC,qDAAqD;EACrD,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,sDAAsD;AACxD;AACA;;;EAGE,sDAAsD;AACxD;AACA;;;;;;;EAOE,kDAAkD;AACpD;AACA;;;;EAIE,kDAAkD;AACpD;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;;EAGE,yBAAyB;AAC3B;AACA;;EAEE,2CAA2C;AAC7C;AACA;;EAEE,2CAA2C;AAC7C;AACA;;EAEE,0CAA0C;AAC5C;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,2EAA2E;AAC3E;EACE,+BAA+B;AACjC;;AAEA;;;EAGE,wBAAwB;EACxB,2BAA2B;EAC3B,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;;;EAIE,iDAAiD;EACjD,2CAA2C;EAC3C,uDAA+C;EAA/C,+CAA+C;AACjD;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,QAAQ;EACR,SAAS;AACX;;AAEA,kEAAkE;AAClE;;EAEE,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,iDAAiD;EACjD,sDAAsD;AACxD;;AAEA,mEAAmE;AACnE;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;EAIE,iDAAiD;EACjD,2CAA2C;EAC3C,uDAA+C;EAA/C,+CAA+C;AACjD;AACA;EACE,+BAA+B;AACjC;;AAEA,qFAAqF;AACrF;;;EAGE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;;;;;;;;;EAUE,iDAAiD;EACjD,2CAA2C;EAC3C,uDAA+C;EAA/C,+CAA+C;AACjD;;AAEA,uDAAuD;AACvD,wBAAwB,qDAAqD,EAAE;AAC/E,2BAA2B,yBAAyB,EAAE;AACtD,6BAA6B,iDAAiD,EAAE;AAChF,yBAAyB,oDAAoD,EAAE;AAC/E,4BAA4B,yBAAyB,EAAE;AACvD,8BAA8B,gDAAgD,EAAE;AAChF,0BAA0B,qDAAqD,EAAE;AACjF,6BAA6B,yBAAyB,EAAE;AACxD,+BAA+B,iDAAiD,EAAE;AAClF,0BAA0B,qDAAqD,EAAE;AACjF,6BAA6B,yBAAyB,EAAE;AACxD,+BAA+B,iDAAiD,EAAE;AAClF,wBAAwB,qDAAqD,EAAE;AAC/E,2BAA2B,yBAAyB,EAAE;AACtD,6BAA6B,iDAAiD,EAAE;AAChF,0BAA0B,qDAAqD,EAAE;AACjF,6BAA6B,yBAAyB,EAAE;AACxD,+BAA+B,iDAAiD,EAAE;;AAElF,oFAAoF;AACpF,qCAAqC,qDAAqD,EAAE;AAC5F,sCAAsC,oDAAoD,EAAE;AAC5F,uCAAuC,qDAAqD,EAAE;AAC9F,uCAAuC,qDAAqD,EAAE;AAC9F,wCAAwC,qDAAqD,EAAE;AAC/F,oCAAoC,oDAAoD,EAAE;AAC1F,wCAAwC,qDAAqD,EAAE;AAC/F,uCAAuC,qDAAqD,EAAE;AAC9F;4CAC4C,qDAAqD,EAAE;AACnG;;;EAGE,sDAAsD;AACxD;AACA;;EAEE,sDAAsD;AACxD;AACA,2BAA2B,qDAAqD,EAAE;;AAElF,wEAAwE;AACxE;;;;;;;;EAQE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;;AAEA,yDAAyD;AACzD;;EAEE,yBAAyB;AAC3B;;AAEA,mFAAmF;AACnF;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+CAA+C;AACjD;;AAEA;EACE,qDAAqD;EACrD,0CAA0C;AAC5C;AACA;EACE,qDAAqD;EACrD,0CAA0C;AAC5C;AACA;EACE,qDAAqD;EACrD,0CAA0C;AAC5C;AACA;EACE,qDAAqD;EACrD,0CAA0C;AAC5C;AACA;EACE,qDAAqD;EACrD,0CAA0C;AAC5C;AACA;EACE,oDAAoD;EACpD,yCAAyC;AAC3C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,yBAAyB;AAC3B;;AAEA;;;yCAGyC;AACzC;;;EAGE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,yBAAyB;EACzB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;;EAGE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;;;;;;EAOE,oCAAoC;AACtC;;AAEA,sEAAsE;AACtE;;;;;;;;;;;;;EAaE,iCAAiC;AACnC;;AAEA,aAAa;AACb;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA6BE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;;;;EAME,oCAAoC;AACtC;;AAEA;;;;;;;;EAQE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;;;;;;;EAOE,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;;;;;;;;;;;;;;;;EAgBE,yBAAyB;AAC3B;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA,sEAAsE;AACtE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EA0DE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAmEE,oDAAoD;EACpD,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;EA2BE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;EAEE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwDE,gCAAgC;AAClC;;AAEA,+BAA+B;AAC/B;;;;;EAKE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,kFAAkF;AAClF;;EAEE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,4CAA4C;AAC5C;;;EAGE,qBAAqB;AACvB;;AAEA;;;;;;;EAOE,wCAAwC;EACxC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;;;;;;;;EASE,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,kDAAkD;AAClD;;;;;EAKE,wBAAwB;EACxB,wDAAwD;EACxD,mDAAmD;EACnD,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;;EAIE,oCAAoC;EACpC,sDAAsD;AACxD;;AAEA,uCAAuC;AACvC;;;;;;;EAOE,8BAA8B;EAC9B,iCAAiC;EACjC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,sDAAsD;AACxD;;AAEA;;;;;;EAME,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;;;EAGE,8CAA8C;EAC9C,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA,yEAAyE;AACzE;;;;;;;EAOE,oCAAoC;EACpC,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;EAGE,kCAAkC;EAClC,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA,4EAA4E;AAC5E;;;EAGE,wBAAwB;EACxB,2BAA2B;EAC3B,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE;IACE,uBAAuB;IACvB,kCAAkC;EACpC;AACF;;AAEA;;;EAGE,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,wCAAwC;EACxC,kCAAkC;EAClC,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA,oGAAoG;AACpG;EACE;;;;;;;cAOY;EACZ,oBAAoB;AACtB;;AAEA,0EAA0E;AAC1E;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;;;EAGE,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,sCAAsC;EACtC,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,wCAAwC;EACxC,iCAAiC;EACjC,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sDAAsD;EACtD,yBAAyB;AAC3B;;AAEA,wFAAwF;AACxF;;EAEE,qDAAqD;EACrD,iCAAiC;EACjC,kDAAkD;EAClD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA,iFAAiF;AACjF;;EAEE,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA;;EAEE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;;EAEE,SAAO;EACP,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;;;;;EAQE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;;;;;;EAOE,iDAAiD;EACjD,2CAA2C;EAC3C,uDAA+C;EAA/C,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,wEAAwE;EACxE,8EAA8E;EAC9E,yBAAyB;EACzB,uBAAuB;EACvB,oCAAoC;AACtC;;AAlhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,gBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2GAmhDA;EAnhDA,yGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,iBAmhDA;EAnhDA,iBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,4DAmhDA;EAnhDA,mEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,4DAmhDA;EAnhDA,mEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,4DAmhDA;EAnhDA,mEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,4DAmhDA;EAnhDA,mEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,4DAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,0CAmhDA;EAnhDA,oDAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oFAmhDA;EAnhDA,kGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,gDAmhDA;EAnhDA,uDAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oFAmhDA;EAnhDA,kGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,mFAmhDA;EAnhDA,iGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,gFAmhDA;EAnhDA,8FAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sFAmhDA;EAnhDA,oGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,uCAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,uCAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,4BAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA,8BAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,8BAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2GAmhDA;EAnhDA,yGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2GAmhDA;EAnhDA,yGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2GAmhDA;EAnhDA,yGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,8BAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2GAmhDA;EAnhDA,yGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2GAmhDA;EAnhDA,yGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2GAmhDA;EAnhDA,yGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,gBAmhDA;EAnhDA,gBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,iBAmhDA;EAnhDA,iBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,qBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,qBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,iBAmhDA;EAnhDA,iBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,mFAmhDA;EAnhDA,iGAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,wCAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,iCAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,kBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,4DAmhDA;EAnhDA,kEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,0EAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,0EAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,0EAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2EAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2EAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,0EAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2EAmhDA;EAnhDA,oEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,2EAmhDA;EAnhDA,qEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,mEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,mEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,mEAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,2BAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,+CAmhDA;EAnhDA,6DAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,8CAmhDA;EAnhDA,6DAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,6CAmhDA;EAnhDA,4DAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA,8BAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,mCAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,iCAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,sBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;EAAA,oBAmhDA;EAnhDA;AAmhDA;;AAnhDA;;EAAA;IAAA;EAmhDA;;EAnhDA;IAAA,SAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,gBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,uBAmhDA;IAnhDA,2DAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,eAmhDA;IAnhDA,mBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA,8BAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA,8BAmhDA;IAnhDA;EAmhDA;AAAA;;AAnhDA;;EAAA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,uBAmhDA;IAnhDA,2DAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,uBAmhDA;IAnhDA,2DAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,uBAmhDA;IAnhDA,4DAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,wBAmhDA;IAnhDA,0DAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,wBAmhDA;IAnhDA,kEAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,gBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,gBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,gBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,mBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,mBAmhDA;IAnhDA,qBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,eAmhDA;IAnhDA,mBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,wCAmhDA;IAnhDA,sDAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,gFAmhDA;IAnhDA,8FAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,wCAmhDA;IAnhDA,sDAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,6CAmhDA;IAnhDA,4DAmhDA;IAnhDA;EAmhDA;AAAA;;AAnhDA;;EAAA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,gBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,eAmhDA;IAnhDA,gBAmhDA;IAnhDA,uBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,eAmhDA;IAnhDA,gBAmhDA;IAnhDA,uBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;AAAA;;AAnhDA;;EAAA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,uBAmhDA;IAnhDA,4DAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,uBAmhDA;IAnhDA,4DAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,sBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,gBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,mBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,kBAmhDA;IAnhDA,iBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA,gFAmhDA;IAnhDA,8FAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,wBAmhDA;IAnhDA,wDAmhDA;IAnhDA;EAmhDA;;EAnhDA;IAAA,+FAmhDA;IAnhDA,wDAmhDA;IAnhDA;EAmhDA;EAzqCE;IACE,wBAAwB;IACxB,qBAAqB;EACvB;EACA;IACE,aAAa;EACf;EAhXF;IAAA,sBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,kBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA;EAmhDA;EAnhDA;IAAA,8BAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,2GAmhDA;IAnhDA,yGAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA;EAmhDA;EAnhDA;IAAA;EAmhDA;EAnhDA;IAAA;EAmhDA;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA,oBAmhDA;IAnhDA;EAmhDA;EAnhDA;IAAA;EAmhDA;AAAA;;AAnhDA;;EAAA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;;EAnhDA;IAAA;EAmhDA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');\n\n/*\n * Company Dashboard design tokens (CSS custom properties + .glass / .fab utilities).\n * Mirrors the `dashboard.*` Tailwind tokens added in `tailwind.config.js`.\n * Source: .kiro/specs/company-dashboard-internal-pages/design.md\n */\n@import './styles/tokens.css';\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ─── BASE LAYER ─────────────────────────────────────────────────────── */\n@layer base {\n  * {\n    box-sizing: border-box;\n  }\n\n  html {\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    text-rendering: optimizeLegibility;\n    overflow-x: hidden;\n    background-color: #f8fafc;\n  }\n\n  body {\n    @apply font-sans text-base text-neutral-900;\n    font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11';\n    line-height: 1.5;\n    min-height: 100%;\n    background-color: #f8fafc;\n  }\n\n  #root {\n    min-height: 100%;\n    background-color: inherit;\n  }\n\n  /* ─── Dark mode base ────────────────────────────────────────────────\n     A single body-level override gives every screen — even ones we\n     haven't explicitly dark-styled yet — a readable dark background.\n     Per-component `dark:` variants then layer on top. */\n  html.dark {\n    color-scheme: dark;\n  }\n  html.dark body {\n    @apply text-neutral-100;\n    background-color: #0b0b15;\n  }\n  html.dark #root {\n    background-color: #0b0b15;\n  }\n  /* Subtle dark scrollbars (WebKit). */\n  html.dark *::-webkit-scrollbar-thumb {\n    background-color: rgba(255, 255, 255, 0.12);\n  }\n  html.dark *::-webkit-scrollbar-thumb:hover {\n    background-color: rgba(255, 255, 255, 0.2);\n  }\n\n  /* Native form controls. */\n  html.dark input,\n  html.dark textarea,\n  html.dark select {\n    color-scheme: dark;\n  }\n\n  /* Typography hierarchy */\n  h1 {\n    @apply text-4xl font-bold text-neutral-900 tracking-tight;\n  }\n\n  h2 {\n    @apply text-3xl font-semibold text-neutral-900 tracking-tight;\n  }\n\n  h3 {\n    @apply text-2xl font-semibold text-neutral-900;\n  }\n\n  h4 {\n    @apply text-xl font-semibold text-neutral-800;\n  }\n\n  h5 {\n    @apply text-lg font-medium text-neutral-800;\n  }\n\n  h6 {\n    @apply text-base font-medium text-neutral-700;\n  }\n\n  p {\n    @apply text-base text-neutral-600 leading-relaxed;\n  }\n\n  /* Focus styles */\n  :focus-visible {\n    @apply outline-none ring-2 ring-primary-500/40 ring-offset-2 ring-offset-white;\n  }\n\n  /* Selection */\n  ::selection {\n    @apply bg-primary-100 text-primary-900;\n  }\n}\n\n/* ─── COMPONENT LAYER ────────────────────────────────────────────────── */\n@layer components {\n\n  /* ── Cards ── */\n  .card {\n    @apply bg-white rounded-xl border border-neutral-200/60 shadow-card transition-all duration-200;\n  }\n\n  .card:hover {\n    @apply shadow-card-hover;\n  }\n\n  .card-body {\n    @apply p-5;\n  }\n\n  .card-header {\n    @apply px-5 py-4 border-b border-neutral-100;\n  }\n\n  .card-footer {\n    @apply px-5 py-3 border-t border-neutral-100 bg-neutral-50/50 rounded-b-xl;\n  }\n\n  /* ── Brand wordmark (SNAP + SULE) ── */\n  .lp-brand-text {\n    display: inline-flex;\n    align-items: baseline;\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    line-height: 1;\n    color: #fff;\n  }\n\n  .lp-brand-text--sm {\n    font-size: 0.9375rem;\n  }\n\n  .lp-brand-text--md {\n    font-size: 1.0625rem;\n  }\n\n  .lp-brand-text--lg {\n    font-size: 1.3125rem;\n  }\n\n  .lp-brand-text-snap {\n    color: inherit;\n  }\n\n  .lp-brand-text-sule {\n    color: #2563eb;\n  }\n\n  /* ── Buttons ── */\n  .btn {\n    @apply inline-flex items-center justify-center gap-2 font-medium rounded-lg\n           transition-all duration-200 ease-out\n           focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2\n           disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none\n           active:scale-[0.97];\n  }\n\n  .btn-sm {\n    @apply px-3 py-1.5 text-sm h-8;\n  }\n\n  .btn-md {\n    @apply px-4 py-2 text-sm h-9;\n  }\n\n  .btn-lg {\n    @apply px-5 py-2.5 text-base h-10;\n  }\n\n  .btn-xl {\n    @apply px-6 py-3 text-md h-11;\n  }\n\n  .btn-primary {\n    @apply bg-primary-600 text-white shadow-sm\n           hover:bg-primary-700 hover:shadow-md\n           focus-visible:ring-primary-500;\n  }\n\n  .btn-secondary {\n    @apply bg-white text-neutral-700 border border-neutral-300 shadow-xs\n           hover:bg-neutral-50 hover:border-neutral-400 hover:shadow-sm\n           focus-visible:ring-neutral-400;\n  }\n\n  .btn-ghost {\n    @apply bg-transparent text-neutral-600\n           hover:bg-neutral-100 hover:text-neutral-900\n           focus-visible:ring-neutral-400;\n  }\n\n  .btn-danger {\n    @apply bg-error-600 text-white shadow-sm\n           hover:bg-error-700 hover:shadow-md\n           focus-visible:ring-error-500;\n  }\n\n  /* ── Inputs ── */\n  .input {\n    @apply w-full px-3.5 py-2.5 bg-white border border-neutral-300 rounded-lg\n           text-neutral-900 text-sm placeholder-neutral-400\n           transition-all duration-200\n           focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500\n           hover:border-neutral-400;\n  }\n\n  .input-error {\n    @apply border-error-500 focus:ring-error-500/20 focus:border-error-500;\n  }\n\n  /* ── Route transitions — disabled opacity fade (caused white flash) ── */\n  .route-fade-in {\n    animation: none;\n  }\n\n  /* Thin progress bar shown on slow chunk loads (>150ms) */\n  .route-progress-bar {\n    height: 2px;\n    width: 100%;\n    background: linear-gradient(90deg, transparent, #6366f1 35%, #a855f7 65%, transparent);\n    background-size: 40% 100%;\n    background-repeat: no-repeat;\n    background-position: -40% 0;\n    animation: routeProgressSlide 1.1s ease-in-out infinite;\n  }\n\n  @keyframes routeProgressSlide {\n    0%   { background-position: -40% 0; }\n    100% { background-position: 140% 0; }\n  }\n\n  /* ── Inline add / remove buttons (used in array editors) ── */\n  .btn-add {\n    @apply inline-flex items-center gap-1 px-3 py-1.5 text-xs font-semibold\n           text-indigo-700 bg-indigo-50 border border-indigo-200 rounded-md\n           hover:bg-indigo-100 transition-colors;\n  }\n\n  .btn-remove {\n    @apply inline-flex items-center justify-center col-span-1 p-2\n           text-neutral-400 hover:text-error-600 hover:bg-error-50\n           rounded-md transition-colors;\n  }\n\n  /* ── Badges ── */\n  .badge {\n    @apply inline-flex items-center px-2 py-0.5 rounded-md text-xs font-medium;\n  }\n\n  .badge-primary {\n    @apply bg-primary-50 text-primary-700;\n  }\n\n  .badge-secondary {\n    @apply bg-neutral-100 text-neutral-600;\n  }\n\n  .badge-success {\n    @apply bg-success-50 text-success-700;\n  }\n\n  .badge-warning {\n    @apply bg-warning-50 text-warning-700;\n  }\n\n  .badge-error {\n    @apply bg-error-50 text-error-700;\n  }\n\n  /* ── Avatar ── */\n  .avatar {\n    @apply rounded-full bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center text-white font-semibold;\n  }\n\n  .avatar-sm { @apply w-8 h-8 text-xs; }\n  .avatar-md { @apply w-10 h-10 text-sm; }\n  .avatar-lg { @apply w-12 h-12 text-base; }\n  .avatar-xl { @apply w-14 h-14 text-lg; }\n  .avatar-2xl { @apply w-20 h-20 text-xl; }\n\n  /* ── Layout ── */\n  .page-container {\n    @apply max-w-layout mx-auto px-6;\n  }\n\n  .layout-grid {\n    @apply flex gap-6;\n  }\n\n  .sidebar-left {\n    @apply w-sidebar-left flex-shrink-0;\n  }\n\n  .content-feed {\n    @apply flex-1 min-w-0 max-w-feed;\n  }\n\n  .sidebar-right {\n    @apply w-sidebar-right flex-shrink-0;\n  }\n\n  /* ── Divider ── */\n  .divider {\n    @apply border-t border-neutral-100 my-4;\n  }\n\n  /* ── Link ── */\n  .link {\n    @apply text-primary-600 hover:text-primary-700 font-medium transition-colors duration-150;\n  }\n\n  /* ── Skeleton ── */\n  .skeleton {\n    @apply animate-pulse bg-neutral-200 rounded-md;\n  }\n\n  /* ── Scrollbar ── */\n  .scrollbar-thin::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n  }\n\n  .scrollbar-thin::-webkit-scrollbar-track {\n    @apply bg-transparent;\n  }\n\n  .scrollbar-thin::-webkit-scrollbar-thumb {\n    @apply bg-neutral-200 rounded-full hover:bg-neutral-300;\n  }\n\n  /* ── Glass ── */\n  .glass {\n    @apply bg-white/80 backdrop-blur-xl border border-white/20;\n  }\n\n  .glass-strong {\n    @apply bg-white/90 backdrop-blur-2xl border border-neutral-200/50;\n  }\n}\n\n/* ─── UTILITY LAYER ──────────────────────────────────────────────────── */\n@layer utilities {\n  .text-balance {\n    text-wrap: balance;\n  }\n\n  /* Hide scrollbar */\n  .scrollbar-hide {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  .scrollbar-hide::-webkit-scrollbar {\n    display: none;\n  }\n\n  /* Company dashboard — hide scrollbars on all scrollable regions */\n  .dashboard-no-scrollbar,\n  .dashboard-no-scrollbar *,\n  html.dashboard-no-scrollbar {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n  .dashboard-no-scrollbar *::-webkit-scrollbar,\n  html.dashboard-no-scrollbar::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    height: 0;\n  }\n\n  /* Hover lift effect */\n  .hover-lift {\n    @apply transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md;\n  }\n\n  /* Truncate multiline */\n  .line-clamp-2 {\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n\n  .line-clamp-3 {\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n  }\n}\n\n/* ─── CUSTOM ANIMATIONS ──────────────────────────────────────────────── */\n@keyframes shimmer {\n  0% { background-position: -1000px 0; }\n  100% { background-position: 1000px 0; }\n}\n\n.animate-shimmer {\n  animation: shimmer 2s infinite;\n  background: linear-gradient(to right, #f3f4f6 4%, #e5e7eb 25%, #f3f4f6 36%);\n  background-size: 1000px 100%;\n}\n\n/* ─── FALLBACKS ──────────────────────────────────────────────────────── */\n@supports not (backdrop-filter: blur(10px)) {\n  .glass,\n  .glass-strong {\n    @apply bg-white border border-neutral-200;\n    backdrop-filter: none;\n  }\n}\n\n/*\n * Dark-mode legacy overrides — placed AFTER Tailwind utilities so they\n * beat raw bg-white / text-gray-* classes on unconverted components.\n */\nhtml.dark .bg-white {\n  background-color: #161628 !important;\n}\nhtml.dark .bg-white\\/95 {\n  background-color: rgba(22, 22, 40, 0.95) !important;\n}\nhtml.dark .bg-white\\/90 {\n  background-color: rgba(22, 22, 40, 0.9) !important;\n}\nhtml.dark .bg-white\\/70 {\n  background-color: rgba(22, 22, 40, 0.55) !important;\n}\nhtml.dark .bg-gradient-dashboard-hero {\n  background-image: linear-gradient(135deg, #1e1b4b 0%, rgba(49, 46, 129, 0.45) 50%, #12121f 100%) !important;\n}\nhtml.dark [data-testid=\"sidebar-nav\"] a[data-active=\"true\"] {\n  background-image: none !important;\n  background-color: rgba(99, 102, 241, 0.22) !important;\n  color: #e0e7ff !important;\n}\nhtml.dark [data-testid=\"sidebar-nav\"] a[data-active=\"true\"] svg {\n  color: #a5b4fc !important;\n}\nhtml.dark [data-testid=\"modal-dialog\"] footer {\n  background-color: #12121f !important;\n}\nhtml.dark [data-testid=\"multi-step-form\"] > div:first-child > div:last-child {\n  background-color: #12121f !important;\n}\nhtml.dark [data-testid=\"create-job-flow\"] h2.text-base {\n  color: #f5f5fa !important;\n}\nhtml.dark [data-testid=\"create-job-flow\"] .text-neutral-500 {\n  color: #a0a0b0 !important;\n}\nhtml.dark [data-testid=\"create-job-flow\"] .text-dashboard-600 {\n  color: #a5b4fc !important;\n}\nhtml.dark .bg-gray-50,\nhtml.dark .bg-neutral-50,\nhtml.dark .bg-slate-50 {\n  background-color: rgba(255, 255, 255, 0.04) !important;\n}\nhtml.dark .bg-gray-100,\nhtml.dark .bg-neutral-100,\nhtml.dark .bg-slate-100 {\n  background-color: rgba(255, 255, 255, 0.06) !important;\n}\nhtml.dark .border-neutral-200,\nhtml.dark .border-gray-200,\nhtml.dark .border-slate-200,\nhtml.dark .border-neutral-200\\/60,\nhtml.dark .border-gray-200\\/60,\nhtml.dark .border-neutral-200\\/80,\nhtml.dark .border-gray-200\\/80 {\n  border-color: rgba(255, 255, 255, 0.08) !important;\n}\nhtml.dark .border-neutral-100,\nhtml.dark .border-gray-100,\nhtml.dark .divide-neutral-100 > :not([hidden]) ~ :not([hidden]),\nhtml.dark .divide-gray-100 > :not([hidden]) ~ :not([hidden]) {\n  border-color: rgba(255, 255, 255, 0.06) !important;\n}\nhtml.dark .text-neutral-900,\nhtml.dark .text-gray-900,\nhtml.dark .text-slate-900 {\n  color: #f5f5fa !important;\n}\nhtml.dark .text-neutral-800,\nhtml.dark .text-gray-800,\nhtml.dark .text-slate-800 {\n  color: #ececf3 !important;\n}\nhtml.dark .text-neutral-700,\nhtml.dark .text-gray-700,\nhtml.dark .text-slate-700 {\n  color: #d6d6e0 !important;\n}\nhtml.dark .text-neutral-600,\nhtml.dark .text-gray-600,\nhtml.dark .text-slate-600 {\n  color: #c2c2cf !important;\n}\nhtml.dark .text-neutral-500,\nhtml.dark .text-gray-500,\nhtml.dark .text-slate-500 {\n  color: #a0a0b0 !important;\n}\nhtml.dark .text-neutral-400,\nhtml.dark .text-gray-400,\nhtml.dark .text-slate-400 {\n  color: #7a7a8a !important;\n}\nhtml.dark input::placeholder,\nhtml.dark textarea::placeholder {\n  color: rgba(255, 255, 255, 0.45) !important;\n}\nhtml.dark .placeholder\\:text-neutral-400::placeholder,\nhtml.dark .placeholder-neutral-400::placeholder {\n  color: rgba(255, 255, 255, 0.45) !important;\n}\nhtml.dark .placeholder\\:text-neutral-500::placeholder,\nhtml.dark .placeholder-neutral-500::placeholder {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\nhtml.dark input.bg-transparent,\nhtml.dark textarea.bg-transparent {\n  color: #ececf3 !important;\n}\n\n/* Kill white focus ring offset in dark mode (caused white box in inputs) */\nhtml.dark :focus-visible {\n  --tw-ring-offset-color: #0b0b15;\n}\n\nhtml.dark .gossip-inline-input,\nhtml.dark .gossip-inline-input:focus,\nhtml.dark .gossip-inline-input:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n  --tw-ring-shadow: 0 0 #0000 !important;\n  --tw-ring-offset-shadow: 0 0 #0000 !important;\n}\n\nhtml.dark .gossip-inline-input:-webkit-autofill,\nhtml.dark .gossip-inline-input:-webkit-autofill:hover,\nhtml.dark .gossip-inline-input:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #12121f inset !important;\n  box-shadow: 0 0 0 1000px #12121f inset !important;\n  -webkit-text-fill-color: #ececf3 !important;\n  transition: background-color 99999s ease-out 0s;\n}\n\n/* Event registration modal — hide scrollbars while keeping scroll */\n[data-event-registration-modal] .evt-reg-scroll {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n[data-event-registration-modal] .evt-reg-scroll::-webkit-scrollbar {\n  display: none;\n  width: 0;\n  height: 0;\n}\n\n/* Resume drop zone — subtle hover in dark mode (no indigo glow) */\n[data-event-registration-modal] .evt-reg-upload-zone,\n[data-event-registration-modal] .evt-reg-upload-zone:hover {\n  box-shadow: none !important;\n  outline: none;\n}\nhtml.dark [data-event-registration-modal] .evt-reg-upload-zone--idle:hover {\n  border-color: rgba(255, 255, 255, 0.2) !important;\n  background-color: rgba(255, 255, 255, 0.05) !important;\n}\n\n/* College profile — form fields match panel surface in dark mode */\nhtml.dark [data-college-profile] .profile-field {\n  background-color: #161628 !important;\n  color: #ececf3 !important;\n}\nhtml.dark [data-college-profile] .profile-field:-webkit-autofill,\nhtml.dark [data-college-profile] .profile-field:-webkit-autofill:hover,\nhtml.dark [data-college-profile] .profile-field:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #161628 inset !important;\n  box-shadow: 0 0 0 1000px #161628 inset !important;\n  -webkit-text-fill-color: #ececf3 !important;\n  transition: background-color 99999s ease-out 0s;\n}\nhtml.dark [data-college-profile] .profile-field:focus {\n  --tw-ring-offset-color: #161628;\n}\n\n/* Event registration modal — consistent inputs in dark mode (no browser gray fill) */\nhtml.dark [data-event-registration-modal] input:not([type=\"checkbox\"]):not([type=\"file\"]),\nhtml.dark [data-event-registration-modal] textarea,\nhtml.dark [data-event-registration-modal] select {\n  background-color: #161628 !important;\n  color: #ececf3 !important;\n}\nhtml.dark [data-event-registration-modal] input:not([type=\"checkbox\"]):not([type=\"file\"]):-webkit-autofill,\nhtml.dark [data-event-registration-modal] input:not([type=\"checkbox\"]):not([type=\"file\"]):-webkit-autofill:hover,\nhtml.dark [data-event-registration-modal] input:not([type=\"checkbox\"]):not([type=\"file\"]):-webkit-autofill:focus,\nhtml.dark [data-event-registration-modal] textarea:-webkit-autofill,\nhtml.dark [data-event-registration-modal] textarea:-webkit-autofill:hover,\nhtml.dark [data-event-registration-modal] textarea:-webkit-autofill:focus,\nhtml.dark [data-event-registration-modal] select:-webkit-autofill,\nhtml.dark [data-event-registration-modal] select:-webkit-autofill:hover,\nhtml.dark [data-event-registration-modal] select:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #161628 inset !important;\n  box-shadow: 0 0 0 1000px #161628 inset !important;\n  -webkit-text-fill-color: #ececf3 !important;\n  transition: background-color 99999s ease-out 0s;\n}\n\n/* Category pills / badges — tinted for dark surfaces */\nhtml.dark .bg-blue-50 { background-color: rgba(59, 130, 246, 0.12) !important; }\nhtml.dark .text-blue-600 { color: #93c5fd !important; }\nhtml.dark .border-blue-200 { border-color: rgba(59, 130, 246, 0.25) !important; }\nhtml.dark .bg-green-50 { background-color: rgba(34, 197, 94, 0.12) !important; }\nhtml.dark .text-green-600 { color: #86efac !important; }\nhtml.dark .border-green-200 { border-color: rgba(34, 197, 94, 0.25) !important; }\nhtml.dark .bg-orange-50 { background-color: rgba(249, 115, 22, 0.12) !important; }\nhtml.dark .text-orange-600 { color: #fdba74 !important; }\nhtml.dark .border-orange-200 { border-color: rgba(249, 115, 22, 0.25) !important; }\nhtml.dark .bg-violet-50 { background-color: rgba(139, 92, 246, 0.12) !important; }\nhtml.dark .text-violet-600 { color: #c4b5fd !important; }\nhtml.dark .border-violet-200 { border-color: rgba(139, 92, 246, 0.25) !important; }\nhtml.dark .bg-pink-50 { background-color: rgba(236, 72, 153, 0.12) !important; }\nhtml.dark .text-pink-600 { color: #f9a8d4 !important; }\nhtml.dark .border-pink-200 { border-color: rgba(236, 72, 153, 0.25) !important; }\nhtml.dark .bg-purple-50 { background-color: rgba(168, 85, 247, 0.12) !important; }\nhtml.dark .text-purple-600 { color: #d8b4fe !important; }\nhtml.dark .border-purple-200 { border-color: rgba(168, 85, 247, 0.25) !important; }\n\n/* Hover tints — Tailwind hover:bg-*-50 must not flash light surfaces in dark mode */\nhtml.dark .hover\\:bg-blue-50:hover { background-color: rgba(59, 130, 246, 0.12) !important; }\nhtml.dark .hover\\:bg-green-50:hover { background-color: rgba(34, 197, 94, 0.12) !important; }\nhtml.dark .hover\\:bg-purple-50:hover { background-color: rgba(168, 85, 247, 0.12) !important; }\nhtml.dark .hover\\:bg-orange-50:hover { background-color: rgba(249, 115, 22, 0.12) !important; }\nhtml.dark .hover\\:bg-orange-100:hover { background-color: rgba(249, 115, 22, 0.18) !important; }\nhtml.dark .hover\\:bg-red-50:hover { background-color: rgba(239, 68, 68, 0.12) !important; }\nhtml.dark .hover\\:bg-violet-100:hover { background-color: rgba(139, 92, 246, 0.18) !important; }\nhtml.dark .hover\\:bg-violet-50:hover { background-color: rgba(139, 92, 246, 0.12) !important; }\nhtml.dark .hover\\:bg-primary-50:hover,\nhtml.dark .hover\\:bg-primary-50\\/50:hover { background-color: rgba(99, 102, 241, 0.12) !important; }\nhtml.dark .hover\\:bg-gray-50:hover,\nhtml.dark .hover\\:bg-neutral-50:hover,\nhtml.dark .hover\\:bg-slate-50:hover {\n  background-color: rgba(255, 255, 255, 0.06) !important;\n}\nhtml.dark .hover\\:bg-gray-100:hover,\nhtml.dark .hover\\:bg-neutral-100:hover {\n  background-color: rgba(255, 255, 255, 0.08) !important;\n}\nhtml.dark .bg-orange-100 { background-color: rgba(249, 115, 22, 0.18) !important; }\n\n/* Pastel gossip category cards keep light gradients — force dark text */\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]) .text-neutral-800,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]) .text-neutral-700,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]) .text-neutral-600,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]) .text-neutral-500,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]).text-neutral-800,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]).text-neutral-700,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]).text-neutral-600,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]) h3 {\n  color: #1f2937 !important;\n}\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]) .text-neutral-600,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]).text-neutral-600 {\n  color: #4b5563 !important;\n}\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]) .text-neutral-500,\nhtml.dark [class*=\"from-\"][class*=\"-100\"]:not([data-project-showcase-hero]).text-neutral-500 {\n  color: #6b7280 !important;\n}\n\n/* Project showcase hero — white title on dark gradient */\nhtml.dark [data-project-showcase-hero] .project-showcase-title,\nhtml.dark [data-project-showcase-hero] h3.project-showcase-title {\n  color: #ffffff !important;\n}\n\n/* Event detail — tint cards readable in dark mode (global text-gray-900 → white) */\n[data-event-detail] .evt-tint-title {\n  color: #111827;\n}\n[data-event-detail] .evt-tint-sub {\n  color: #6b7280;\n}\n.evt-share-x {\n  background-color: #171717;\n  color: #ffffff;\n}\n.evt-share-x:hover {\n  background-color: #000000;\n}\n[data-event-detail] .evt-sticky-cta {\n  box-shadow: 0 4px 20px -6px rgba(0, 0, 0, 0.12);\n}\n\nhtml.dark [data-event-detail] .evt-tint-purple {\n  background-color: rgba(168, 85, 247, 0.14) !important;\n  border: 1px solid rgba(168, 85, 247, 0.22);\n}\nhtml.dark [data-event-detail] .evt-tint-amber {\n  background-color: rgba(245, 158, 11, 0.14) !important;\n  border: 1px solid rgba(245, 158, 11, 0.22);\n}\nhtml.dark [data-event-detail] .evt-tint-emerald {\n  background-color: rgba(16, 185, 129, 0.14) !important;\n  border: 1px solid rgba(16, 185, 129, 0.22);\n}\nhtml.dark [data-event-detail] .evt-tint-pink {\n  background-color: rgba(236, 72, 153, 0.14) !important;\n  border: 1px solid rgba(236, 72, 153, 0.22);\n}\nhtml.dark [data-event-detail] .evt-tint-blue {\n  background-color: rgba(59, 130, 246, 0.14) !important;\n  border: 1px solid rgba(59, 130, 246, 0.22);\n}\nhtml.dark [data-event-detail] .evt-tint-rose {\n  background-color: rgba(244, 63, 94, 0.14) !important;\n  border: 1px solid rgba(244, 63, 94, 0.22);\n}\nhtml.dark [data-event-detail] .evt-tint-title {\n  color: #ffffff !important;\n}\nhtml.dark [data-event-detail] .evt-tint-sub {\n  color: rgba(255, 255, 255, 0.65) !important;\n}\nhtml.dark [data-event-detail] .evt-share-x {\n  background-color: #e5e7eb !important;\n  color: #111827 !important;\n}\nhtml.dark [data-event-detail] .evt-share-x:hover {\n  background-color: #f3f4f6 !important;\n}\nhtml.dark [data-event-detail] .evt-sticky-cta {\n  box-shadow: 0 8px 28px -8px rgba(0, 0, 0, 0.65) !important;\n}\nhtml.dark [data-event-detail] .evt-sticky-title {\n  color: #ffffff !important;\n}\n\n/* ─── LinkedIn-inspired dark platform theme ─────────────────────────────\n   Final authority layer. The app has many legacy page-level colors and\n   Tailwind classes; this block normalizes them to one dark grayscale system\n   with a single blue accent (#2563EB). */\n:root,\nhtml,\nhtml.dark {\n  color-scheme: dark;\n  --app-bg: #0F1117;\n  --app-card: #171A23;\n  --app-hover: #1E2230;\n  --app-border: #2A3042;\n  --app-text: #FFFFFF;\n  --app-text-secondary: #A1A8B8;\n  --app-text-muted: #6B7280;\n  --app-blue: #2563EB;\n  --app-blue-hover: #1D4ED8;\n  --bg-app: #0F1117;\n  --bg-card: #171A23;\n  --bg-muted: #1E2230;\n  --bg-glass: rgba(23, 26, 35, 0.9);\n  --border-default: #2A3042;\n  --border-strong: #2A3042;\n  --border-focus: #2563EB;\n  --border-glass: #2A3042;\n  --text-primary: #FFFFFF;\n  --text-secondary: #A1A8B8;\n  --text-muted: #6B7280;\n  --text-tertiary: #6B7280;\n  --text-on-primary: #FFFFFF;\n  --primary-500: #2563EB;\n  --primary-600: #2563EB;\n  --primary-700: #1D4ED8;\n  --accent-500: #2563EB;\n  --accent-600: #2563EB;\n  --accent-700: #1D4ED8;\n  --status-success: #2563EB;\n  --status-warning: #2563EB;\n  --status-danger: #2563EB;\n  --status-info: #2563EB;\n  --status-live: #2563EB;\n  --gradient-primary: #2563EB;\n  --gradient-hero: #0F1117;\n  --gradient-soft: #171A23;\n}\n\nhtml,\nbody,\n#root {\n  background-color: #0F1117 !important;\n  color: #FFFFFF;\n}\n\nbody,\n.App,\n.min-h-screen,\n[class*=\"bg-background\"],\n.bg-background-page,\n.bg-background-primary,\n.bg-background-secondary {\n  background-color: #0F1117 !important;\n}\n\n/* Remove platform gradients while preserving actual image elements. */\n[class*=\"bg-gradient\"],\n[class*=\"gradient-\"],\n.animate-shimmer,\n.route-progress-bar,\n.auth-shell-wrap,\n.auth-brand,\n.auth-submit,\n.auth-otp-modal,\n.landing-waitlist-submit,\n.landing-nav-cta,\n.fab,\n.avatar,\n[data-project-showcase-hero] {\n  background-image: none !important;\n}\n\n/* Surfaces */\n.card,\n.glass,\n.glass-strong,\n.glass-card,\n.bg-white,\n.bg-white\\/95,\n.bg-white\\/90,\n.bg-white\\/80,\n.bg-white\\/70,\n.bg-gray-50,\n.bg-gray-100,\n.bg-gray-800,\n.bg-neutral-50,\n.bg-neutral-100,\n.bg-neutral-800,\n.bg-slate-50,\n.bg-slate-100,\n.bg-slate-800,\n.bg-\\[\\#050510\\],\n.bg-\\[\\#080814\\],\n.bg-\\[\\#0b0b15\\],\n.bg-\\[\\#12121f\\],\n.bg-\\[\\#13131f\\],\n.bg-\\[\\#161628\\],\n.bg-\\[\\#171A23\\],\n[data-leaderboard-page],\n[data-testid=\"modal-dialog\"],\n[data-event-registration-modal],\n[data-college-profile] {\n  background-color: #171A23 !important;\n  border-color: #2A3042 !important;\n}\n\n.bg-black,\n.bg-\\[\\#020208\\],\n.bg-\\[\\#04050c\\],\n.bg-\\[\\#050508\\],\n.auth-page,\n.mlp-page {\n  background-color: #0F1117 !important;\n}\n\n.hover\\:bg-gray-50:hover,\n.hover\\:bg-gray-100:hover,\n.hover\\:bg-neutral-50:hover,\n.hover\\:bg-neutral-100:hover,\n.hover\\:bg-slate-50:hover,\n.hover\\:bg-slate-100:hover,\n.hover\\:bg-\\[\\#1E2230\\]:hover,\n[class*=\"hover:bg-\"]:hover {\n  background-color: #1E2230 !important;\n}\n\n/* Borders and dividers */\n.border,\n[class*=\"border-\"],\n[class*=\"divide-\"] > :not([hidden]) ~ :not([hidden]),\nhr,\ninput,\ntextarea,\nselect {\n  border-color: #2A3042 !important;\n}\n\n/* Text hierarchy */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.text-white,\n.text-neutral-950,\n.text-neutral-900,\n.text-neutral-800,\n.text-gray-950,\n.text-gray-900,\n.text-gray-800,\n.text-slate-950,\n.text-slate-900,\n.text-slate-800 {\n  color: #FFFFFF !important;\n}\n\np,\n.text-neutral-700,\n.text-neutral-600,\n.text-gray-700,\n.text-gray-600,\n.text-slate-700,\n.text-slate-600 {\n  color: #A1A8B8 !important;\n}\n\n.text-neutral-500,\n.text-neutral-400,\n.text-gray-500,\n.text-gray-400,\n.text-slate-500,\n.text-slate-400,\n.text-muted,\n.text-tertiary,\nsmall,\ntime {\n  color: #6B7280 !important;\n}\n\n/* Single accent color for every legacy category/status/brand class. */\n[class^=\"text-blue\"],\n[class*=\" text-blue\"],\n[class^=\"dark:text-blue\"],\n[class*=\" dark:text-blue\"],\n[class^=\"text-indigo\"],\n[class*=\" text-indigo\"],\n[class^=\"dark:text-indigo\"],\n[class*=\" dark:text-indigo\"],\n[class^=\"text-purple\"],\n[class*=\" text-purple\"],\n[class^=\"dark:text-purple\"],\n[class*=\" dark:text-purple\"],\n[class^=\"text-violet\"],\n[class*=\" text-violet\"],\n[class^=\"dark:text-violet\"],\n[class*=\" dark:text-violet\"],\n[class^=\"text-pink\"],\n[class*=\" text-pink\"],\n[class^=\"dark:text-pink\"],\n[class*=\" dark:text-pink\"],\n[class^=\"text-rose\"],\n[class*=\" text-rose\"],\n[class^=\"dark:text-rose\"],\n[class*=\" dark:text-rose\"],\n[class^=\"text-red\"],\n[class*=\" text-red\"],\n[class^=\"dark:text-red\"],\n[class*=\" dark:text-red\"],\n[class^=\"text-orange\"],\n[class*=\" text-orange\"],\n[class^=\"dark:text-orange\"],\n[class*=\" dark:text-orange\"],\n[class^=\"text-amber\"],\n[class*=\" text-amber\"],\n[class^=\"dark:text-amber\"],\n[class*=\" dark:text-amber\"],\n[class^=\"text-yellow\"],\n[class*=\" text-yellow\"],\n[class^=\"dark:text-yellow\"],\n[class*=\" dark:text-yellow\"],\n[class^=\"text-green\"],\n[class*=\" text-green\"],\n[class^=\"dark:text-green\"],\n[class*=\" dark:text-green\"],\n[class^=\"text-emerald\"],\n[class*=\" text-emerald\"],\n[class^=\"dark:text-emerald\"],\n[class*=\" dark:text-emerald\"],\n[class^=\"text-teal\"],\n[class*=\" text-teal\"],\n[class^=\"dark:text-teal\"],\n[class*=\" dark:text-teal\"],\n[class^=\"text-cyan\"],\n[class*=\" text-cyan\"],\n[class^=\"dark:text-cyan\"],\n[class*=\" dark:text-cyan\"],\n.link,\na {\n  color: #2563EB !important;\n}\n\n[class^=\"bg-blue\"],\n[class*=\" bg-blue\"],\n[class^=\"dark:bg-blue\"],\n[class*=\" dark:bg-blue\"],\n[class^=\"bg-indigo\"],\n[class*=\" bg-indigo\"],\n[class^=\"dark:bg-indigo\"],\n[class*=\" dark:bg-indigo\"],\n[class^=\"bg-purple\"],\n[class*=\" bg-purple\"],\n[class^=\"dark:bg-purple\"],\n[class*=\" dark:bg-purple\"],\n[class^=\"bg-violet\"],\n[class*=\" bg-violet\"],\n[class^=\"dark:bg-violet\"],\n[class*=\" dark:bg-violet\"],\n[class^=\"bg-pink\"],\n[class*=\" bg-pink\"],\n[class^=\"dark:bg-pink\"],\n[class*=\" dark:bg-pink\"],\n[class^=\"bg-rose\"],\n[class*=\" bg-rose\"],\n[class^=\"dark:bg-rose\"],\n[class*=\" dark:bg-rose\"],\n[class^=\"bg-red\"],\n[class*=\" bg-red\"],\n[class^=\"dark:bg-red\"],\n[class*=\" dark:bg-red\"],\n[class^=\"bg-orange\"],\n[class*=\" bg-orange\"],\n[class^=\"dark:bg-orange\"],\n[class*=\" dark:bg-orange\"],\n[class^=\"bg-amber\"],\n[class*=\" bg-amber\"],\n[class^=\"dark:bg-amber\"],\n[class*=\" dark:bg-amber\"],\n[class^=\"bg-yellow\"],\n[class*=\" bg-yellow\"],\n[class^=\"dark:bg-yellow\"],\n[class*=\" dark:bg-yellow\"],\n[class^=\"bg-green\"],\n[class*=\" bg-green\"],\n[class^=\"dark:bg-green\"],\n[class*=\" dark:bg-green\"],\n[class^=\"bg-emerald\"],\n[class*=\" bg-emerald\"],\n[class^=\"dark:bg-emerald\"],\n[class*=\" dark:bg-emerald\"],\n[class^=\"bg-teal\"],\n[class*=\" bg-teal\"],\n[class^=\"dark:bg-teal\"],\n[class*=\" dark:bg-teal\"],\n[class^=\"bg-cyan\"],\n[class*=\" bg-cyan\"],\n[class^=\"dark:bg-cyan\"],\n[class*=\" dark:bg-cyan\"],\n.badge-primary,\n.badge-success,\n.badge-warning,\n.badge-error,\n.badge-info,\n.btn-primary,\n.auth-submit,\n.auth-otp-submit,\n.landing-waitlist-submit,\n.landing-nav-cta,\n.fab {\n  background-color: rgba(37, 99, 235, 0.14) !important;\n  color: #93c5fd !important;\n  border-color: rgba(37, 99, 235, 0.32) !important;\n}\n\n[class^=\"bg-blue-500\"],\n[class*=\" bg-blue-500\"],\n[class^=\"bg-blue-600\"],\n[class*=\" bg-blue-600\"],\n[class^=\"bg-primary-500\"],\n[class*=\" bg-primary-500\"],\n[class^=\"bg-primary-600\"],\n[class*=\" bg-primary-600\"],\n[class^=\"bg-dashboard-500\"],\n[class*=\" bg-dashboard-500\"],\n[class^=\"bg-dashboard-600\"],\n[class*=\" bg-dashboard-600\"],\n[class^=\"bg-red-500\"],\n[class*=\" bg-red-500\"],\n[class^=\"bg-green-500\"],\n[class*=\" bg-green-500\"],\n[class^=\"bg-amber-500\"],\n[class*=\" bg-amber-500\"],\n.bg-\\[\\#2563EB\\],\n.bg-gradient-dashboard-primary,\n.badge-primary,\n.btn-primary,\n.auth-submit,\n.auth-otp-submit,\n.landing-waitlist-submit,\n.landing-nav-cta,\n.fab {\n  background-color: #2563EB !important;\n  color: #FFFFFF !important;\n  border-color: #2563EB !important;\n}\n\n.bg-gradient-dashboard-soft,\n.bg-gradient-dashboard-hero {\n  background-color: #1E2230 !important;\n  color: #FFFFFF !important;\n  border-color: #2A3042 !important;\n}\n\n[class*=\"hover:bg-blue\"]:hover,\n[class*=\"hover:bg-indigo\"]:hover,\n[class*=\"hover:bg-purple\"]:hover,\n[class*=\"hover:bg-violet\"]:hover,\n[class*=\"hover:bg-pink\"]:hover,\n[class*=\"hover:bg-rose\"]:hover,\n[class*=\"hover:bg-red\"]:hover,\n[class*=\"hover:bg-orange\"]:hover,\n[class*=\"hover:bg-amber\"]:hover,\n[class*=\"hover:bg-yellow\"]:hover,\n[class*=\"hover:bg-green\"]:hover,\n[class*=\"hover:bg-emerald\"]:hover,\n[class*=\"hover:bg-teal\"]:hover,\n[class*=\"hover:bg-cyan\"]:hover,\n.btn-primary:hover,\n.auth-submit:hover,\n.auth-otp-submit:hover,\n.landing-waitlist-submit:hover,\n.landing-nav-cta:hover,\n.fab:hover {\n  background-color: #1D4ED8 !important;\n  color: #FFFFFF !important;\n  border-color: #1D4ED8 !important;\n}\n\n[class^=\"border-blue\"],\n[class*=\" border-blue\"],\n[class^=\"dark:border-blue\"],\n[class*=\" dark:border-blue\"],\n[class^=\"border-indigo\"],\n[class*=\" border-indigo\"],\n[class^=\"dark:border-indigo\"],\n[class*=\" dark:border-indigo\"],\n[class^=\"border-purple\"],\n[class*=\" border-purple\"],\n[class^=\"dark:border-purple\"],\n[class*=\" dark:border-purple\"],\n[class^=\"border-violet\"],\n[class*=\" border-violet\"],\n[class^=\"dark:border-violet\"],\n[class*=\" dark:border-violet\"],\n[class^=\"border-pink\"],\n[class*=\" border-pink\"],\n[class^=\"dark:border-pink\"],\n[class*=\" dark:border-pink\"],\n[class^=\"border-rose\"],\n[class*=\" border-rose\"],\n[class^=\"dark:border-rose\"],\n[class*=\" dark:border-rose\"],\n[class^=\"border-red\"],\n[class*=\" border-red\"],\n[class^=\"dark:border-red\"],\n[class*=\" dark:border-red\"],\n[class^=\"border-orange\"],\n[class*=\" border-orange\"],\n[class^=\"dark:border-orange\"],\n[class*=\" dark:border-orange\"],\n[class^=\"border-amber\"],\n[class*=\" border-amber\"],\n[class^=\"dark:border-amber\"],\n[class*=\" dark:border-amber\"],\n[class^=\"border-yellow\"],\n[class*=\" border-yellow\"],\n[class^=\"dark:border-yellow\"],\n[class*=\" dark:border-yellow\"],\n[class^=\"border-green\"],\n[class*=\" border-green\"],\n[class^=\"dark:border-green\"],\n[class*=\" dark:border-green\"],\n[class^=\"border-emerald\"],\n[class*=\" border-emerald\"],\n[class^=\"dark:border-emerald\"],\n[class*=\" dark:border-emerald\"],\n[class^=\"border-teal\"],\n[class*=\" border-teal\"],\n[class^=\"dark:border-teal\"],\n[class*=\" dark:border-teal\"],\n[class^=\"border-cyan\"],\n[class*=\" border-cyan\"],\n[class^=\"dark:border-cyan\"],\n[class*=\" dark:border-cyan\"] {\n  border-color: #2563EB !important;\n}\n\n/* Inputs, selects, textareas */\ninput:not([type=\"checkbox\"]):not([type=\"radio\"]):not([type=\"file\"]),\ntextarea,\nselect,\n.input,\n.profile-field {\n  background-color: #171A23 !important;\n  border-color: #2A3042 !important;\n  color: #FFFFFF !important;\n}\n\n/* Auth fields — styled in auth.css; inner controls stay transparent inside wrap */\n.auth-page .auth-input-wrap .auth-input,\n.auth-page .auth-input-wrap .auth-select {\n  background-color: transparent !important;\n  border: none !important;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n  color: #6B7280 !important;\n}\n\n/* Buttons and interactive neutral actions */\nbutton,\n.btn,\n[role=\"button\"] {\n  border-color: #2A3042;\n}\n\n.btn-secondary,\n.btn-ghost,\n.auth-google-btn,\n.auth-mode-card,\n.auth-type-btn,\n.auth-otp-resend,\n.badge-secondary {\n  background-color: transparent !important;\n  color: #A1A8B8 !important;\n  border-color: #2A3042 !important;\n}\n\n.btn-secondary:hover,\n.btn-ghost:hover,\n.auth-google-btn:hover,\n.auth-mode-card:hover,\n.auth-type-btn:hover,\n.auth-type-btn--active,\n.auth-otp-resend:hover,\n[aria-selected=\"true\"],\n[data-active=\"true\"] {\n  background-color: #1E2230 !important;\n  color: #FFFFFF !important;\n  border-color: #2563EB !important;\n}\n\n/* Focus, selection, notification dots and icons */\n:focus-visible,\n.focus\\:ring-primary-500:focus,\n.focus\\:ring-blue-500:focus,\n.focus-visible\\:ring-primary-500:focus-visible,\n.focus-visible\\:ring-blue-500:focus-visible {\n  outline: none !important;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.35) !important;\n  --tw-ring-color: rgba(37, 99, 235, 0.45) !important;\n  --tw-ring-offset-color: #0F1117 !important;\n}\n\n::selection {\n  background-color: rgba(37, 99, 235, 0.32);\n  color: #FFFFFF;\n}\n\nsvg,\n.lucide,\n[class*=\"icon\"] {\n  color: currentColor;\n}\n\n.live-pulse-dot,\n.notification-dot,\n[class*=\"badge-dot\"],\n[class*=\"status-dot\"] {\n  background-color: #2563EB !important;\n  box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.45) !important;\n}\n\n/* Auth and landing decorative layers */\n.auth-page-ambient-blob,\n.auth-brand-glow,\n.auth-ambient-orb,\n.auth-orbit-dot,\n.mlp-page::before,\n.landing-whatsapp-icon,\n.landing-whatsapp-modal {\n  background: #171A23 !important;\n  background-image: none !important;\n  border-color: #2A3042 !important;\n  box-shadow: none !important;\n}\n\n.auth-shell-wrap {\n  background: #2A3042 !important;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.36) !important;\n}\n\n.auth-shell,\n.auth-brand,\n.auth-form-panel,\n.auth-otp-modal,\n.landing-waitlist-card,\n.landing-whatsapp-modal {\n  background: #171A23 !important;\n  border-color: #2A3042 !important;\n}\n\n.auth-error-banner,\n.auth-success-banner,\n.landing-waitlist-error {\n  background: rgba(37, 99, 235, 0.12) !important;\n  border-color: rgba(37, 99, 235, 0.32) !important;\n  color: #A1A8B8 !important;\n}\n\n/* Category cards and pastel panels should never keep multicolor fills. */\n[class*=\"from-\"][class*=\"-100\"],\n[class*=\"to-\"][class*=\"-100\"],\n[class*=\"via-\"][class*=\"-100\"],\n[class*=\"from-\"][class*=\"-200\"],\n[class*=\"to-\"][class*=\"-200\"],\n[class*=\"via-\"][class*=\"-200\"],\n[class*=\"evt-tint-\"] {\n  background-color: #171A23 !important;\n  background-image: none !important;\n  border-color: #2A3042 !important;\n}\n\n.message-highlight {\n  background-color: rgba(37, 99, 235, 0.12) !important;\n}\n\n.messaging-search-shell .messaging-search-input,\n.messaging-search-shell .messaging-search-input:focus,\n.messaging-search-shell .messaging-search-input:focus-visible {\n  background: transparent !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: 0 !important;\n  padding: 0 !important;\n  min-height: 0 !important;\n}\n\n/* College header search — no inner focus ring; highlight outer shell only */\n.college-header-search-input,\n.college-header-search-input:focus,\n.college-header-search-input:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n  --tw-ring-shadow: 0 0 #0000 !important;\n  --tw-ring-offset-shadow: 0 0 #0000 !important;\n}\n\n@media (max-width: 639px) {\n  .college-header-search-input {\n    border: none !important;\n    background: transparent !important;\n  }\n}\n\n.community-chat-input,\n.community-chat-input:focus,\n.community-chat-input:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n  border: none !important;\n  background-color: transparent !important;\n  background: transparent !important;\n  --tw-ring-shadow: 0 0 #0000 !important;\n  --tw-ring-offset-shadow: 0 0 #0000 !important;\n}\n\n/* Community hero — black fade for readable text (Tailwind bg-gradient-* is stripped in dark mode) */\n.community-hero-overlay {\n  background: linear-gradient(\n    to top,\n    rgba(0, 0, 0, 0.96) 0%,\n    rgba(0, 0, 0, 0.88) 22%,\n    rgba(0, 0, 0, 0.55) 50%,\n    rgba(0, 0, 0, 0.12) 78%,\n    rgba(0, 0, 0, 0) 100%\n  ) !important;\n  pointer-events: none;\n}\n\n/* Event share menu — keep dropdown items out of global button overrides */\n.event-share-menu,\n.event-share-menu * {\n  max-width: none !important;\n}\n\n.event-share-menu {\n  background-color: #ffffff !important;\n  border-color: #e5e7eb !important;\n  min-width: 288px !important;\n}\n\nhtml.dark .event-share-menu {\n  background-color: #161628 !important;\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.event-share-menu__item,\n.event-share-menu__item:hover,\n.event-share-menu__item:focus-visible {\n  display: flex !important;\n  flex-direction: row !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  width: 100% !important;\n  min-height: 2.75rem !important;\n  min-width: 0 !important;\n  background-color: transparent !important;\n  background-image: none !important;\n  border: 0 !important;\n  box-shadow: none !important;\n  text-align: left !important;\n  white-space: nowrap !important;\n  overflow: visible !important;\n}\n\n.event-share-menu__item span:last-child {\n  overflow: visible !important;\n  text-overflow: unset !important;\n  flex: 1 1 auto !important;\n}\n\nhtml.dark .event-share-menu__item {\n  color: rgba(255, 255, 255, 0.88) !important;\n}\n\nhtml.dark .event-share-menu__item:hover {\n  background-color: rgba(255, 255, 255, 0.06) !important;\n  color: #ffffff !important;\n}\n\n/* Event detail hero — square icon buttons (avoid global bg-white / stretch overrides) */\n.event-detail-hero-icon-btn,\n.event-detail-hero-share-btn {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  background-image: none !important;\n  border-color: rgba(255, 255, 255, 0.15) !important;\n  color: #ffffff !important;\n  box-shadow: none !important;\n}\n\n.event-detail-hero-icon-btn {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 2.25rem !important;\n  height: 2.25rem !important;\n  min-width: 2.25rem !important;\n  max-width: 2.25rem !important;\n  min-height: 2.25rem !important;\n  max-height: 2.25rem !important;\n  padding: 0 !important;\n  flex: 0 0 auto !important;\n}\n\n.event-detail-hero-icon-btn:hover,\n.event-detail-hero-share-btn:hover {\n  background-color: rgba(255, 255, 255, 0.18) !important;\n}\n\n/* Landing waitlist — preserve field shell + gradient submit on desktop landing */\n.dt-waitlist-card .landing-field,\n.dt-waitlist-form-shell .landing-field {\n  background-color: #0b0e14 !important;\n  border-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field,\n.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field {\n  flex: 1;\n  width: 100%;\n  min-width: 0;\n  background: transparent !important;\n  background-color: transparent !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n  appearance: none;\n  -webkit-appearance: none;\n}\n\n.dt-waitlist-card .landing-field select.landing-input.landing-input-in-field,\n.dt-waitlist-form-shell .landing-field select.landing-input.landing-input-in-field {\n  flex: 1;\n  width: 100%;\n  min-width: 0;\n  background-color: transparent !important;\n  border: none !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:focus,\n.dt-waitlist-card .landing-field select.landing-input.landing-input-in-field:focus,\n.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:focus-visible,\n.dt-waitlist-card .landing-field select.landing-input.landing-input-in-field:focus-visible,\n.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:focus,\n.dt-waitlist-form-shell .landing-field select.landing-input.landing-input-in-field:focus,\n.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:focus-visible,\n.dt-waitlist-form-shell .landing-field select.landing-input.landing-input-in-field:focus-visible {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:-webkit-autofill,\n.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:hover,\n.dt-waitlist-form-shell .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:focus,\n.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:-webkit-autofill,\n.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:hover,\n.dt-waitlist-card .landing-field input.landing-input.landing-input-in-field:-webkit-autofill:focus {\n  -webkit-box-shadow: 0 0 0 1000px #0b0e14 inset !important;\n  box-shadow: 0 0 0 1000px #0b0e14 inset !important;\n  -webkit-text-fill-color: #e1e2eb !important;\n  transition: background-color 99999s ease-out 0s;\n}\n\n.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-input-in-field,\n.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-select {\n  color: #e1e2eb !important;\n}\n\n.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-input-in-field::placeholder {\n  color: #6b7280 !important;\n}\n\n.dt-waitlist-form-shell .landing-waitlist-form--sheet .landing-select:invalid {\n  color: #6b7280 !important;\n}\n\n.dt-landing .landing-waitlist-submit,\n.dt-waitlist-card .landing-waitlist-submit,\n.dt-waitlist-form-shell .landing-waitlist-submit {\n  background: linear-gradient(135deg, #2f6bff 0%, #003cac 100%) !important;\n  background-image: linear-gradient(135deg, #2f6bff 0%, #003cac 100%) !important;\n  color: #ffffff !important;\n  border: none !important;\n  border-color: transparent !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
